export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  GenericScalar: any;
  JSONString: string;
  Metadata: any;
  UUID: any;
  Upload: any;
};



export type AcceptCareRecommendationMutation = {
  __typename?: 'AcceptCareRecommendationMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type AcceptContractsMutation = {
  __typename?: 'AcceptContractsMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum AccountDeviceOs {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type AccountDoesNotExist = {
  __typename?: 'AccountDoesNotExist';
  uuid: Scalars['UUID'];
};

export enum AccountInsuranceStatus {
  Eligible = 'ELIGIBLE',
  Incomplete = 'INCOMPLETE',
  NotEligible = 'NOT_ELIGIBLE'
}

export enum AccountLocalTimezone {
  AfricaAbidjan = 'AFRICA_ABIDJAN',
  AfricaAccra = 'AFRICA_ACCRA',
  AfricaAddisAbaba = 'AFRICA_ADDIS_ABABA',
  AfricaAlgiers = 'AFRICA_ALGIERS',
  AfricaAsmara = 'AFRICA_ASMARA',
  AfricaAsmera = 'AFRICA_ASMERA',
  AfricaBamako = 'AFRICA_BAMAKO',
  AfricaBangui = 'AFRICA_BANGUI',
  AfricaBanjul = 'AFRICA_BANJUL',
  AfricaBissau = 'AFRICA_BISSAU',
  AfricaBlantyre = 'AFRICA_BLANTYRE',
  AfricaBrazzaville = 'AFRICA_BRAZZAVILLE',
  AfricaBujumbura = 'AFRICA_BUJUMBURA',
  AfricaCairo = 'AFRICA_CAIRO',
  AfricaCasablanca = 'AFRICA_CASABLANCA',
  AfricaCeuta = 'AFRICA_CEUTA',
  AfricaConakry = 'AFRICA_CONAKRY',
  AfricaDakar = 'AFRICA_DAKAR',
  AfricaDarEsSalaam = 'AFRICA_DAR_ES_SALAAM',
  AfricaDjibouti = 'AFRICA_DJIBOUTI',
  AfricaDouala = 'AFRICA_DOUALA',
  AfricaElAaiun = 'AFRICA_EL_AAIUN',
  AfricaFreetown = 'AFRICA_FREETOWN',
  AfricaGaborone = 'AFRICA_GABORONE',
  AfricaHarare = 'AFRICA_HARARE',
  AfricaJohannesburg = 'AFRICA_JOHANNESBURG',
  AfricaJuba = 'AFRICA_JUBA',
  AfricaKampala = 'AFRICA_KAMPALA',
  AfricaKhartoum = 'AFRICA_KHARTOUM',
  AfricaKigali = 'AFRICA_KIGALI',
  AfricaKinshasa = 'AFRICA_KINSHASA',
  AfricaLagos = 'AFRICA_LAGOS',
  AfricaLibreville = 'AFRICA_LIBREVILLE',
  AfricaLome = 'AFRICA_LOME',
  AfricaLuanda = 'AFRICA_LUANDA',
  AfricaLubumbashi = 'AFRICA_LUBUMBASHI',
  AfricaLusaka = 'AFRICA_LUSAKA',
  AfricaMalabo = 'AFRICA_MALABO',
  AfricaMaputo = 'AFRICA_MAPUTO',
  AfricaMaseru = 'AFRICA_MASERU',
  AfricaMbabane = 'AFRICA_MBABANE',
  AfricaMogadishu = 'AFRICA_MOGADISHU',
  AfricaMonrovia = 'AFRICA_MONROVIA',
  AfricaNairobi = 'AFRICA_NAIROBI',
  AfricaNdjamena = 'AFRICA_NDJAMENA',
  AfricaNiamey = 'AFRICA_NIAMEY',
  AfricaNouakchott = 'AFRICA_NOUAKCHOTT',
  AfricaOuagadougou = 'AFRICA_OUAGADOUGOU',
  AfricaPortoNovo = 'AFRICA_PORTO_NOVO',
  AfricaSaoTome = 'AFRICA_SAO_TOME',
  AfricaTimbuktu = 'AFRICA_TIMBUKTU',
  AfricaTripoli = 'AFRICA_TRIPOLI',
  AfricaTunis = 'AFRICA_TUNIS',
  AfricaWindhoek = 'AFRICA_WINDHOEK',
  AmericaAdak = 'AMERICA_ADAK',
  AmericaAnchorage = 'AMERICA_ANCHORAGE',
  AmericaAnguilla = 'AMERICA_ANGUILLA',
  AmericaAntigua = 'AMERICA_ANTIGUA',
  AmericaAraguaina = 'AMERICA_ARAGUAINA',
  AmericaArgentinaBuenosAires = 'AMERICA_ARGENTINA_BUENOS_AIRES',
  AmericaArgentinaCatamarca = 'AMERICA_ARGENTINA_CATAMARCA',
  AmericaArgentinaComodrivadavia = 'AMERICA_ARGENTINA_COMODRIVADAVIA',
  AmericaArgentinaCordoba = 'AMERICA_ARGENTINA_CORDOBA',
  AmericaArgentinaJujuy = 'AMERICA_ARGENTINA_JUJUY',
  AmericaArgentinaLaRioja = 'AMERICA_ARGENTINA_LA_RIOJA',
  AmericaArgentinaMendoza = 'AMERICA_ARGENTINA_MENDOZA',
  AmericaArgentinaRioGallegos = 'AMERICA_ARGENTINA_RIO_GALLEGOS',
  AmericaArgentinaSalta = 'AMERICA_ARGENTINA_SALTA',
  AmericaArgentinaSanJuan = 'AMERICA_ARGENTINA_SAN_JUAN',
  AmericaArgentinaSanLuis = 'AMERICA_ARGENTINA_SAN_LUIS',
  AmericaArgentinaTucuman = 'AMERICA_ARGENTINA_TUCUMAN',
  AmericaArgentinaUshuaia = 'AMERICA_ARGENTINA_USHUAIA',
  AmericaAruba = 'AMERICA_ARUBA',
  AmericaAsuncion = 'AMERICA_ASUNCION',
  AmericaAtikokan = 'AMERICA_ATIKOKAN',
  AmericaAtka = 'AMERICA_ATKA',
  AmericaBahia = 'AMERICA_BAHIA',
  AmericaBahiaBanderas = 'AMERICA_BAHIA_BANDERAS',
  AmericaBarbados = 'AMERICA_BARBADOS',
  AmericaBelem = 'AMERICA_BELEM',
  AmericaBelize = 'AMERICA_BELIZE',
  AmericaBlancSablon = 'AMERICA_BLANC_SABLON',
  AmericaBoaVista = 'AMERICA_BOA_VISTA',
  AmericaBogota = 'AMERICA_BOGOTA',
  AmericaBoise = 'AMERICA_BOISE',
  AmericaBuenosAires = 'AMERICA_BUENOS_AIRES',
  AmericaCambridgeBay = 'AMERICA_CAMBRIDGE_BAY',
  AmericaCampoGrande = 'AMERICA_CAMPO_GRANDE',
  AmericaCancun = 'AMERICA_CANCUN',
  AmericaCaracas = 'AMERICA_CARACAS',
  AmericaCatamarca = 'AMERICA_CATAMARCA',
  AmericaCayenne = 'AMERICA_CAYENNE',
  AmericaCayman = 'AMERICA_CAYMAN',
  AmericaChicago = 'AMERICA_CHICAGO',
  AmericaChihuahua = 'AMERICA_CHIHUAHUA',
  AmericaCoralHarbour = 'AMERICA_CORAL_HARBOUR',
  AmericaCordoba = 'AMERICA_CORDOBA',
  AmericaCostaRica = 'AMERICA_COSTA_RICA',
  AmericaCreston = 'AMERICA_CRESTON',
  AmericaCuiaba = 'AMERICA_CUIABA',
  AmericaCuracao = 'AMERICA_CURACAO',
  AmericaDanmarkshavn = 'AMERICA_DANMARKSHAVN',
  AmericaDawson = 'AMERICA_DAWSON',
  AmericaDawsonCreek = 'AMERICA_DAWSON_CREEK',
  AmericaDenver = 'AMERICA_DENVER',
  AmericaDetroit = 'AMERICA_DETROIT',
  AmericaDominica = 'AMERICA_DOMINICA',
  AmericaEdmonton = 'AMERICA_EDMONTON',
  AmericaEirunepe = 'AMERICA_EIRUNEPE',
  AmericaElSalvador = 'AMERICA_EL_SALVADOR',
  AmericaEnsenada = 'AMERICA_ENSENADA',
  AmericaFortaleza = 'AMERICA_FORTALEZA',
  AmericaFortNelson = 'AMERICA_FORT_NELSON',
  AmericaFortWayne = 'AMERICA_FORT_WAYNE',
  AmericaGlaceBay = 'AMERICA_GLACE_BAY',
  AmericaGodthab = 'AMERICA_GODTHAB',
  AmericaGooseBay = 'AMERICA_GOOSE_BAY',
  AmericaGrandTurk = 'AMERICA_GRAND_TURK',
  AmericaGrenada = 'AMERICA_GRENADA',
  AmericaGuadeloupe = 'AMERICA_GUADELOUPE',
  AmericaGuatemala = 'AMERICA_GUATEMALA',
  AmericaGuayaquil = 'AMERICA_GUAYAQUIL',
  AmericaGuyana = 'AMERICA_GUYANA',
  AmericaHalifax = 'AMERICA_HALIFAX',
  AmericaHavana = 'AMERICA_HAVANA',
  AmericaHermosillo = 'AMERICA_HERMOSILLO',
  AmericaIndianapolis = 'AMERICA_INDIANAPOLIS',
  AmericaIndianaIndianapolis = 'AMERICA_INDIANA_INDIANAPOLIS',
  AmericaIndianaKnox = 'AMERICA_INDIANA_KNOX',
  AmericaIndianaMarengo = 'AMERICA_INDIANA_MARENGO',
  AmericaIndianaPetersburg = 'AMERICA_INDIANA_PETERSBURG',
  AmericaIndianaTellCity = 'AMERICA_INDIANA_TELL_CITY',
  AmericaIndianaVevay = 'AMERICA_INDIANA_VEVAY',
  AmericaIndianaVincennes = 'AMERICA_INDIANA_VINCENNES',
  AmericaIndianaWinamac = 'AMERICA_INDIANA_WINAMAC',
  AmericaInuvik = 'AMERICA_INUVIK',
  AmericaIqaluit = 'AMERICA_IQALUIT',
  AmericaJamaica = 'AMERICA_JAMAICA',
  AmericaJujuy = 'AMERICA_JUJUY',
  AmericaJuneau = 'AMERICA_JUNEAU',
  AmericaKentuckyLouisville = 'AMERICA_KENTUCKY_LOUISVILLE',
  AmericaKentuckyMonticello = 'AMERICA_KENTUCKY_MONTICELLO',
  AmericaKnoxIn = 'AMERICA_KNOX_IN',
  AmericaKralendijk = 'AMERICA_KRALENDIJK',
  AmericaLaPaz = 'AMERICA_LA_PAZ',
  AmericaLima = 'AMERICA_LIMA',
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  AmericaLouisville = 'AMERICA_LOUISVILLE',
  AmericaLowerPrinces = 'AMERICA_LOWER_PRINCES',
  AmericaMaceio = 'AMERICA_MACEIO',
  AmericaManagua = 'AMERICA_MANAGUA',
  AmericaManaus = 'AMERICA_MANAUS',
  AmericaMarigot = 'AMERICA_MARIGOT',
  AmericaMartinique = 'AMERICA_MARTINIQUE',
  AmericaMatamoros = 'AMERICA_MATAMOROS',
  AmericaMazatlan = 'AMERICA_MAZATLAN',
  AmericaMendoza = 'AMERICA_MENDOZA',
  AmericaMenominee = 'AMERICA_MENOMINEE',
  AmericaMerida = 'AMERICA_MERIDA',
  AmericaMetlakatla = 'AMERICA_METLAKATLA',
  AmericaMexicoCity = 'AMERICA_MEXICO_CITY',
  AmericaMiquelon = 'AMERICA_MIQUELON',
  AmericaMoncton = 'AMERICA_MONCTON',
  AmericaMonterrey = 'AMERICA_MONTERREY',
  AmericaMontevideo = 'AMERICA_MONTEVIDEO',
  AmericaMontreal = 'AMERICA_MONTREAL',
  AmericaMontserrat = 'AMERICA_MONTSERRAT',
  AmericaNassau = 'AMERICA_NASSAU',
  AmericaNewYork = 'AMERICA_NEW_YORK',
  AmericaNipigon = 'AMERICA_NIPIGON',
  AmericaNome = 'AMERICA_NOME',
  AmericaNoronha = 'AMERICA_NORONHA',
  AmericaNorthDakotaBeulah = 'AMERICA_NORTH_DAKOTA_BEULAH',
  AmericaNorthDakotaCenter = 'AMERICA_NORTH_DAKOTA_CENTER',
  AmericaNorthDakotaNewSalem = 'AMERICA_NORTH_DAKOTA_NEW_SALEM',
  AmericaNuuk = 'AMERICA_NUUK',
  AmericaOjinaga = 'AMERICA_OJINAGA',
  AmericaPanama = 'AMERICA_PANAMA',
  AmericaPangnirtung = 'AMERICA_PANGNIRTUNG',
  AmericaParamaribo = 'AMERICA_PARAMARIBO',
  AmericaPhoenix = 'AMERICA_PHOENIX',
  AmericaPortoAcre = 'AMERICA_PORTO_ACRE',
  AmericaPortoVelho = 'AMERICA_PORTO_VELHO',
  AmericaPortAuPrince = 'AMERICA_PORT_AU_PRINCE',
  AmericaPortOfSpain = 'AMERICA_PORT_OF_SPAIN',
  AmericaPuertoRico = 'AMERICA_PUERTO_RICO',
  AmericaPuntaArenas = 'AMERICA_PUNTA_ARENAS',
  AmericaRainyRiver = 'AMERICA_RAINY_RIVER',
  AmericaRankinInlet = 'AMERICA_RANKIN_INLET',
  AmericaRecife = 'AMERICA_RECIFE',
  AmericaRegina = 'AMERICA_REGINA',
  AmericaResolute = 'AMERICA_RESOLUTE',
  AmericaRioBranco = 'AMERICA_RIO_BRANCO',
  AmericaRosario = 'AMERICA_ROSARIO',
  AmericaSantarem = 'AMERICA_SANTAREM',
  AmericaSantaIsabel = 'AMERICA_SANTA_ISABEL',
  AmericaSantiago = 'AMERICA_SANTIAGO',
  AmericaSantoDomingo = 'AMERICA_SANTO_DOMINGO',
  AmericaSaoPaulo = 'AMERICA_SAO_PAULO',
  AmericaScoresbysund = 'AMERICA_SCORESBYSUND',
  AmericaShiprock = 'AMERICA_SHIPROCK',
  AmericaSitka = 'AMERICA_SITKA',
  AmericaStBarthelemy = 'AMERICA_ST_BARTHELEMY',
  AmericaStJohns = 'AMERICA_ST_JOHNS',
  AmericaStKitts = 'AMERICA_ST_KITTS',
  AmericaStLucia = 'AMERICA_ST_LUCIA',
  AmericaStThomas = 'AMERICA_ST_THOMAS',
  AmericaStVincent = 'AMERICA_ST_VINCENT',
  AmericaSwiftCurrent = 'AMERICA_SWIFT_CURRENT',
  AmericaTegucigalpa = 'AMERICA_TEGUCIGALPA',
  AmericaThule = 'AMERICA_THULE',
  AmericaThunderBay = 'AMERICA_THUNDER_BAY',
  AmericaTijuana = 'AMERICA_TIJUANA',
  AmericaToronto = 'AMERICA_TORONTO',
  AmericaTortola = 'AMERICA_TORTOLA',
  AmericaVancouver = 'AMERICA_VANCOUVER',
  AmericaVirgin = 'AMERICA_VIRGIN',
  AmericaWhitehorse = 'AMERICA_WHITEHORSE',
  AmericaWinnipeg = 'AMERICA_WINNIPEG',
  AmericaYakutat = 'AMERICA_YAKUTAT',
  AmericaYellowknife = 'AMERICA_YELLOWKNIFE',
  AntarcticaCasey = 'ANTARCTICA_CASEY',
  AntarcticaDavis = 'ANTARCTICA_DAVIS',
  AntarcticaDumontdurville = 'ANTARCTICA_DUMONTDURVILLE',
  AntarcticaMacquarie = 'ANTARCTICA_MACQUARIE',
  AntarcticaMawson = 'ANTARCTICA_MAWSON',
  AntarcticaMcmurdo = 'ANTARCTICA_MCMURDO',
  AntarcticaPalmer = 'ANTARCTICA_PALMER',
  AntarcticaRothera = 'ANTARCTICA_ROTHERA',
  AntarcticaSouthPole = 'ANTARCTICA_SOUTH_POLE',
  AntarcticaSyowa = 'ANTARCTICA_SYOWA',
  AntarcticaTroll = 'ANTARCTICA_TROLL',
  AntarcticaVostok = 'ANTARCTICA_VOSTOK',
  ArcticLongyearbyen = 'ARCTIC_LONGYEARBYEN',
  AsiaAden = 'ASIA_ADEN',
  AsiaAlmaty = 'ASIA_ALMATY',
  AsiaAmman = 'ASIA_AMMAN',
  AsiaAnadyr = 'ASIA_ANADYR',
  AsiaAqtau = 'ASIA_AQTAU',
  AsiaAqtobe = 'ASIA_AQTOBE',
  AsiaAshgabat = 'ASIA_ASHGABAT',
  AsiaAshkhabad = 'ASIA_ASHKHABAD',
  AsiaAtyrau = 'ASIA_ATYRAU',
  AsiaBaghdad = 'ASIA_BAGHDAD',
  AsiaBahrain = 'ASIA_BAHRAIN',
  AsiaBaku = 'ASIA_BAKU',
  AsiaBangkok = 'ASIA_BANGKOK',
  AsiaBarnaul = 'ASIA_BARNAUL',
  AsiaBeirut = 'ASIA_BEIRUT',
  AsiaBishkek = 'ASIA_BISHKEK',
  AsiaBrunei = 'ASIA_BRUNEI',
  AsiaCalcutta = 'ASIA_CALCUTTA',
  AsiaChita = 'ASIA_CHITA',
  AsiaChoibalsan = 'ASIA_CHOIBALSAN',
  AsiaChongqing = 'ASIA_CHONGQING',
  AsiaChungking = 'ASIA_CHUNGKING',
  AsiaColombo = 'ASIA_COLOMBO',
  AsiaDacca = 'ASIA_DACCA',
  AsiaDamascus = 'ASIA_DAMASCUS',
  AsiaDhaka = 'ASIA_DHAKA',
  AsiaDili = 'ASIA_DILI',
  AsiaDubai = 'ASIA_DUBAI',
  AsiaDushanbe = 'ASIA_DUSHANBE',
  AsiaFamagusta = 'ASIA_FAMAGUSTA',
  AsiaGaza = 'ASIA_GAZA',
  AsiaHarbin = 'ASIA_HARBIN',
  AsiaHebron = 'ASIA_HEBRON',
  AsiaHongKong = 'ASIA_HONG_KONG',
  AsiaHovd = 'ASIA_HOVD',
  AsiaHoChiMinh = 'ASIA_HO_CHI_MINH',
  AsiaIrkutsk = 'ASIA_IRKUTSK',
  AsiaIstanbul = 'ASIA_ISTANBUL',
  AsiaJakarta = 'ASIA_JAKARTA',
  AsiaJayapura = 'ASIA_JAYAPURA',
  AsiaJerusalem = 'ASIA_JERUSALEM',
  AsiaKabul = 'ASIA_KABUL',
  AsiaKamchatka = 'ASIA_KAMCHATKA',
  AsiaKarachi = 'ASIA_KARACHI',
  AsiaKashgar = 'ASIA_KASHGAR',
  AsiaKathmandu = 'ASIA_KATHMANDU',
  AsiaKatmandu = 'ASIA_KATMANDU',
  AsiaKhandyga = 'ASIA_KHANDYGA',
  AsiaKolkata = 'ASIA_KOLKATA',
  AsiaKrasnoyarsk = 'ASIA_KRASNOYARSK',
  AsiaKualaLumpur = 'ASIA_KUALA_LUMPUR',
  AsiaKuching = 'ASIA_KUCHING',
  AsiaKuwait = 'ASIA_KUWAIT',
  AsiaMacao = 'ASIA_MACAO',
  AsiaMacau = 'ASIA_MACAU',
  AsiaMagadan = 'ASIA_MAGADAN',
  AsiaMakassar = 'ASIA_MAKASSAR',
  AsiaManila = 'ASIA_MANILA',
  AsiaMuscat = 'ASIA_MUSCAT',
  AsiaNicosia = 'ASIA_NICOSIA',
  AsiaNovokuznetsk = 'ASIA_NOVOKUZNETSK',
  AsiaNovosibirsk = 'ASIA_NOVOSIBIRSK',
  AsiaOmsk = 'ASIA_OMSK',
  AsiaOral = 'ASIA_ORAL',
  AsiaPhnomPenh = 'ASIA_PHNOM_PENH',
  AsiaPontianak = 'ASIA_PONTIANAK',
  AsiaPyongyang = 'ASIA_PYONGYANG',
  AsiaQatar = 'ASIA_QATAR',
  AsiaQostanay = 'ASIA_QOSTANAY',
  AsiaQyzylorda = 'ASIA_QYZYLORDA',
  AsiaRangoon = 'ASIA_RANGOON',
  AsiaRiyadh = 'ASIA_RIYADH',
  AsiaSaigon = 'ASIA_SAIGON',
  AsiaSakhalin = 'ASIA_SAKHALIN',
  AsiaSamarkand = 'ASIA_SAMARKAND',
  AsiaSeoul = 'ASIA_SEOUL',
  AsiaShanghai = 'ASIA_SHANGHAI',
  AsiaSingapore = 'ASIA_SINGAPORE',
  AsiaSrednekolymsk = 'ASIA_SREDNEKOLYMSK',
  AsiaTaipei = 'ASIA_TAIPEI',
  AsiaTashkent = 'ASIA_TASHKENT',
  AsiaTbilisi = 'ASIA_TBILISI',
  AsiaTehran = 'ASIA_TEHRAN',
  AsiaTelAviv = 'ASIA_TEL_AVIV',
  AsiaThimbu = 'ASIA_THIMBU',
  AsiaThimphu = 'ASIA_THIMPHU',
  AsiaTokyo = 'ASIA_TOKYO',
  AsiaTomsk = 'ASIA_TOMSK',
  AsiaUjungPandang = 'ASIA_UJUNG_PANDANG',
  AsiaUlaanbaatar = 'ASIA_ULAANBAATAR',
  AsiaUlanBator = 'ASIA_ULAN_BATOR',
  AsiaUrumqi = 'ASIA_URUMQI',
  AsiaUstNera = 'ASIA_UST_NERA',
  AsiaVientiane = 'ASIA_VIENTIANE',
  AsiaVladivostok = 'ASIA_VLADIVOSTOK',
  AsiaYakutsk = 'ASIA_YAKUTSK',
  AsiaYangon = 'ASIA_YANGON',
  AsiaYekaterinburg = 'ASIA_YEKATERINBURG',
  AsiaYerevan = 'ASIA_YEREVAN',
  AtlanticAzores = 'ATLANTIC_AZORES',
  AtlanticBermuda = 'ATLANTIC_BERMUDA',
  AtlanticCanary = 'ATLANTIC_CANARY',
  AtlanticCapeVerde = 'ATLANTIC_CAPE_VERDE',
  AtlanticFaeroe = 'ATLANTIC_FAEROE',
  AtlanticFaroe = 'ATLANTIC_FAROE',
  AtlanticJanMayen = 'ATLANTIC_JAN_MAYEN',
  AtlanticMadeira = 'ATLANTIC_MADEIRA',
  AtlanticReykjavik = 'ATLANTIC_REYKJAVIK',
  AtlanticSouthGeorgia = 'ATLANTIC_SOUTH_GEORGIA',
  AtlanticStanley = 'ATLANTIC_STANLEY',
  AtlanticStHelena = 'ATLANTIC_ST_HELENA',
  AustraliaAct = 'AUSTRALIA_ACT',
  AustraliaAdelaide = 'AUSTRALIA_ADELAIDE',
  AustraliaBrisbane = 'AUSTRALIA_BRISBANE',
  AustraliaBrokenHill = 'AUSTRALIA_BROKEN_HILL',
  AustraliaCanberra = 'AUSTRALIA_CANBERRA',
  AustraliaCurrie = 'AUSTRALIA_CURRIE',
  AustraliaDarwin = 'AUSTRALIA_DARWIN',
  AustraliaEucla = 'AUSTRALIA_EUCLA',
  AustraliaHobart = 'AUSTRALIA_HOBART',
  AustraliaLhi = 'AUSTRALIA_LHI',
  AustraliaLindeman = 'AUSTRALIA_LINDEMAN',
  AustraliaLordHowe = 'AUSTRALIA_LORD_HOWE',
  AustraliaMelbourne = 'AUSTRALIA_MELBOURNE',
  AustraliaNorth = 'AUSTRALIA_NORTH',
  AustraliaNsw = 'AUSTRALIA_NSW',
  AustraliaPerth = 'AUSTRALIA_PERTH',
  AustraliaQueensland = 'AUSTRALIA_QUEENSLAND',
  AustraliaSouth = 'AUSTRALIA_SOUTH',
  AustraliaSydney = 'AUSTRALIA_SYDNEY',
  AustraliaTasmania = 'AUSTRALIA_TASMANIA',
  AustraliaVictoria = 'AUSTRALIA_VICTORIA',
  AustraliaWest = 'AUSTRALIA_WEST',
  AustraliaYancowinna = 'AUSTRALIA_YANCOWINNA',
  A = 'A_',
  BrazilAcre = 'BRAZIL_ACRE',
  BrazilDenoronha = 'BRAZIL_DENORONHA',
  BrazilEast = 'BRAZIL_EAST',
  BrazilWest = 'BRAZIL_WEST',
  CanadaAtlantic = 'CANADA_ATLANTIC',
  CanadaCentral = 'CANADA_CENTRAL',
  CanadaEastern = 'CANADA_EASTERN',
  CanadaMountain = 'CANADA_MOUNTAIN',
  CanadaNewfoundland = 'CANADA_NEWFOUNDLAND',
  CanadaPacific = 'CANADA_PACIFIC',
  CanadaSaskatchewan = 'CANADA_SASKATCHEWAN',
  CanadaYukon = 'CANADA_YUKON',
  Cet = 'CET',
  ChileContinental = 'CHILE_CONTINENTAL',
  ChileEasterisland = 'CHILE_EASTERISLAND',
  Cst6Cdt = 'CST6CDT',
  Cuba = 'CUBA',
  Eet = 'EET',
  Egypt = 'EGYPT',
  Eire = 'EIRE',
  Est = 'EST',
  Est5Edt = 'EST5EDT',
  EtcGmt = 'ETC_GMT',
  EtcGmt0 = 'ETC_GMT0',
  EtcGmt_0 = 'ETC_GMT_0',
  EtcGmt_0_405 = 'ETC_GMT_0_405',
  EtcGmt_1 = 'ETC_GMT_1',
  EtcGmt_1_406 = 'ETC_GMT_1_406',
  EtcGmt_2 = 'ETC_GMT_2',
  EtcGmt_2_412 = 'ETC_GMT_2_412',
  EtcGmt_3 = 'ETC_GMT_3',
  EtcGmt_3_413 = 'ETC_GMT_3_413',
  EtcGmt_4 = 'ETC_GMT_4',
  EtcGmt_4_414 = 'ETC_GMT_4_414',
  EtcGmt_5 = 'ETC_GMT_5',
  EtcGmt_5_415 = 'ETC_GMT_5_415',
  EtcGmt_6 = 'ETC_GMT_6',
  EtcGmt_6_416 = 'ETC_GMT_6_416',
  EtcGmt_7 = 'ETC_GMT_7',
  EtcGmt_7_417 = 'ETC_GMT_7_417',
  EtcGmt_8 = 'ETC_GMT_8',
  EtcGmt_8_418 = 'ETC_GMT_8_418',
  EtcGmt_9 = 'ETC_GMT_9',
  EtcGmt_9_419 = 'ETC_GMT_9_419',
  EtcGmt_10 = 'ETC_GMT_10',
  EtcGmt_10_407 = 'ETC_GMT_10_407',
  EtcGmt_11 = 'ETC_GMT_11',
  EtcGmt_11_408 = 'ETC_GMT_11_408',
  EtcGmt_12 = 'ETC_GMT_12',
  EtcGmt_12_409 = 'ETC_GMT_12_409',
  EtcGmt_13 = 'ETC_GMT_13',
  EtcGmt_14 = 'ETC_GMT_14',
  EtcGreenwich = 'ETC_GREENWICH',
  EtcUct = 'ETC_UCT',
  EtcUniversal = 'ETC_UNIVERSAL',
  EtcUtc = 'ETC_UTC',
  EtcZulu = 'ETC_ZULU',
  EuropeAmsterdam = 'EUROPE_AMSTERDAM',
  EuropeAndorra = 'EUROPE_ANDORRA',
  EuropeAstrakhan = 'EUROPE_ASTRAKHAN',
  EuropeAthens = 'EUROPE_ATHENS',
  EuropeBelfast = 'EUROPE_BELFAST',
  EuropeBelgrade = 'EUROPE_BELGRADE',
  EuropeBerlin = 'EUROPE_BERLIN',
  EuropeBratislava = 'EUROPE_BRATISLAVA',
  EuropeBrussels = 'EUROPE_BRUSSELS',
  EuropeBucharest = 'EUROPE_BUCHAREST',
  EuropeBudapest = 'EUROPE_BUDAPEST',
  EuropeBusingen = 'EUROPE_BUSINGEN',
  EuropeChisinau = 'EUROPE_CHISINAU',
  EuropeCopenhagen = 'EUROPE_COPENHAGEN',
  EuropeDublin = 'EUROPE_DUBLIN',
  EuropeGibraltar = 'EUROPE_GIBRALTAR',
  EuropeGuernsey = 'EUROPE_GUERNSEY',
  EuropeHelsinki = 'EUROPE_HELSINKI',
  EuropeIsleOfMan = 'EUROPE_ISLE_OF_MAN',
  EuropeIstanbul = 'EUROPE_ISTANBUL',
  EuropeJersey = 'EUROPE_JERSEY',
  EuropeKaliningrad = 'EUROPE_KALININGRAD',
  EuropeKiev = 'EUROPE_KIEV',
  EuropeKirov = 'EUROPE_KIROV',
  EuropeLisbon = 'EUROPE_LISBON',
  EuropeLjubljana = 'EUROPE_LJUBLJANA',
  EuropeLondon = 'EUROPE_LONDON',
  EuropeLuxembourg = 'EUROPE_LUXEMBOURG',
  EuropeMadrid = 'EUROPE_MADRID',
  EuropeMalta = 'EUROPE_MALTA',
  EuropeMariehamn = 'EUROPE_MARIEHAMN',
  EuropeMinsk = 'EUROPE_MINSK',
  EuropeMonaco = 'EUROPE_MONACO',
  EuropeMoscow = 'EUROPE_MOSCOW',
  EuropeNicosia = 'EUROPE_NICOSIA',
  EuropeOslo = 'EUROPE_OSLO',
  EuropeParis = 'EUROPE_PARIS',
  EuropePodgorica = 'EUROPE_PODGORICA',
  EuropePrague = 'EUROPE_PRAGUE',
  EuropeRiga = 'EUROPE_RIGA',
  EuropeRome = 'EUROPE_ROME',
  EuropeSamara = 'EUROPE_SAMARA',
  EuropeSanMarino = 'EUROPE_SAN_MARINO',
  EuropeSarajevo = 'EUROPE_SARAJEVO',
  EuropeSaratov = 'EUROPE_SARATOV',
  EuropeSimferopol = 'EUROPE_SIMFEROPOL',
  EuropeSkopje = 'EUROPE_SKOPJE',
  EuropeSofia = 'EUROPE_SOFIA',
  EuropeStockholm = 'EUROPE_STOCKHOLM',
  EuropeTallinn = 'EUROPE_TALLINN',
  EuropeTirane = 'EUROPE_TIRANE',
  EuropeTiraspol = 'EUROPE_TIRASPOL',
  EuropeUlyanovsk = 'EUROPE_ULYANOVSK',
  EuropeUzhgorod = 'EUROPE_UZHGOROD',
  EuropeVaduz = 'EUROPE_VADUZ',
  EuropeVatican = 'EUROPE_VATICAN',
  EuropeVienna = 'EUROPE_VIENNA',
  EuropeVilnius = 'EUROPE_VILNIUS',
  EuropeVolgograd = 'EUROPE_VOLGOGRAD',
  EuropeWarsaw = 'EUROPE_WARSAW',
  EuropeZagreb = 'EUROPE_ZAGREB',
  EuropeZaporozhye = 'EUROPE_ZAPOROZHYE',
  EuropeZurich = 'EUROPE_ZURICH',
  Gb = 'GB',
  GbEire = 'GB_EIRE',
  Gmt = 'GMT',
  Gmt0 = 'GMT0',
  Gmt_0 = 'GMT_0',
  Gmt_0_493 = 'GMT_0_493',
  Greenwich = 'GREENWICH',
  Hongkong = 'HONGKONG',
  Hst = 'HST',
  Iceland = 'ICELAND',
  IndianAntananarivo = 'INDIAN_ANTANANARIVO',
  IndianChagos = 'INDIAN_CHAGOS',
  IndianChristmas = 'INDIAN_CHRISTMAS',
  IndianCocos = 'INDIAN_COCOS',
  IndianComoro = 'INDIAN_COMORO',
  IndianKerguelen = 'INDIAN_KERGUELEN',
  IndianMahe = 'INDIAN_MAHE',
  IndianMaldives = 'INDIAN_MALDIVES',
  IndianMauritius = 'INDIAN_MAURITIUS',
  IndianMayotte = 'INDIAN_MAYOTTE',
  IndianReunion = 'INDIAN_REUNION',
  Iran = 'IRAN',
  Israel = 'ISRAEL',
  Jamaica = 'JAMAICA',
  Japan = 'JAPAN',
  Kwajalein = 'KWAJALEIN',
  Libya = 'LIBYA',
  Met = 'MET',
  MexicoBajanorte = 'MEXICO_BAJANORTE',
  MexicoBajasur = 'MEXICO_BAJASUR',
  MexicoGeneral = 'MEXICO_GENERAL',
  Mst = 'MST',
  Mst7Mdt = 'MST7MDT',
  Navajo = 'NAVAJO',
  Nz = 'NZ',
  NzChat = 'NZ_CHAT',
  PacificApia = 'PACIFIC_APIA',
  PacificAuckland = 'PACIFIC_AUCKLAND',
  PacificBougainville = 'PACIFIC_BOUGAINVILLE',
  PacificChatham = 'PACIFIC_CHATHAM',
  PacificChuuk = 'PACIFIC_CHUUK',
  PacificEaster = 'PACIFIC_EASTER',
  PacificEfate = 'PACIFIC_EFATE',
  PacificEnderbury = 'PACIFIC_ENDERBURY',
  PacificFakaofo = 'PACIFIC_FAKAOFO',
  PacificFiji = 'PACIFIC_FIJI',
  PacificFunafuti = 'PACIFIC_FUNAFUTI',
  PacificGalapagos = 'PACIFIC_GALAPAGOS',
  PacificGambier = 'PACIFIC_GAMBIER',
  PacificGuadalcanal = 'PACIFIC_GUADALCANAL',
  PacificGuam = 'PACIFIC_GUAM',
  PacificHonolulu = 'PACIFIC_HONOLULU',
  PacificJohnston = 'PACIFIC_JOHNSTON',
  PacificKanton = 'PACIFIC_KANTON',
  PacificKiritimati = 'PACIFIC_KIRITIMATI',
  PacificKosrae = 'PACIFIC_KOSRAE',
  PacificKwajalein = 'PACIFIC_KWAJALEIN',
  PacificMajuro = 'PACIFIC_MAJURO',
  PacificMarquesas = 'PACIFIC_MARQUESAS',
  PacificMidway = 'PACIFIC_MIDWAY',
  PacificNauru = 'PACIFIC_NAURU',
  PacificNiue = 'PACIFIC_NIUE',
  PacificNorfolk = 'PACIFIC_NORFOLK',
  PacificNoumea = 'PACIFIC_NOUMEA',
  PacificPagoPago = 'PACIFIC_PAGO_PAGO',
  PacificPalau = 'PACIFIC_PALAU',
  PacificPitcairn = 'PACIFIC_PITCAIRN',
  PacificPohnpei = 'PACIFIC_POHNPEI',
  PacificPonape = 'PACIFIC_PONAPE',
  PacificPortMoresby = 'PACIFIC_PORT_MORESBY',
  PacificRarotonga = 'PACIFIC_RAROTONGA',
  PacificSaipan = 'PACIFIC_SAIPAN',
  PacificSamoa = 'PACIFIC_SAMOA',
  PacificTahiti = 'PACIFIC_TAHITI',
  PacificTarawa = 'PACIFIC_TARAWA',
  PacificTongatapu = 'PACIFIC_TONGATAPU',
  PacificTruk = 'PACIFIC_TRUK',
  PacificWake = 'PACIFIC_WAKE',
  PacificWallis = 'PACIFIC_WALLIS',
  PacificYap = 'PACIFIC_YAP',
  Poland = 'POLAND',
  Portugal = 'PORTUGAL',
  Prc = 'PRC',
  Pst8Pdt = 'PST8PDT',
  Roc = 'ROC',
  Rok = 'ROK',
  Singapore = 'SINGAPORE',
  Turkey = 'TURKEY',
  Uct = 'UCT',
  Universal = 'UNIVERSAL',
  UsAlaska = 'US_ALASKA',
  UsAleutian = 'US_ALEUTIAN',
  UsArizona = 'US_ARIZONA',
  UsCentral = 'US_CENTRAL',
  UsEastern = 'US_EASTERN',
  UsEastIndiana = 'US_EAST_INDIANA',
  UsHawaii = 'US_HAWAII',
  UsIndianaStarke = 'US_INDIANA_STARKE',
  UsMichigan = 'US_MICHIGAN',
  UsMountain = 'US_MOUNTAIN',
  UsPacific = 'US_PACIFIC',
  UsSamoa = 'US_SAMOA',
  Utc = 'UTC',
  Wet = 'WET',
  WSu = 'W_SU',
  Zulu = 'ZULU'
}

export enum AccountOnboardingStatus {
  Active = 'ACTIVE',
  Deprovisioned = 'DEPROVISIONED',
  Eligible = 'ELIGIBLE',
  Ineligible = 'INELIGIBLE',
  Unmatchable = 'UNMATCHABLE'
}

export enum AccountProviderSchedulingType {
  Calendar = 'CALENDAR',
  MaximumMembers = 'MAXIMUM_MEMBERS',
  NotSet = 'NOT_SET',
  Roster = 'ROSTER'
}

export enum AccountProviderType {
  Coach = 'COACH',
  Psychiatrist = 'PSYCHIATRIST',
  Therapist = 'THERAPIST'
}

export enum AccountPsychiatristSubtype {
  PrimaryCarePhysician = 'PRIMARY_CARE_PHYSICIAN',
  PsychiatricNursePractitioner = 'PSYCHIATRIC_NURSE_PRACTITIONER',
  Psychiatrist = 'PSYCHIATRIST'
}

export enum AccountRegistrationSource {
  DependentInvitation = 'DEPENDENT_INVITATION',
  MagicLink = 'MAGIC_LINK',
  OrganicRegistration = 'ORGANIC_REGISTRATION',
  ScimProvisioning = 'SCIM_PROVISIONING',
  SingleSignOn = 'SINGLE_SIGN_ON'
}

export enum AccountRole {
  Coach = 'COACH',
  GroupPractice = 'GROUP_PRACTICE',
  Member = 'MEMBER',
  PowerUser = 'POWER_USER',
  SystemAdministrator = 'SYSTEM_ADMINISTRATOR'
}

export type AccountSharedPreferencesRecordNode = {
  __typename?: 'AccountSharedPreferencesRecordNode';
  createdAt: Scalars['DateTime'];
  key: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
  value: Scalars['String'];
};

export type ActivityDoesNotExist = {
  __typename?: 'ActivityDoesNotExist';
  id?: Maybe<Scalars['String']>;
};

export type ActivityGroupDoesNotExist = {
  __typename?: 'ActivityGroupDoesNotExist';
  id?: Maybe<Scalars['String']>;
};

export type AddCareNavigationRequestMutation = {
  __typename?: 'AddCareNavigationRequestMutation';
  careNavigationRequest?: Maybe<CareNavigationRequestNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AddCoachMutation = {
  __typename?: 'AddCoachMutation';
  coachAssignment?: Maybe<CoachAssignmentNode>;
};

export type AddLanguageResponseType = {
  __typename?: 'AddLanguageResponseType';
  error?: Maybe<Scalars['String']>;
  language?: Maybe<LanguageNode>;
  ok: Scalars['Boolean'];
};

export type AddMemberCarePreferenceMutation = {
  __typename?: 'AddMemberCarePreferenceMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type AddNoteMutation = {
  __typename?: 'AddNoteMutation';
  note?: Maybe<NoteNode>;
};

export type AddSymptomsExperiencedMutation = {
  __typename?: 'AddSymptomsExperiencedMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type AddTranslationKeyResponseType = {
  __typename?: 'AddTranslationKeyResponseType';
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
  translationKey?: Maybe<TranslationKeyNode>;
};

export type AddTranslationResponseType = {
  __typename?: 'AddTranslationResponseType';
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
  translation?: Maybe<TranslationNode>;
};

export type AddUpdateCompanyFeatureMutation = {
  __typename?: 'AddUpdateCompanyFeatureMutation';
  feature?: Maybe<CompanyFeatureNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type AllCompaniesOutput = AllCompaniesSuccessResponse | InternalToolPermissionDeniedError;

export type AllCompaniesSuccessResponse = {
  __typename?: 'AllCompaniesSuccessResponse';
  companies?: Maybe<Array<Maybe<LaunchOpsCompanyNode>>>;
};

export type AllCompanyAdditionalBenefitNode = Node & {
  __typename?: 'AllCompanyAdditionalBenefitNode';
  availableForDependents: Scalars['Boolean'];
  benefitId?: Maybe<Scalars['String']>;
  color?: Maybe<Scalars['String']>;
  companies?: Maybe<Array<Maybe<CompanyNode>>>;
  countries: Array<CountryNode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isModernHealthAddOn: Scalars['Boolean'];
  link: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  segments: Array<CompanySegmentNode>;
  source?: Maybe<CompanyAdditionalBenefitSource>;
  startDate?: Maybe<Scalars['Date']>;
  states?: Maybe<Array<Scalars['String']>>;
  subtopicOfFocus?: Maybe<SubtopicOfFocusNode>;
  title: Scalars['String'];
  topics: Array<TopicOfFocusNode>;
  uuid: Scalars['UUID'];
};

export type AllCompanyAdditionalBenefitNodeConnection = {
  __typename?: 'AllCompanyAdditionalBenefitNodeConnection';
  edgeCount?: Maybe<Scalars['Int']>;
  edges: Array<Maybe<AllCompanyAdditionalBenefitNodeEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AllCompanyAdditionalBenefitNodeEdge = {
  __typename?: 'AllCompanyAdditionalBenefitNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<AllCompanyAdditionalBenefitNode>;
};

export type AllCompanyAdditionalBenefitOutput = AllCompanyAdditionalBenefitSuccessResponse | InternalToolPermissionDeniedError;

export type AllCompanyAdditionalBenefitSuccessResponse = {
  __typename?: 'AllCompanyAdditionalBenefitSuccessResponse';
  companyAdditionalBenefits?: Maybe<AllCompanyAdditionalBenefitNodeConnection>;
};


export type AllCompanyAdditionalBenefitSuccessResponseCompanyAdditionalBenefitsArgs = {
  after?: Maybe<Scalars['String']>;
  availableForDependents?: Maybe<Scalars['Boolean']>;
  before?: Maybe<Scalars['String']>;
  benefitId?: Maybe<Scalars['String']>;
  companyUuid?: Maybe<Scalars['UUID']>;
  countryId?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  isModernHealthAddOn?: Maybe<Scalars['Boolean']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
  q?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  subtopicOfFocusUuid?: Maybe<Scalars['UUID']>;
  topicOfFocusUuid?: Maybe<Scalars['UUID']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type AllCompanyFeaturesOutput = AllCompanyFeaturesResponse | InternalToolPermissionDeniedError;

export type AllCompanyFeaturesResponse = {
  __typename?: 'AllCompanyFeaturesResponse';
  features?: Maybe<Array<Maybe<CompanyFeatureNode>>>;
};

export type AllContentLanguagesOutput = AllContentLanguagesSuccessResponse | InternalToolPermissionDeniedError;

export type AllContentLanguagesSuccessResponse = {
  __typename?: 'AllContentLanguagesSuccessResponse';
  contentLanguages?: Maybe<Array<Maybe<ContentLanguageNode>>>;
};

export type AllContentTagCategoriesResponse = {
  __typename?: 'AllContentTagCategoriesResponse';
  contentTagCategories?: Maybe<Array<Maybe<ContentTagCategoryNode>>>;
};

export type AllContentTagCategoryOutput = AllContentTagCategoriesResponse | InternalToolPermissionDeniedError;

export type AllContentTagRelationsOutput = AllContentTagRelationsResponse | InternalToolPermissionDeniedError;

export type AllContentTagRelationsResponse = {
  __typename?: 'AllContentTagRelationsResponse';
  contentTagRelations?: Maybe<ContentTagRelationNodeConnection>;
};


export type AllContentTagRelationsResponseContentTagRelationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  contentTagId?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  objectId?: Maybe<Scalars['String']>;
  objectType?: Maybe<Scalars['String']>;
};

export type AllContentTagsOutput = AllContentTagsResponse | InternalToolPermissionDeniedError;

export type AllContentTagsResponse = {
  __typename?: 'AllContentTagsResponse';
  contentTags?: Maybe<Array<Maybe<ContentTagNode>>>;
};

export type AllContentTranslationAvailabilitiesOutput = AllContentTranslationAvailabilitiesSuccessResponse | InternalToolPermissionDeniedError;

export type AllContentTranslationAvailabilitiesSuccessResponse = {
  __typename?: 'AllContentTranslationAvailabilitiesSuccessResponse';
  contentTranslationAvailabilities?: Maybe<Array<Maybe<ContentTranslationAvailabilityNode>>>;
};

export type AllContentUuidsOutput = InternalToolPermissionDeniedError | InvalidEnvironmentError | SyncUuidsSuccessResponse;

export type AllCourseGuidesOutput = AllGuidesResponse | InternalToolPermissionDeniedError;

export type AllCourseHeroesOutput = AllCourseHeroesSuccessResponse | InternalToolPermissionDeniedError;

export type AllCourseHeroesSuccessResponse = {
  __typename?: 'AllCourseHeroesSuccessResponse';
  courseHeroes?: Maybe<Array<Maybe<CourseHeroNode>>>;
};

export type AllGuidesResponse = {
  __typename?: 'AllGuidesResponse';
  courseGuides?: Maybe<Array<Maybe<CourseGuideNode>>>;
};

export type AllHrAdminRolesOutput = AllHrAdminRolesResponse | InternalToolPermissionDeniedError;

export type AllHrAdminRolesResponse = {
  __typename?: 'AllHRAdminRolesResponse';
  hrAdminRoles?: Maybe<Array<Maybe<HrAdminRoleNode>>>;
};

export type AllHrAdminsOutput = AllHrAdminsResponse | InternalToolPermissionDeniedError;

export type AllHrAdminsResponse = {
  __typename?: 'AllHRAdminsResponse';
  hrAdmins?: Maybe<Array<Maybe<HrAdminNode>>>;
};

export type AllHrEventsOutput = AllHrEventsResponse | InternalToolPermissionDeniedError;

export type AllHrEventsResponse = {
  __typename?: 'AllHREventsResponse';
  hrEvents?: Maybe<Array<Maybe<HrEventNode>>>;
};

export type AllHrResourcesOutput = AllHrResourcesResponse | InternalToolPermissionDeniedError;

export type AllHrResourcesResponse = {
  __typename?: 'AllHRResourcesResponse';
  hrResources?: Maybe<Array<Maybe<HrResourceNode>>>;
};

export type AllMediaTypesOutput = AllMediaTypesSuccessResponse | InternalToolPermissionDeniedError;

export type AllMediaTypesSuccessResponse = {
  __typename?: 'AllMediaTypesSuccessResponse';
  mediaTypes?: Maybe<Array<Maybe<MediaTypeNode>>>;
};

export type AllProvidersOutput = AllProvidersSuccessResponse | InternalToolPermissionDeniedError;

export type AllProvidersSuccessResponse = {
  __typename?: 'AllProvidersSuccessResponse';
  providers?: Maybe<Array<Maybe<CoachNode>>>;
};

export type AllScheduledContentOutput = AllScheduledContentResponse | InternalToolPermissionDeniedError;

export type AllScheduledContentResponse = {
  __typename?: 'AllScheduledContentResponse';
  scheduledContent?: Maybe<Array<Maybe<ScheduledContentNode>>>;
};

export type AllScreensOutput = AllScreensSuccessResponse | InternalToolPermissionDeniedError;

export type AllScreensSuccessResponse = {
  __typename?: 'AllScreensSuccessResponse';
  screens?: Maybe<Array<Maybe<GenericScreenNode>>>;
};

export type AllVideoContentOutput = AllVideoContentSuccessResponse | InternalToolPermissionDeniedError;

export type AllVideoContentSuccessResponse = {
  __typename?: 'AllVideoContentSuccessResponse';
  videoContent?: Maybe<Array<Maybe<VideoContentNode>>>;
};

export type AnswerCustomOptions = {
  __typename?: 'AnswerCustomOptions';
  buttonText?: Maybe<Scalars['String']>;
  placeholder?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AnswerOption = {
  __typename?: 'AnswerOption';
  customOptionValue?: Maybe<Scalars['String']>;
  customOptions?: Maybe<AnswerCustomOptions>;
  isSelected?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

export type AssessmentActivityNode = {
  __typename?: 'AssessmentActivityNode';
  assessment?: Maybe<AssessmentNode>;
  contentResponses?: Maybe<ContentResponsesNode>;
  isCompleted?: Maybe<Scalars['Boolean']>;
};

export type AssessmentAnswerNode = {
  __typename?: 'AssessmentAnswerNode';
  answerOrder: Scalars['Int'];
  answerText: Scalars['String'];
  answerTextDe?: Maybe<Scalars['String']>;
  answerTextEnUs?: Maybe<Scalars['String']>;
  answerTextEs?: Maybe<Scalars['String']>;
  answerTextFr?: Maybe<Scalars['String']>;
  answerTextFrCa?: Maybe<Scalars['String']>;
  answerTextHi?: Maybe<Scalars['String']>;
  answerTextIt?: Maybe<Scalars['String']>;
  answerTextJa?: Maybe<Scalars['String']>;
  answerTextKo?: Maybe<Scalars['String']>;
  answerTextMy?: Maybe<Scalars['String']>;
  answerTextPl?: Maybe<Scalars['String']>;
  answerTextPt?: Maybe<Scalars['String']>;
  answerTextZhHans?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  questions: Array<AssessmentQuestionNode>;
  uuid: Scalars['UUID'];
  value: Scalars['Int'];
};

export type AssessmentDetailNode = Node & {
  __typename?: 'AssessmentDetailNode';
  assessmentDescription: Scalars['String'];
  assessmentTitle: Scalars['String'];
  assessmentType: Scalars['String'];
  color: Scalars['String'];
  date: Scalars['String'];
  id: Scalars['ID'];
  responses: Array<Maybe<AssessmentResponseNode>>;
  score: Scalars['Int'];
  shouldShowPhq9Q9WarningToProvider?: Maybe<Scalars['Boolean']>;
};

export type AssessmentFlowNode = {
  __typename?: 'AssessmentFlowNode';
  careRecommendation?: Maybe<CareRecommendationNode>;
  member: MemberNode;
  startedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export enum AssessmentJourneyCreationSource {
  Courses = 'COURSES',
  Email = 'EMAIL',
  HomePage = 'HOME_PAGE',
  InitialOnboarding = 'INITIAL_ONBOARDING',
  LegacyProgram = 'LEGACY_PROGRAM',
  MemberWebSettings = 'MEMBER_WEB_SETTINGS',
  PreSession = 'PRE_SESSION',
  PushNotification = 'PUSH_NOTIFICATION',
  Retriage = 'RETRIAGE'
}

export type AssessmentJourneyNode = {
  __typename?: 'AssessmentJourneyNode';
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export enum AssessmentKey {
  Burnout = 'BURNOUT',
  EmploymentHealth = 'EMPLOYMENT_HEALTH',
  EmploymentHealthV2 = 'EMPLOYMENT_HEALTH_V2',
  Gad2 = 'GAD2',
  Gad7 = 'GAD7',
  Gad7Remainder = 'GAD7_REMAINDER',
  ManagerEssentials = 'MANAGER_ESSENTIALS',
  Phq2 = 'PHQ2',
  Phq8 = 'PHQ8',
  Phq8Remainder = 'PHQ8_REMAINDER',
  Phq9 = 'PHQ9',
  Phq9Remainder = 'PHQ9_REMAINDER',
  Who5 = 'WHO5'
}

export type AssessmentLinkNode = Node & {
  __typename?: 'AssessmentLinkNode';
  assessment: AssessmentNode;
  banner?: Maybe<ContentBannerNode>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  mediaType?: Maybe<MediaTypeNode>;
  mobileValue?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type AssessmentNode = {
  __typename?: 'AssessmentNode';
  assessmentQuestions: Array<AssessmentQuestionNode>;
  calculation: Scalars['String'];
  createdAt: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  englishOnlyHeaderText?: Maybe<Scalars['String']>;
  headerText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mandatory: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  questions?: Maybe<Scalars['JSONString']>;
  resources?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt: Scalars['DateTime'];
};

export type AssessmentOverviewDataNode = Node & {
  __typename?: 'AssessmentOverviewDataNode';
  assessmentFlowUuid: Scalars['UUID'];
  color: Scalars['String'];
  date: Scalars['String'];
  id: Scalars['ID'];
  score: Scalars['Int'];
};

export type AssessmentOverviewNode = Node & {
  __typename?: 'AssessmentOverviewNode';
  assessmentDescription: Scalars['String'];
  assessmentTitle: Scalars['String'];
  assessmentType: Scalars['String'];
  data: Array<Maybe<AssessmentOverviewDataNode>>;
  id: Scalars['ID'];
};

export type AssessmentQuestionNode = {
  __typename?: 'AssessmentQuestionNode';
  calloutText?: Maybe<Scalars['String']>;
  displayCrisisWarning: Scalars['Boolean'];
  id: Scalars['ID'];
  optional: Scalars['Boolean'];
  questionKey: Scalars['String'];
  questionOrder: Scalars['Int'];
  questionText: Scalars['String'];
  responseType: Array<AssessmentAnswerNode>;
  uuid: Scalars['UUID'];
};

export type AssessmentResponseNode = Node & {
  __typename?: 'AssessmentResponseNode';
  answer: Scalars['String'];
  id: Scalars['ID'];
  prompt: Scalars['String'];
  score: Scalars['Int'];
};

export type AvailableHourInput = {
  day: Scalars['String'];
  end: Scalars['String'];
  start: Scalars['String'];
};

export type AvailableHourNode = {
  __typename?: 'AvailableHourNode';
  day?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['String']>;
};

export type AvailablePeriodNode = {
  __typename?: 'AvailablePeriodNode';
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type AvailableReportType = {
  __typename?: 'AvailableReportType';
  dashboardId: Scalars['String'];
  iconUrl?: Maybe<Scalars['String']>;
  lookerUrl: Scalars['String'];
  lookerUrlTtl: Scalars['Int'];
  reportOrSectionEnum: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AvailableSectionType = {
  __typename?: 'AvailableSectionType';
  reportOrSectionEnum: Scalars['String'];
  reports: Array<Maybe<PossibleReportType>>;
  title: Scalars['String'];
};

export type BaseError = {
  debug?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type BaseSurveyError = {
  debug: Scalars['String'];
  message: Scalars['String'];
};

export type BenefitByTopicInput = {
  benefitId: Scalars['ID'];
  topicId: Scalars['ID'];
};

export type BenefitFeatureInput = {
  benefitsByTopic: Array<BenefitByTopicInput>;
};

export type BenefitNode = {
  __typename?: 'BenefitNode';
  id: Scalars['ID'];
  score: Scalars['Float'];
  topic: Scalars['ID'];
};

export type BenefitUnitNode = {
  __typename?: 'BenefitUnitNode';
  contents?: Maybe<Array<BenefitNode>>;
  modelMetadata: ModelMetadataNode;
};

export type BypassAssessmentsMutation = {
  __typename?: 'BypassAssessmentsMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type CalendarAuthLinkNode = {
  __typename?: 'CalendarAuthLinkNode';
  alreadyConnected?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};

export type CalendarEventNode = {
  __typename?: 'CalendarEventNode';
  description?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Scalars['String']>;
  recurrence?: Maybe<CalendarEventRecurFrequency>;
  startDate: Scalars['DateTime'];
  timezone?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum CalendarEventRecurFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type CalendarNode = {
  __typename?: 'CalendarNode';
  calendarName: Scalars['String'];
  calendarProfile: CalendarProfileNode;
  createdAt: Scalars['DateTime'];
  isActive: Scalars['Boolean'];
  isReadonly: Scalars['Boolean'];
  isTarget: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type CalendarProfileNode = {
  __typename?: 'CalendarProfileNode';
  calendars: Array<CalendarNode>;
  createdAt: Scalars['DateTime'];
  profileId: Scalars['String'];
  profileName: Scalars['String'];
  providerName: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type CancelEventMutation = {
  __typename?: 'CancelEventMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CancelMemberPathwayMutationInput = {
  pathwayUuid: Scalars['UUID'];
};

export type CancelMemberPathwayMutationResponse = {
  __typename?: 'CancelMemberPathwayMutationResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CancelledSessionDoesNotExist = {
  __typename?: 'CancelledSessionDoesNotExist';
  coachingVisitUuidDoesNotExist?: Maybe<Scalars['UUID']>;
};

export type CancelledSessionReviewInput = {
  coachingVisitUuid: Scalars['UUID'];
  otherText?: Maybe<Scalars['String']>;
  reasons: Array<Maybe<Scalars['String']>>;
};

export type CancelledSessionReviewOutput = CancelledSessionDoesNotExist | CancelledSessionReviewResponse;

export type CancelledSessionReviewResponse = {
  __typename?: 'CancelledSessionReviewResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum CareNavigationRequestContactPreference {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type CareNavigationRequestNode = {
  __typename?: 'CareNavigationRequestNode';
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  contactPreference: Scalars['String'];
  createdAt: Scalars['DateTime'];
  inAppConsent?: Maybe<Scalars['Boolean']>;
  isClinical?: Maybe<Scalars['Boolean']>;
  member: MemberNode;
  message?: Maybe<Scalars['String']>;
  platform: Scalars['String'];
  source?: Maybe<Scalars['String']>;
  subtopicsOfFocus: Array<SubtopicOfFocusNode>;
  topic?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  zendeskLink?: Maybe<Scalars['String']>;
  zendeskTicketId?: Maybe<Scalars['String']>;
};

export enum CareNavigationRequestSource {
  BenefitsPage = 'BENEFITS_PAGE',
  CareOptions = 'CARE_OPTIONS',
  ContactUs = 'CONTACT_US',
  WellbeingReport = 'WELLBEING_REPORT'
}

export enum CareNavigationRequestTopic {
  CompanyBenefits = 'COMPANY_BENEFITS',
  NavigatingMh = 'NAVIGATING_MH',
  OneOnOneCare = 'ONE_ON_ONE_CARE',
  Other = 'OTHER',
  TopicsOfFocus = 'TOPICS_OF_FOCUS'
}

export enum CareOption {
  Circles = 'CIRCLES',
  Coaching = 'COACHING',
  Courses = 'COURSES',
  DigitalPrograms = 'DIGITAL_PROGRAMS',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING',
  Therapy = 'THERAPY'
}

export enum CareRecommendationClinicalRecommendation {
  Coaching = 'COACHING',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING',
  Therapy = 'THERAPY'
}

export enum CareRecommendationModality {
  OneOnOne = 'ONE_ON_ONE',
  OnMyOwn = 'ON_MY_OWN',
  Unspecified = 'UNSPECIFIED',
  WithASmallGroup = 'WITH_A_SMALL_GROUP'
}

export enum CareRecommendationModalityPreference {
  OneOnOne = 'ONE_ON_ONE',
  OnMyOwn = 'ON_MY_OWN',
  Unspecified = 'UNSPECIFIED',
  WithASmallGroup = 'WITH_A_SMALL_GROUP'
}

export type CareRecommendationNode = {
  __typename?: 'CareRecommendationNode';
  acceptedAt?: Maybe<Scalars['DateTime']>;
  calculatedUsingContentResponses?: Maybe<ContentResponsesNode>;
  clinicalRecommendation?: Maybe<CareRecommendationClinicalRecommendation>;
  member: MemberNode;
  modalityPreference?: Maybe<CareRecommendationModalityPreference>;
  onboarding: Scalars['Boolean'];
  outcome?: Maybe<CareRecommendationOutcome>;
  recommendation?: Maybe<CareRecommendationRecommendation>;
  recommendationLogicVersion?: Maybe<Scalars['String']>;
  recommendedAt?: Maybe<Scalars['DateTime']>;
  startedAt: Scalars['DateTime'];
  state: CareRecommendationState;
  topicSelections: Array<TopicSelectionNode>;
  uuid: Scalars['UUID'];
};

export enum CareRecommendationOutcome {
  Circles = 'CIRCLES',
  Coaching = 'COACHING',
  Courses = 'COURSES',
  DigitalPrograms = 'DIGITAL_PROGRAMS',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING',
  Therapy = 'THERAPY'
}

export enum CareRecommendationRecommendation {
  Circles = 'CIRCLES',
  Coaching = 'COACHING',
  Courses = 'COURSES',
  DigitalPrograms = 'DIGITAL_PROGRAMS',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING',
  Therapy = 'THERAPY'
}

export enum CareRecommendationState {
  Accepted = 'ACCEPTED',
  AssessmentsCompleted = 'ASSESSMENTS_COMPLETED',
  BypassedAssessments = 'BYPASSED_ASSESSMENTS',
  DifficultySelected = 'DIFFICULTY_SELECTED',
  ModalitySelected = 'MODALITY_SELECTED',
  PrimaryFocusSelected = 'PRIMARY_FOCUS_SELECTED',
  Recommended = 'RECOMMENDED',
  Started = 'STARTED',
  SymptomsSelected = 'SYMPTOMS_SELECTED',
  TopicsSelected = 'TOPICS_SELECTED'
}

export type CareRecommendationsForMembersOutput = CareRecommendationsResponse | InternalToolPermissionDeniedError;

export type CareRecommendationsResponse = {
  __typename?: 'CareRecommendationsResponse';
  careRecommendations?: Maybe<Array<Maybe<CareRecommendationNode>>>;
};

export type CertificationNode = {
  __typename?: 'CertificationNode';
  certificationRequirements: Array<CertificationRequirementNode>;
  name: Scalars['String'];
  uuid: Scalars['UUID'];
};

export enum CertificationRequirementCareOption {
  Circles = 'CIRCLES',
  Coaching = 'COACHING',
  Courses = 'COURSES',
  DigitalPrograms = 'DIGITAL_PROGRAMS',
  MentalHealthCoaching = 'MENTAL_HEALTH_COACHING',
  Therapy = 'THERAPY'
}

export type CertificationRequirementNode = {
  __typename?: 'CertificationRequirementNode';
  careOption: CertificationRequirementCareOption;
  certification: CertificationNode;
  description: Scalars['String'];
  isActive: Scalars['Boolean'];
  uuid: Scalars['UUID'];
};

export type ChangeAccountTopicsOutput = ChangeAccountTopicsResponse | SubtopicOfFocusDoesNotExist | TopicSelectionTypeInvalid;

export type ChangeAccountTopicsResponse = {
  __typename?: 'ChangeAccountTopicsResponse';
  debug?: Maybe<Scalars['String']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type ChangeTopicsInput = {
  selectionType: Scalars['String'];
  subtopicUuids: Array<Maybe<Scalars['UUID']>>;
};

export type CheckEligibilityInput = {
  insurance: CheckInsuranceInput;
  member: CheckMemberInput;
};

export type CheckEligibilityResponse = {
  __typename?: 'CheckEligibilityResponse';
  ineligibleReason?: Maybe<IneligibleReason>;
  ok: Scalars['Boolean'];
};

export type CheckInsuranceInput = {
  employerInsurance: Scalars['Int'];
  policyMemberId: Scalars['String'];
  policyNumber: Scalars['String'];
  primaryFirstName?: Maybe<Scalars['String']>;
  primaryLastName?: Maybe<Scalars['String']>;
  relationshipCode: Scalars['String'];
};

export type CheckMemberInput = {
  address: Scalars['String'];
  addressTwo?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  dateOfBirth: Scalars['DateTime'];
  firstName: Scalars['String'];
  gender: Scalars['String'];
  lastName: Scalars['String'];
  postalCode: Scalars['String'];
  state: Scalars['String'];
};

export type ChooseProviderMutation = {
  __typename?: 'ChooseProviderMutation';
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
};

export type CircleAdminCreateBooleanQuestionMutationResponse = CircleBooleanQuestionDefinitionNode | CirclePermissionDeniedError;

export type CircleAdminCreateFacilitatorMutationResponse = CircleFacilitatorNode | CirclePermissionDeniedError;

export type CircleAdminCreateFeaturedItemMutationResponse = CircleFeaturedItemNode | CircleNotFoundError | CirclePermissionDeniedError | CircleValidationError;

export type CircleAdminCreateFreeResponseQuestionMutationResponse = CircleFreeResponseQuestionDefinitionNode | CirclePermissionDeniedError;

export type CircleAdminCreateMultipleChoiceQuestionMutationResponse = CircleMultipleChoiceQuestionDefinitionNode | CirclePermissionDeniedError;

export type CircleAdminCreateOnDemandTopicMutationResponse = CircleNotFoundError | CircleOnDemandNode | CirclePermissionDeniedError | CircleValidationError;

export type CircleAdminCreateRsvpQuestionTopicDataInput = {
  displayOrder: Scalars['Int'];
  questionId: Scalars['ID'];
  topicId: Scalars['ID'];
};

export type CircleAdminCreateRsvpQuestionTopicMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleRsvpQuestionTopicNode | CircleValidationError;

export type CircleAdminCreateSegmentedScaleQuestionMutationResponse = CirclePermissionDeniedError | CircleSegmentedScaleQuestionDefinitionNode;

export type CircleAdminCreateSeriesMutationResponse = CirclePermissionDeniedError | CircleSeriesNode | CircleValidationError;

export type CircleAdminCreateSessionMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleSessionNode | CircleValidationError;

export type CircleAdminCreateShortResponseQuestionMutationResponse = CirclePermissionDeniedError | CircleShortResponseQuestionDefinitionNode;

export type CircleAdminCreateTopicMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleTopicNode | CircleValidationError;

export type CircleAdminDeleteFeaturedItemMutationResponse = CircleDeleteSuccessful | CircleNotFoundError | CirclePermissionDeniedError;

export type CircleAdminDeleteRsvpQuestionTopicMutationResponse = CircleDeleteSuccessful | CircleNotFoundError | CirclePermissionDeniedError;

export type CircleAdminFacilitatorCollectionResponse = CircleFacilitatorCollection | CirclePermissionDeniedError;

export type CircleAdminFeaturedItemCollectionResponse = CircleFeaturedItemCollection | CirclePermissionDeniedError;

export type CircleAdminOnDemandTopicQueryResponse = CircleNotFoundError | CircleOnDemandNode | CirclePermissionDeniedError;

export type CircleAdminRsvpQuestionDefinitionsResponse = CirclePermissionDeniedError | CircleRsvpQuestionDefinitionCollection;

export type CircleAdminScheduledTaskConnectionResponse = CirclePermissionDeniedError | CircleScheduledTaskConnection | CircleValidationError;

export type CircleAdminScheduledTaskListInput = {
  taskState: Scalars['String'];
};

export type CircleAdminScheduledTasksCollection = {
  __typename?: 'CircleAdminScheduledTasksCollection';
  items: Array<CircleScheduledTaskNode>;
  totalCount: Scalars['Int'];
};

export type CircleAdminUpdateFacilitatorMutationResponse = CircleFacilitatorNode | CircleNotFoundError | CirclePermissionDeniedError;

export type CircleAdminUpdateOnDemandTopicMutationResponse = CircleNotFoundError | CircleOnDemandNode | CirclePermissionDeniedError | CircleValidationError;

export type CircleAdminUpdateSeriesMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleSeriesNode | CircleValidationError;

export type CircleAdminUpdateSessionMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleSessionNode | CircleValidationError;

export type CircleAdminUpdateTopicMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleTopicNode | CircleValidationError;

/** An answer option in a dropdown question */
export type CircleAnswerDropdownOptionNode = Node & {
  __typename?: 'CircleAnswerDropdownOptionNode';
  id: Scalars['ID'];
  optionText: Scalars['String'];
};

export type CircleAnswerMultipleChoiceDefinitionNode = Node & {
  __typename?: 'CircleAnswerMultipleChoiceDefinitionNode';
  id: Scalars['ID'];
  optionText: Scalars['String'];
};

/** An answer option in a radio group question */
export type CircleAnswerRadioOptionNode = Node & {
  __typename?: 'CircleAnswerRadioOptionNode';
  id: Scalars['ID'];
  optionText: Scalars['String'];
};

export type CircleAnswerSegmentedScaleDefinitionNode = Node & {
  __typename?: 'CircleAnswerSegmentedScaleDefinitionNode';
  id: Scalars['ID'];
  optionText: Scalars['String'];
  optionValue: Scalars['Int'];
};

export type CircleBaseQuestion = {
  id: Scalars['ID'];
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

/**
 * A question definition representing a "boolean question", or one
 * with only a True/False answer
 */
export type CircleBooleanQuestionDefinitionNode = CircleQuestionDefinitionNode & {
  __typename?: 'CircleBooleanQuestionDefinitionNode';
  id: Scalars['ID'];
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleCalendarLinks = {
  __typename?: 'CircleCalendarLinks';
  /** Add to Google Calendar link */
  google?: Maybe<Scalars['String']>;
  /**
   * Download ICS link
   *
   * The link returned is formatted as /circles/rsvp/<uuid>/ics-download,
   * the site must support this relative URL redirecting to the
   * backend
   */
  ics?: Maybe<Scalars['String']>;
  /** Add to Outlook (Online) link */
  outlook?: Maybe<Scalars['String']>;
};

export type CircleCalendarLinksByRsvpQueryResponse = CircleCalendarLinks | CircleNotFoundError | CircleValidationError;

export type CircleCancelAuthenticatedRsvpMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleRsvpCancellationSuccessful | CircleSessionAlreadyStartedError | CircleValidationError;

export type CircleCancelUnauthenticatedRsvpMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleRsvpCancellationSuccessful | CircleSessionAlreadyStartedError;

/**
 * A question representing a boolean checkbox, if this
 * question is required that indicates the checkbox must
 * be checked prior to submission.
 */
export type CircleCheckboxQuestionNode = CircleBaseQuestion & {
  __typename?: 'CircleCheckboxQuestionNode';
  id: Scalars['ID'];
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleCircleTopicLinkNode = Node & {
  __typename?: 'CircleCircleTopicLinkNode';
  circleTopic?: Maybe<CircleTopicNode>;
  id: Scalars['ID'];
};

export type CircleCompanyRsvpUnauthenticatedUserInfoInput = {
  email: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
};

/** Components to render Circles content with */
export enum CircleContentCollectionRenderComponent {
  Grid = 'GRID',
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export type CircleContentLinkNode = CircleCircleTopicLinkNode | CircleLanguageLinkNode | CircleOnDemandLinkNode;

export type CircleCreateAuthenticatedRsvpDataInput = {
  rsvpQuestionAnswers?: Maybe<Array<CircleRsvpQuestionAnswerInput>>;
  sessionId: Scalars['ID'];
};

export type CircleCreateAuthenticatedRsvpMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleProcessingError | CircleRsvpForSessionExistsForUserError | CircleRsvpSuccessful | CircleSessionAlreadyStartedError | CircleSessionSeatLimitExceededError | CircleValidationError;

/** Defines a boolean response question */
export type CircleCreateBooleanQuestionDataInput = {
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

/** CircleCreateFacilitatorDataInput input used for adminCreateFacilitator mutation */
export type CircleCreateFacilitatorDataInput = {
  bio?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  photoUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

/** CircleCreateFeaturedItemDataInput input used for adminCreateFeaturedItem mutation */
export type CircleCreateFeaturedItemDataInput = {
  displayOrder: Scalars['Int'];
  id: Scalars['ID'];
};

/** Defines a free response question */
export type CircleCreateFreeResponseQuestionDataInput = {
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleCreateItemFeedbackInput = {
  freeText?: Maybe<Scalars['String']>;
  itemId: Scalars['ID'];
  labels?: Maybe<Array<Scalars['String']>>;
  rating: Scalars['Int'];
  type: CircleItemFeedbackType;
};

export type CircleCreateItemFeedbackMutationResponse = CircleCreateItemFeedbackSuccessful | CircleNotFoundError | CirclePermissionDeniedError | CircleValidationError;

export type CircleCreateItemFeedbackSuccessful = {
  __typename?: 'CircleCreateItemFeedbackSuccessful';
  message: Scalars['String'];
};

export type CircleCreateMultipleChoiceOption = {
  optionText: Scalars['String'];
};

/** Defines a multiple choice question */
export type CircleCreateMultipleChoiceQuestionDataInput = {
  options: Array<CircleCreateMultipleChoiceOption>;
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleCreateOnDemandDataInput = {
  archived?: Maybe<Scalars['Boolean']>;
  description: Scalars['String'];
  duration: Scalars['Int'];
  externalVideoUrl: Scalars['String'];
  facilitatorIds?: Maybe<Array<Scalars['ID']>>;
  languageCode: Scalars['String'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  poster?: Maybe<Scalars['String']>;
  relatedTopicIds?: Maybe<Array<Scalars['ID']>>;
  seriesId: Scalars['ID'];
  slug: Scalars['String'];
  thumbnail: Scalars['String'];
};

export type CircleCreateSegmentedScaleOption = {
  optionText: Scalars['String'];
  optionValue: Scalars['Int'];
};

/** Defines a segmented scale question */
export type CircleCreateSegmentedScaleQuestionDataInput = {
  options: Array<CircleCreateSegmentedScaleOption>;
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

/** CircleCreateSeriesDataInput input used for adminCreateSeries mutation */
export type CircleCreateSeriesDataInput = {
  accessType?: Maybe<Scalars['String']>;
  archived: Scalars['Boolean'];
  description: Scalars['String'];
  heroBackgroundColor?: Maybe<Scalars['String']>;
  heroImage?: Maybe<Scalars['String']>;
  illustrationUrl: Scalars['String'];
  isDraft?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  other?: Maybe<Scalars['String']>;
  shortDescription: Scalars['String'];
  slug: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
};

/** CircleCreateSessionDataInput input used for adminCreateSession mutation */
export type CircleCreateSessionDataInput = {
  archived: Scalars['Boolean'];
  companyId?: Maybe<Scalars['ID']>;
  companySurveyUrl?: Maybe<Scalars['String']>;
  facilitatorIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isExternalMeetingUrl?: Maybe<Scalars['Boolean']>;
  meetingInstructions?: Maybe<Scalars['String']>;
  meetingUrl?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  rsvpLink?: Maybe<Scalars['String']>;
  seatLimit: Scalars['Int'];
  seatsLeft?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  startTime: Scalars['DateTime'];
  topicId: Scalars['ID'];
  useInHouseRsvp?: Maybe<Scalars['Boolean']>;
};

/** Defines a short response question */
export type CircleCreateShortResponseQuestionDataInput = {
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

/** CircleCreateTopicDataInput input used for adminCreateTopic mutation */
export type CircleCreateTopicDataInput = {
  description: Scalars['String'];
  duration: Scalars['Int'];
  format: CircleTopicFormat;
  languageCode: Scalars['String'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  seriesId?: Maybe<Scalars['ID']>;
  slug: Scalars['String'];
  surveyUrl?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type CircleCreateUnauthenticatedCompanyRsvpDataInput = {
  sessionId: Scalars['ID'];
  userInfo: CircleCompanyRsvpUnauthenticatedUserInfoInput;
};

export type CircleCreateUnauthenticatedCompanyRsvpMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleProcessingError | CircleRsvpSuccessful | CircleSeriesAccessTypeNotAllowedError | CircleSessionAlreadyStartedError | CircleSessionSeatLimitExceededError | CircleValidationError;

export type CircleCreateUnauthenticatedRsvpDataInput = {
  rsvpQuestionAnswers?: Maybe<Array<CircleRsvpQuestionAnswerInput>>;
  sessionId: Scalars['ID'];
  userInfo: CircleRsvpUnauthenticatedUserInfoInput;
};

export type CircleCreateUnauthenticatedRsvpMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleProcessingError | CircleRsvpSuccessful | CircleSeriesAccessTypeNotAllowedError | CircleSessionAlreadyStartedError | CircleSessionSeatLimitExceededError | CircleValidationError;

export type CircleDeleteSuccessful = {
  __typename?: 'CircleDeleteSuccessful';
  message: Scalars['String'];
};

/** A question representing a dropdown of options */
export type CircleDropdownQuestionNode = CircleBaseQuestion & {
  __typename?: 'CircleDropdownQuestionNode';
  id: Scalars['ID'];
  options: Array<CircleAnswerDropdownOptionNode>;
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleFacilitatorCollection = {
  __typename?: 'CircleFacilitatorCollection';
  items: Array<Maybe<CircleFacilitatorNode>>;
  totalCount: Scalars['Int'];
};

export type CircleFacilitatorConnection = {
  __typename?: 'CircleFacilitatorConnection';
  edges: Array<Maybe<CircleFacilitatorEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleFacilitatorEdge = {
  __typename?: 'CircleFacilitatorEdge';
  cursor: Scalars['String'];
  node: CircleFacilitatorNode;
};

export type CircleFacilitatorNode = Node & {
  __typename?: 'CircleFacilitatorNode';
  bio?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  credential: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  photo?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
  webflowCreatedAt?: Maybe<Scalars['DateTime']>;
  webflowUpdatedAt?: Maybe<Scalars['DateTime']>;
};

/** A collection of items to feature */
export type CircleFeaturedCollection = {
  __typename?: 'CircleFeaturedCollection';
  /** The items to feature. */
  items: Array<CircleItem>;
  totalCount: Scalars['Int'];
};

export type CircleFeaturedItemCollection = {
  __typename?: 'CircleFeaturedItemCollection';
  items: Array<Maybe<CircleFeaturedItemNode>>;
  totalCount: Scalars['Int'];
};

export type CircleFeaturedItemNode = Node & {
  __typename?: 'CircleFeaturedItemNode';
  createdAt: Scalars['DateTime'];
  displayOrder: Scalars['Int'];
  featuredTopic?: Maybe<CircleTopicNode>;
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

/** A question definition representing a long-form text answer */
export type CircleFreeResponseQuestionDefinitionNode = CircleQuestionDefinitionNode & {
  __typename?: 'CircleFreeResponseQuestionDefinitionNode';
  id: Scalars['ID'];
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

/**
 * A type representing all nodes which can be featured,
 * if a frontend does not support a type it should not
 * be rendered.
 */
export type CircleItem = CircleTopicNode;

export enum CircleItemFeedbackType {
  OnDemandTopicFeedback = 'ON_DEMAND_TOPIC_FEEDBACK'
}

/** A language supported for Circles content */
export type CircleLanguage = {
  __typename?: 'CircleLanguage';
  englishDisplayName: Scalars['String'];
  languageCode: Scalars['String'];
  localeCode?: Maybe<Scalars['String']>;
};

export type CircleLanguageLinkNode = Node & {
  __typename?: 'CircleLanguageLinkNode';
  circleLanguage?: Maybe<CircleLanguage>;
  id: Scalars['ID'];
};

/** A question definition representing a multiple choice question */
export type CircleMultipleChoiceQuestionDefinitionNode = CircleQuestionDefinitionNode & {
  __typename?: 'CircleMultipleChoiceQuestionDefinitionNode';
  id: Scalars['ID'];
  options: Array<CircleAnswerMultipleChoiceDefinitionNode>;
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleNotFoundError = {
  __typename?: 'CircleNotFoundError';
  message: Scalars['String'];
};

export type CircleOnDemandBySlugQueryResponse = CircleNotFoundError | CircleOnDemandNode | CirclePermissionDeniedError;

export type CircleOnDemandConnection = {
  __typename?: 'CircleOnDemandConnection';
  edges: Array<Maybe<CircleOnDemandEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleOnDemandConnectionQueryResponse = CircleOnDemandConnection | CirclePermissionDeniedError;

export type CircleOnDemandEdge = {
  __typename?: 'CircleOnDemandEdge';
  cursor: Scalars['String'];
  node: CircleOnDemandNode;
};

export type CircleOnDemandLinkNode = Node & {
  __typename?: 'CircleOnDemandLinkNode';
  circleOnDemand?: Maybe<CircleOnDemandNode>;
  id: Scalars['ID'];
};

export type CircleOnDemandNode = Node & {
  __typename?: 'CircleOnDemandNode';
  archived?: Maybe<Scalars['Boolean']>;
  description: Scalars['String'];
  facilitators: Array<CircleFacilitatorNode>;
  id: Scalars['ID'];
  languageCode: Scalars['String'];
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  relatedTopics?: Maybe<Array<CircleTopicNode>>;
  series: CircleSeriesNode;
  slug: Scalars['String'];
  uuid: Scalars['UUID'];
  video: CircleVideoNode;
};

/**
 * A question representing a paragraph or multi-line text
 * input.
 */
export type CircleParagraphQuestionNode = CircleBaseQuestion & {
  __typename?: 'CircleParagraphQuestionNode';
  id: Scalars['ID'];
  lines?: Maybe<Scalars['Int']>;
  maxCharacters?: Maybe<Scalars['Int']>;
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CirclePermissionDeniedError = {
  __typename?: 'CirclePermissionDeniedError';
  message: Scalars['String'];
};

export type CircleProcessingError = {
  __typename?: 'CircleProcessingError';
  message: Scalars['String'];
};

/**
 * A type representing all nodes which can be returned
 * as question objects in Circles forms
 */
export type CircleQuestion = CircleCheckboxQuestionNode | CircleDropdownQuestionNode | CircleParagraphQuestionNode | CircleRadioGroupQuestionNode | CircleSingleLineQuestionNode;

export type CircleQuestionDefinitionNode = {
  id: Scalars['ID'];
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleRsvpQuestionAnswerInput = {
  answerId?: Maybe<Scalars['ID']>;
  answerText?: Maybe<Scalars['String']>;
  questionId: Scalars['ID'];
};

export type CircleRsvpUnauthenticatedUserInfoInput = {
  company?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  isMember: Scalars['Boolean'];
  lastName: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
};

/** A question representing a group of radio options */
export type CircleRadioGroupQuestionNode = CircleBaseQuestion & {
  __typename?: 'CircleRadioGroupQuestionNode';
  id: Scalars['ID'];
  options: Array<CircleAnswerRadioOptionNode>;
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleRetryFailedScheduledTasksMutationResponse = CircleAdminScheduledTasksCollection | CirclePermissionDeniedError;

export type CircleRsvpCancellationSuccessful = {
  __typename?: 'CircleRsvpCancellationSuccessful';
  rsvpState: CircleRsvpState;
};

/** Rsvp collection for a member */
export type CircleRsvpCollection = {
  __typename?: 'CircleRsvpCollection';
  edges: Array<Maybe<CircleRsvpEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleRsvpEdge = {
  __typename?: 'CircleRsvpEdge';
  cursor: Scalars['String'];
  node: CircleRsvpNode;
};

export type CircleRsvpForSessionExistsForUserError = {
  __typename?: 'CircleRsvpForSessionExistsForUserError';
  message: Scalars['String'];
};

export type CircleRsvpNode = Node & {
  __typename?: 'CircleRsvpNode';
  cancelledAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  joinSessionUrl?: Maybe<Scalars['String']>;
  session: CircleSessionNode;
  state: CircleRsvpState;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type CircleRsvpQueryResponse = CircleNotFoundError | CircleRsvpNode;

export type CircleRsvpQuestionDefinitionCollection = {
  __typename?: 'CircleRsvpQuestionDefinitionCollection';
  definitions: Array<CircleQuestionDefinitionNode>;
  totalCount: Scalars['Int'];
};

/** Node that has the relationship between a topic and a rsvpQuestion object */
export type CircleRsvpQuestionTopicNode = Node & {
  __typename?: 'CircleRsvpQuestionTopicNode';
  createdAt: Scalars['DateTime'];
  displayOrder: Scalars['Int'];
  id: Scalars['ID'];
  rsvpQuestion: CircleQuestion;
  topic: CircleTopicNode;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export enum CircleRsvpState {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type CircleRsvpSuccessful = {
  __typename?: 'CircleRsvpSuccessful';
  rsvpId: Scalars['ID'];
};

export type CircleRsvpsQueryResponse = CirclePermissionDeniedError | CircleRsvpCollection;

export type CircleScheduledTaskConnection = {
  __typename?: 'CircleScheduledTaskConnection';
  edges: Array<Maybe<CircleScheduledTaskEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleScheduledTaskEdge = {
  __typename?: 'CircleScheduledTaskEdge';
  cursor: Scalars['String'];
  node: CircleScheduledTaskNode;
};

export type CircleScheduledTaskNode = Node & {
  __typename?: 'CircleScheduledTaskNode';
  confirmedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  finishedProcessingAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  scheduledAt: Scalars['DateTime'];
  startedProcessingAt?: Maybe<Scalars['DateTime']>;
  taskName: Scalars['String'];
  taskState: CircleScheduledTaskState;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export enum CircleScheduledTaskState {
  Cancelled = 'CANCELLED',
  Error = 'ERROR',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Unprocessed = 'UNPROCESSED'
}

export type CircleScreenSectionNode = Node & {
  __typename?: 'CircleScreenSectionNode';
  ctaLink?: Maybe<CircleContentLinkNode>;
  ctaLinkText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  links: Array<Maybe<CircleContentLinkNode>>;
  renderComponent: CircleContentCollectionRenderComponent;
  subtitle?: Maybe<Scalars['String']>;
  /** Must support <country>countryCode</country> and <language>languageCode</language> within text. */
  title: Scalars['String'];
};

/**
 * A question definition representing a segmented scale
 *
 * A segmented scale is a linear list of multiple choice options
 * where each option is assigned a score.
 */
export type CircleSegmentedScaleQuestionDefinitionNode = CircleQuestionDefinitionNode & {
  __typename?: 'CircleSegmentedScaleQuestionDefinitionNode';
  id: Scalars['ID'];
  options: Array<CircleAnswerSegmentedScaleDefinitionNode>;
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleSeriesAccessTypeNotAllowedError = {
  __typename?: 'CircleSeriesAccessTypeNotAllowedError';
  message: Scalars['String'];
};

export type CircleSeriesCollection = {
  __typename?: 'CircleSeriesCollection';
  items: Array<Maybe<CircleSeriesNode>>;
  totalCount: Scalars['Int'];
};

export type CircleSeriesLinkNode = Node & {
  __typename?: 'CircleSeriesLinkNode';
  banner?: Maybe<ContentBannerNode>;
  circleSeries?: Maybe<CircleSeriesNode>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  mediaType?: Maybe<MediaTypeNode>;
  mobileValue?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type CircleSeriesNode = Node & {
  __typename?: 'CircleSeriesNode';
  accessType?: Maybe<Scalars['String']>;
  /** Returns All topics including those with expired sessions */
  allTopics: CircleTopicConnection;
  archived?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  heroBackgroundColor?: Maybe<Scalars['String']>;
  heroImage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  illustration?: Maybe<Scalars['String']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  onDemand: CircleOnDemandConnection;
  originalDescription: Scalars['String'];
  originalName: Scalars['String'];
  originalShortDescription: Scalars['String'];
  shortDescription: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  topics: CircleTopicConnection;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
  uuid: Scalars['UUID'];
  webflowCreatedAt?: Maybe<Scalars['DateTime']>;
  webflowUpdatedAt?: Maybe<Scalars['DateTime']>;
};


export type CircleSeriesNodeAllTopicsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type CircleSeriesNodeOnDemandArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type CircleSeriesNodeTopicsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type CircleSessionAlreadyStartedError = {
  __typename?: 'CircleSessionAlreadyStartedError';
  message: Scalars['String'];
};

export enum CircleSessionBookingStatus {
  FullyBooked = 'FULLY_BOOKED',
  LimitedAvailability = 'LIMITED_AVAILABILITY',
  ManySpotsAvailable = 'MANY_SPOTS_AVAILABLE',
  SpotsAvailable = 'SPOTS_AVAILABLE'
}

export type CircleSessionConnection = {
  __typename?: 'CircleSessionConnection';
  edges: Array<Maybe<CircleSessionEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleSessionEdge = {
  __typename?: 'CircleSessionEdge';
  cursor: Scalars['String'];
  node: CircleSessionNode;
};

export enum CircleSessionFilterType {
  Archived = 'ARCHIVED',
  Past = 'PAST',
  Upcoming = 'UPCOMING'
}

export type CircleSessionLinkNode = Node & {
  __typename?: 'CircleSessionLinkNode';
  banner?: Maybe<ContentBannerNode>;
  circleSession?: Maybe<CircleSessionNode>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  mediaType?: Maybe<MediaTypeNode>;
  mobileValue?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type CircleSessionNode = Node & {
  __typename?: 'CircleSessionNode';
  archived: Scalars['Boolean'];
  bookingStatus?: Maybe<CircleSessionBookingStatus>;
  companyName?: Maybe<Scalars['String']>;
  companySurveyUrl?: Maybe<Scalars['String']>;
  companyUuid?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  facilitators: Array<Maybe<CircleFacilitatorNode>>;
  id: Scalars['ID'];
  isExternalMeetingUrl: Scalars['Boolean'];
  isJoinable: Scalars['Boolean'];
  meetingInstructions?: Maybe<Scalars['String']>;
  meetingUrl?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  rsvpLink: Scalars['String'];
  seatLimit: Scalars['Int'];
  seatsLeft?: Maybe<Scalars['Int']>;
  startTime: Scalars['DateTime'];
  topic: CircleTopicNode;
  updatedAt: Scalars['DateTime'];
  useInHouseRsvp: Scalars['Boolean'];
  uuid: Scalars['UUID'];
  webflowCreatedAt?: Maybe<Scalars['DateTime']>;
  webflowUpdatedAt?: Maybe<Scalars['DateTime']>;
};

export type CircleSessionRegistrantCollection = {
  __typename?: 'CircleSessionRegistrantCollection';
  items: Array<CircleSessionRegistrantNode>;
  totalCount: Scalars['Int'];
};

export type CircleSessionRegistrantCollectionResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleSessionRegistrantCollection;

export type CircleSessionRegistrantNode = {
  __typename?: 'CircleSessionRegistrantNode';
  email: Scalars['String'];
  isMember: Scalars['Boolean'];
};

export type CircleSessionRsvpAnswer = {
  __typename?: 'CircleSessionRsvpAnswer';
  answer: Scalars['String'];
  questionId: Scalars['ID'];
};

export type CircleSessionSeatLimitExceededError = {
  __typename?: 'CircleSessionSeatLimitExceededError';
  message: Scalars['String'];
};

export type CircleSessionsByDateTimeResponse = CircleSessionConnection;

/** A question definition representing a short text answer */
export type CircleShortResponseQuestionDefinitionNode = CircleQuestionDefinitionNode & {
  __typename?: 'CircleShortResponseQuestionDefinitionNode';
  id: Scalars['ID'];
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

/** A question representing a single line of text input. */
export type CircleSingleLineQuestionNode = CircleBaseQuestion & {
  __typename?: 'CircleSingleLineQuestionNode';
  id: Scalars['ID'];
  maxCharacters?: Maybe<Scalars['Int']>;
  questionText: Scalars['String'];
  required: Scalars['Boolean'];
};

export type CircleSuccessfulResponse = {
  __typename?: 'CircleSuccessfulResponse';
  message: Scalars['String'];
};

export type CircleTopicConnection = {
  __typename?: 'CircleTopicConnection';
  edges: Array<Maybe<CircleTopicEdge>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int'];
};

export type CircleTopicEdge = {
  __typename?: 'CircleTopicEdge';
  cursor: Scalars['String'];
  node: CircleTopicNode;
};

export enum CircleTopicFormat {
  Discussion = 'DISCUSSION',
  Fireside = 'FIRESIDE',
  ListenAndLearn = 'LISTEN_AND_LEARN',
  Workshop = 'WORKSHOP'
}

export type CircleTopicLinkNode = Node & {
  __typename?: 'CircleTopicLinkNode';
  banner?: Maybe<ContentBannerNode>;
  circleTopic?: Maybe<CircleTopicNode>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  mediaType?: Maybe<MediaTypeNode>;
  mobileValue?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type CircleTopicNode = Node & {
  __typename?: 'CircleTopicNode';
  /** A list of active rsvps for community sessions in this topic for the authenticated user. */
  activeCommunityRsvps?: Maybe<Array<CircleRsvpNode>>;
  /** A list of active rsvps for company sessions in this topic for the authenticated user. */
  activeCompanyRsvps?: Maybe<Array<CircleRsvpNode>>;
  /** Deprecated. Use activeCommunityRsvps. When authenticated, this returns a list of active Rsvps for that user. */
  activeRsvps?: Maybe<Array<CircleRsvpNode>>;
  /** All Community sessions for this topic for admins */
  allCommunitySessions?: Maybe<Array<CircleSessionNode>>;
  /** All company sessions for this topic for admins */
  allCompanySessions?: Maybe<Array<CircleSessionNode>>;
  /** Community sessions for this topic, excluding already RSVPd sessions for authenticated users. */
  communitySessions: Array<CircleSessionNode>;
  /** Company sessions for this topic. companyId is only used to filter sessions if the user is not authenticated. */
  companySessions: Array<CircleSessionNode>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  /** Number of minutes */
  duration: Scalars['Int'];
  facilitators: CircleFacilitatorConnection;
  format: CircleTopicFormat;
  id: Scalars['ID'];
  languageCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** A special note to indicate content considerations, participation requirements, etc. */
  note?: Maybe<Scalars['String']>;
  /** The list of RsvpQuestionTopic objects */
  rsvpQuestionTopics?: Maybe<Array<Maybe<CircleRsvpQuestionTopicNode>>>;
  /** The list of questions for RSVPing to sessions in this topic */
  rsvpQuestions: Array<Maybe<CircleQuestion>>;
  series: CircleSeriesNode;
  /** Deprecated. Use communitySessions or companySessions. */
  sessions: CircleSessionConnection;
  slug?: Maybe<Scalars['String']>;
  surveyUrl?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
  webflowCreatedAt?: Maybe<Scalars['DateTime']>;
  webflowUpdatedAt?: Maybe<Scalars['DateTime']>;
};


export type CircleTopicNodeAllCommunitySessionsArgs = {
  filterBy?: Maybe<CircleSessionFilterType>;
};


export type CircleTopicNodeAllCompanySessionsArgs = {
  filterBy?: Maybe<CircleSessionFilterType>;
};


export type CircleTopicNodeCompanySessionsArgs = {
  companyId?: Maybe<Scalars['ID']>;
};


export type CircleTopicNodeFacilitatorsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type CircleTopicNodeSessionsArgs = {
  after?: Maybe<Scalars['String']>;
  afterDateTime?: Maybe<Scalars['DateTime']>;
  before?: Maybe<Scalars['String']>;
  beforeDateTime?: Maybe<Scalars['DateTime']>;
  excludeActiveRsvps?: Maybe<Scalars['Boolean']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

/** CircleUpdateFacilitatorDataInput input used for adminUpdateFacilitator mutation */
export type CircleUpdateFacilitatorDataInput = {
  bio?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CircleUpdateOnDemandTopicDataInput = {
  archived?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  externalVideoUrl?: Maybe<Scalars['String']>;
  facilitatorIds?: Maybe<Array<Scalars['ID']>>;
  languageCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  poster?: Maybe<Scalars['String']>;
  relatedTopicIds?: Maybe<Array<Scalars['ID']>>;
  seriesId?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

/** CircleUpdateSeriesDataInput input used for updateSeries mutation */
export type CircleUpdateSeriesDataInput = {
  accessType?: Maybe<Scalars['String']>;
  archived?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  heroBackgroundColor?: Maybe<Scalars['String']>;
  heroImage?: Maybe<Scalars['String']>;
  illustrationUrl?: Maybe<Scalars['String']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  shortDescription?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

/** CircleUpdateSessionDataInput input used for adminUpdateSession mutation */
export type CircleUpdateSessionDataInput = {
  archived?: Maybe<Scalars['Boolean']>;
  companyId?: Maybe<Scalars['ID']>;
  companySurveyUrl?: Maybe<Scalars['String']>;
  facilitatorIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  isExternalMeetingUrl?: Maybe<Scalars['Boolean']>;
  meetingInstructions?: Maybe<Scalars['String']>;
  meetingUrl?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  rsvpLink?: Maybe<Scalars['String']>;
  seatLimit?: Maybe<Scalars['Int']>;
  seatsLeft?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['DateTime']>;
  topicId?: Maybe<Scalars['ID']>;
  useInHouseRsvp?: Maybe<Scalars['Boolean']>;
};

/** CircleUpdateTopicDataInput input used for adminUpdateTopic mutation */
export type CircleUpdateTopicDataInput = {
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  format?: Maybe<CircleTopicFormat>;
  languageCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  seriesId?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
  surveyUrl?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type CircleUserViewedOnDemandTopicMutationResponse = CircleNotFoundError | CirclePermissionDeniedError | CircleSuccessfulResponse | CircleValidationError;

export type CircleValidationError = {
  __typename?: 'CircleValidationError';
  message: Scalars['String'];
};

export type CircleVideoNode = {
  __typename?: 'CircleVideoNode';
  durationInSeconds: Scalars['Int'];
  externalVideoUrl: Scalars['String'];
  poster?: Maybe<Scalars['String']>;
  thumbnail: Scalars['String'];
};

export type CirclesLanguageOverviewScreenNode = Node & {
  __typename?: 'CirclesLanguageOverviewScreenNode';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sections: Array<Maybe<CircleScreenSectionNode>>;
};

export type CirclesLanguageOverviewScreenResponse = CirclePermissionDeniedError | CirclesLanguageOverviewScreenNode;

export type CirclesOnDemandOverviewScreenNode = Node & {
  __typename?: 'CirclesOnDemandOverviewScreenNode';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sections: Array<Maybe<CircleScreenSectionNode>>;
};

export type CirclesOnDemandOverviewScreenResponse = CirclePermissionDeniedError | CirclesOnDemandOverviewScreenNode;

export type ClientBucketNode = {
  __typename?: 'ClientBucketNode';
  automated: Scalars['Boolean'];
  bucketName: Scalars['String'];
  companyFolder?: Maybe<Scalars['String']>;
  companyUuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  notifyAccountUuid: Scalars['UUID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientFileEventDetailsNode = {
  __typename?: 'ClientFileEventDetailsNode';
  events?: Maybe<Array<Maybe<ClientFileEventNode>>>;
  issues?: Maybe<Array<Maybe<ClientFileIssueNode>>>;
  segments?: Maybe<Array<Maybe<ClientFileSegmentNode>>>;
};

export type ClientFileEventNode = {
  __typename?: 'ClientFileEventNode';
  createdAt: Scalars['DateTime'];
  event: Scalars['String'];
  metadata?: Maybe<Scalars['Metadata']>;
};

export type ClientFileIssueNode = {
  __typename?: 'ClientFileIssueNode';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  issueType: Scalars['String'];
  metadata?: Maybe<Scalars['Metadata']>;
};

export type ClientFileNode = {
  __typename?: 'ClientFileNode';
  addedCount?: Maybe<Scalars['Int']>;
  companyUuid: Scalars['UUID'];
  createdAt: Scalars['DateTime'];
  existingCount?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  ineligibleCount?: Maybe<Scalars['Int']>;
  invalidCount?: Maybe<Scalars['Int']>;
  isLatestFile?: Maybe<Scalars['Boolean']>;
  latest_event?: Maybe<Scalars['String']>;
  mark_missing_ineligible?: Maybe<Scalars['Boolean']>;
  originalFilePath: Scalars['String'];
  rowCount?: Maybe<Scalars['Int']>;
  source: Scalars['String'];
  totalCount?: Maybe<Scalars['Int']>;
  uploader_uuid: Scalars['String'];
};

export type ClientFileSegmentNode = {
  __typename?: 'ClientFileSegmentNode';
  createdAt: Scalars['DateTime'];
  filePath: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  preprocessedAt?: Maybe<Scalars['DateTime']>;
  processedAt?: Maybe<Scalars['DateTime']>;
};

export type ClientSummaryNode = Node & {
  __typename?: 'ClientSummaryNode';
  appInstalled: Scalars['Boolean'];
  coachAssignment?: Maybe<CoachAssignmentNode>;
  coachingVisitsToReportCount?: Maybe<Scalars['Int']>;
  companyName: Scalars['String'];
  id: Scalars['ID'];
  isCompanyHpiEnabled?: Maybe<Scalars['Boolean']>;
  isCompanyPsychiatryEnabled?: Maybe<Scalars['Boolean']>;
  isMinor?: Maybe<Scalars['Boolean']>;
  lastVisit?: Maybe<Scalars['DateTime']>;
  lastWho5Score?: Maybe<Scalars['Int']>;
  matchStatus?: Maybe<Scalars['String']>;
  memberEmail: Scalars['String'];
  memberEnrolledInAutoPayments?: Maybe<Scalars['Boolean']>;
  memberFirstName: Scalars['String'];
  memberInsuranceStatus?: Maybe<Scalars['String']>;
  memberLastName: Scalars['String'];
  memberName: Scalars['String'];
  memberUuid: Scalars['UUID'];
  nextVisit?: Maybe<Scalars['DateTime']>;
  phq9SelfharmScore?: Maybe<Scalars['Int']>;
  remainingPathwayVisits?: Maybe<Scalars['Int']>;
  visitsCovered: Scalars['Int'];
  visitsRemaining: Scalars['Int'];
  visitsUsed: Scalars['Int'];
};

export type ClientSummaryNodeConnection = {
  __typename?: 'ClientSummaryNodeConnection';
  edgeCount?: Maybe<Scalars['Int']>;
  edges: Array<Maybe<ClientSummaryNodeEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ClientSummaryNodeEdge = {
  __typename?: 'ClientSummaryNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<ClientSummaryNode>;
};

export type CoachAssignmentNode = {
  __typename?: 'CoachAssignmentNode';
  active: Scalars['Boolean'];
  coach?: Maybe<CoachNode>;
  coachingVisits: Array<CoachingVisitNode>;
  conversation?: Maybe<ConversationNode>;
  createdAt: Scalars['DateTime'];
  displayOnSchedule?: Maybe<Scalars['Boolean']>;
  inactiveAt?: Maybe<Scalars['DateTime']>;
  intakeForm?: Maybe<IntakeFormNode>;
  isPathwayAssignment?: Maybe<Scalars['Boolean']>;
  member?: Maybe<MemberNode>;
  providerDisplayType: ProviderAssignmentDisplayType;
  uuid: Scalars['UUID'];
};

export type CoachInput = {
  available_ttc?: Maybe<Scalars['Boolean']>;
  country_match?: Maybe<Scalars['Boolean']>;
  first_available_time_slot?: Maybe<Scalars['String']>;
  global_uuid?: Maybe<Scalars['String']>;
  new_provider?: Maybe<Scalars['Boolean']>;
  rate?: Maybe<Scalars['Float']>;
  specialty_match?: Maybe<Scalars['Boolean']>;
};

export type CoachMemberMatchingNode = {
  __typename?: 'CoachMemberMatchingNode';
  id: Scalars['ID'];
  score: Scalars['Float'];
};

export type CoachMemberMatchingUnitNode = {
  __typename?: 'CoachMemberMatchingUnitNode';
  modelMetadata: ModelMetadataNode;
  results?: Maybe<Array<CoachMemberMatchingNode>>;
};

export type CoachNode = {
  __typename?: 'CoachNode';
  avatar?: Maybe<Scalars['String']>;
  bufferTime?: Maybe<Scalars['Int']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  credentials?: Maybe<Scalars['String']>;
  defaultVisitDuration?: Maybe<Scalars['Int']>;
  digitalBio?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  goalInterests?: Maybe<Array<Maybe<Scalars['String']>>>;
  introduction?: Maybe<Scalars['String']>;
  isInAppProvider?: Maybe<Scalars['Boolean']>;
  languagePreference?: Maybe<Scalars['String']>;
  languagePreferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  lateCancellationThreshold?: Maybe<Scalars['Int']>;
  licensedStates?: Maybe<Array<Maybe<Scalars['String']>>>;
  localTimezone?: Maybe<AccountLocalTimezone>;
  matchAlgorithmVersion?: Maybe<Scalars['String']>;
  matchScore?: Maybe<Scalars['Float']>;
  maximumMemberSlots?: Maybe<Scalars['Int']>;
  newClientCapacity?: Maybe<Scalars['Int']>;
  officeHours?: Maybe<Scalars['GenericScalar']>;
  preferencesMatched?: Maybe<Array<Maybe<MemberFilterPreferenceNode>>>;
  providerCertifications: Array<ProviderCertificationNode>;
  providerInvoicingOnly?: Maybe<Scalars['Boolean']>;
  providerNextAvailability?: Maybe<Scalars['String']>;
  providerSchedulingType?: Maybe<AccountProviderSchedulingType>;
  providerSpecialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  providerType?: Maybe<Scalars['String']>;
  providerUpdatedProfileAt?: Maybe<Scalars['DateTime']>;
  psychiatristSubtype?: Maybe<Scalars['String']>;
  races: Array<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  therapistModalities?: Maybe<Array<Maybe<Scalars['String']>>>;
  uuid: Scalars['UUID'];
  zipCode?: Maybe<Scalars['String']>;
};


export type CoachNodePreferencesMatchedArgs = {
  preferences: MemberPreferencesInput;
};

export type CoachingVisitClaimable = {
  __typename?: 'CoachingVisitClaimable';
  claimable: Scalars['Boolean'];
};

export enum CoachingVisitModalityType {
  InPerson = 'IN_PERSON',
  Phone = 'PHONE',
  Unknown = 'UNKNOWN',
  Video = 'VIDEO'
}

export type CoachingVisitNode = {
  __typename?: 'CoachingVisitNode';
  actualDuration?: Maybe<Scalars['Int']>;
  coachAssignment?: Maybe<CoachAssignmentNode>;
  coachUuid?: Maybe<Scalars['String']>;
  createdByUuid?: Maybe<Scalars['String']>;
  creationSource?: Maybe<Scalars['String']>;
  googleCalendarEventUrl?: Maybe<Scalars['String']>;
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isPathway?: Maybe<Scalars['Boolean']>;
  isPsychiatryInitialEvaluation?: Maybe<Scalars['Boolean']>;
  isTherapy: Scalars['Boolean'];
  lastTokboxActivity?: Maybe<Scalars['DateTime']>;
  lastZoomActivity?: Maybe<Scalars['DateTime']>;
  memberUuid?: Maybe<Scalars['String']>;
  modalityType: CoachingVisitModalityType;
  organizationImprovements?: Maybe<Scalars['String']>;
  previousProviderReview?: Maybe<CoachingVisitProviderReviewNode>;
  providerVideoEndTime?: Maybe<Scalars['DateTime']>;
  providerVideoStartTime?: Maybe<Scalars['DateTime']>;
  rating?: Maybe<RatingNode>;
  reviews?: Maybe<Array<Maybe<ReviewNode>>>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  scheduledTime: Scalars['DateTime'];
  state: CoachingVisitState;
  uuid: Scalars['UUID'];
  videoService?: Maybe<Scalars['String']>;
  videoSessionUrl?: Maybe<Scalars['String']>;
  visitInfo?: Maybe<Scalars['String']>;
  visitType?: Maybe<Scalars['String']>;
  zoomUrl?: Maybe<Scalars['String']>;
};

export type CoachingVisitProviderReviewNode = {
  __typename?: 'CoachingVisitProviderReviewNode';
  abilityToHelpClient: Scalars['Int'];
  clearPlanToWorkTowardGoals: Scalars['Int'];
  feedbackText?: Maybe<Scalars['String']>;
  workedOnAgreedUponGoals: Scalars['Int'];
};

export enum CoachingVisitState {
  Attended = 'ATTENDED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  CompletedCredited = 'COMPLETED_CREDITED',
  InProgress = 'IN_PROGRESS',
  LateCancellation = 'LATE_CANCELLATION',
  NoShow = 'NO_SHOW',
  PendingConfirmation = 'PENDING_CONFIRMATION',
  PendingPayment = 'PENDING_PAYMENT',
  Scheduled = 'SCHEDULED',
  Unknown = 'UNKNOWN'
}

export enum ColorScheme {
  Blue = 'BLUE',
  Cyan = 'CYAN',
  Grayscale = 'GRAYSCALE',
  Orange = 'ORANGE',
  Red = 'RED',
  Violet = 'VIOLET'
}

export type CompaniesWithSegmentsOutput = CompaniesWithSegmentsSuccessResponse | InternalToolPermissionDeniedError;

export type CompaniesWithSegmentsSuccessResponse = {
  __typename?: 'CompaniesWithSegmentsSuccessResponse';
  companies?: Maybe<Array<Maybe<CompanyNode>>>;
};

export type CompanyAdditionalBenefitNode = {
  __typename?: 'CompanyAdditionalBenefitNode';
  availableForDependents: Scalars['Boolean'];
  color?: Maybe<Scalars['String']>;
  companies: Array<CompanyDropdownNode>;
  countries: Array<CountryNode>;
  /** @deprecated Field no longer used. Use countries instead */
  country?: Maybe<CountryNode>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['Date']>;
  /** @deprecated Use uuid instead */
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isGlobal?: Maybe<Scalars['Boolean']>;
  isModernHealthAddOn: Scalars['Boolean'];
  link: Scalars['String'];
  /** @deprecated Field no longer used */
  longDescription?: Maybe<Scalars['String']>;
  /** @deprecated Field no longer used. */
  needHelp?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  segments: Array<CompanySegmentNode>;
  source?: Maybe<CompanyAdditionalBenefitSource>;
  startDate?: Maybe<Scalars['Date']>;
  states?: Maybe<Array<Scalars['String']>>;
  subtopicOfFocus?: Maybe<SubtopicOfFocusNode>;
  title: Scalars['String'];
  topics: Array<TopicOfFocusNode>;
  topicsInCommon?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uuid: Scalars['UUID'];
};

export enum CompanyAdditionalBenefitSource {
  DjangoAdmin = 'DJANGO_ADMIN',
  DjangoBulkCsv = 'DJANGO_BULK_CSV',
  Retool = 'RETOOL',
  SelfServe = 'SELF_SERVE'
}

export type CompanyDoesNotExist = {
  __typename?: 'CompanyDoesNotExist';
  uuid: Scalars['UUID'];
};

export type CompanyDropdownNode = {
  __typename?: 'CompanyDropdownNode';
  id: Scalars['ID'];
  name: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type CompanyFeatureNode = {
  __typename?: 'CompanyFeatureNode';
  featureName?: Maybe<Scalars['String']>;
  featureType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  latestUpdate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type CompanyFeatureStatusNode = {
  __typename?: 'CompanyFeatureStatusNode';
  companyName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type CompanyNode = Node & {
  __typename?: 'CompanyNode';
  /** @deprecated Field no longer used */
  benefitsPageSubheading?: Maybe<Scalars['String']>;
  companySegments: Array<CompanySegmentNode>;
  coveredCoachingVisits: Scalars['Int'];
  coveredTherapyVisits: Scalars['Int'];
  dependentInvitationFeature: Scalars['Boolean'];
  hrEmail?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  maximumNumberOfDependents: Scalars['Int'];
  minimumDependentTherapyAge: Scalars['Int'];
  name: Scalars['String'];
  resetDate: Scalars['Date'];
  specificInfo?: Maybe<Scalars['String']>;
  ssoOnly?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['UUID'];
};

export type CompanyOutput = CompanyDoesNotExist | CompanyNode;

export type CompanySegmentInput = {
  companyUuid: Scalars['UUID'];
  name: Scalars['String'];
  uuid?: Maybe<Scalars['UUID']>;
};

export type CompanySegmentNode = {
  __typename?: 'CompanySegmentNode';
  company: CompanyNode;
  members: Array<MemberNode>;
  name: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type CompanySegmentsOutput = CompanySegmentsSuccessResponse | InternalToolPermissionDeniedError;

export type CompanySegmentsSuccessResponse = {
  __typename?: 'CompanySegmentsSuccessResponse';
  companySegments?: Maybe<Array<Maybe<CompanySegmentNode>>>;
};

export type CompleteTestPammInitialEvaluation = {
  __typename?: 'CompleteTestPammInitialEvaluation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ConfirmVisitWithoutPaymentMutation = {
  __typename?: 'ConfirmVisitWithoutPaymentMutation';
  ok?: Maybe<Scalars['Boolean']>;
  sessionState?: Maybe<Scalars['String']>;
};

export type ContentBannerNode = Node & {
  __typename?: 'ContentBannerNode';
  backgroundColor: Scalars['String'];
  id: Scalars['ID'];
  imageUrl: Scalars['String'];
};

export type ContentCollectionCreateErrorResponse = {
  __typename?: 'ContentCollectionCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentCollectionCreateInput = {
  designatedApplication: ContentCollectionDesignatedApplication;
  director?: Maybe<ContentCollectionDirectorNames>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ContentCollectionCreateOutput = ContentCollectionCreateErrorResponse | ContentCollectionCreateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentCollectionCreateSuccessResponse = {
  __typename?: 'ContentCollectionCreateSuccessResponse';
  contentCollection?: Maybe<ContentCollectionNode>;
};

export type ContentCollectionDeleteErrorResponse = {
  __typename?: 'ContentCollectionDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentCollectionDeleteInput = {
  id: Scalars['ID'];
};

export type ContentCollectionDeleteOutput = ContentCollectionDeleteErrorResponse | ContentCollectionDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type ContentCollectionDeleteSuccessResponse = {
  __typename?: 'ContentCollectionDeleteSuccessResponse';
  contentCollection?: Maybe<ContentCollectionNode>;
};

export enum ContentCollectionDesignatedApplication {
  HrAdmin = 'HR_ADMIN',
  Member = 'MEMBER'
}

export enum ContentCollectionDirectorNames {
  AllRecommendedContent = 'ALL_RECOMMENDED_CONTENT',
  CirclesRecommendedContent = 'CIRCLES_RECOMMENDED_CONTENT',
  ExploreCareOptions = 'EXPLORE_CARE_OPTIONS',
  ExploreYourTopPicks = 'EXPLORE_YOUR_TOP_PICKS',
  ForYou = 'FOR_YOU',
  JumpBackIn = 'JUMP_BACK_IN',
  ManageCareTeam = 'MANAGE_CARE_TEAM',
  MeditationsRecommendedContent = 'MEDITATIONS_RECOMMENDED_CONTENT',
  ProgramsRecommendedContent = 'PROGRAMS_RECOMMENDED_CONTENT',
  RecommendedContentTags = 'RECOMMENDED_CONTENT_TAGS',
  RecommendedNextStepContent = 'RECOMMENDED_NEXT_STEP_CONTENT',
  YourOneCare = 'YOUR_ONE_CARE'
}

export type ContentCollectionLinkCreateErrorResponse = {
  __typename?: 'ContentCollectionLinkCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentCollectionLinkCreateInput = {
  contentCollectionId: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  intendedAudience?: Maybe<Scalars['String']>;
  linkType: Scalars['String'];
  mediaTypeId?: Maybe<Scalars['ID']>;
  minimumMobileVersion?: Maybe<Scalars['String']>;
  mobileValue: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  tileColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type ContentCollectionLinkCreateOutput = ContentCollectionLinkCreateErrorResponse | ContentCollectionLinkCreateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentCollectionLinkCreateSuccessResponse = {
  __typename?: 'ContentCollectionLinkCreateSuccessResponse';
  contentCollectionLink?: Maybe<ContentCollectionLinkNode>;
};

export type ContentCollectionLinkDeleteErrorResponse = {
  __typename?: 'ContentCollectionLinkDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentCollectionLinkDeleteInput = {
  id: Scalars['ID'];
};

export type ContentCollectionLinkDeleteOutput = ContentCollectionLinkDeleteErrorResponse | ContentCollectionLinkDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type ContentCollectionLinkDeleteSuccessResponse = {
  __typename?: 'ContentCollectionLinkDeleteSuccessResponse';
  contentCollectionLink?: Maybe<ContentCollectionLinkNode>;
};

export enum ContentCollectionLinkLinkType {
  CircleSeries = 'CIRCLE_SERIES',
  CircleSession = 'CIRCLE_SESSION',
  CircleTopic = 'CIRCLE_TOPIC',
  ExternalLink = 'EXTERNAL_LINK',
  InternalLink = 'INTERNAL_LINK',
  Meditation = 'MEDITATION',
  Program = 'PROGRAM'
}

export type ContentCollectionLinkNode = Node & {
  __typename?: 'ContentCollectionLinkNode';
  banner?: Maybe<ContentBannerNode>;
  contentCollection: ContentCollectionNode;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  intendedAudience?: Maybe<Scalars['String']>;
  linkType: Scalars['String'];
  mediaType?: Maybe<MediaTypeNode>;
  minimumMobileVersion: Scalars['String'];
  mobileValue: Scalars['String'];
  scheduledcontentSet: ScheduledContentNodeConnection;
  screenSet: GenericScreenNodeConnection;
  screensectionSet: DataDefinedScreenSectionNodeConnection;
  slug?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  tileColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
  webValue?: Maybe<Scalars['String']>;
};


export type ContentCollectionLinkNodeScheduledcontentSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ContentCollectionLinkNodeScreenSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ContentCollectionLinkNodeScreensectionSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ContentCollectionLinkNodeConnection = {
  __typename?: 'ContentCollectionLinkNodeConnection';
  edges: Array<Maybe<ContentCollectionLinkNodeEdge>>;
  pageInfo: PageInfo;
};

export type ContentCollectionLinkNodeEdge = {
  __typename?: 'ContentCollectionLinkNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<ContentCollectionLinkNode>;
};

export type ContentCollectionLinkUpdateErrorResponse = {
  __typename?: 'ContentCollectionLinkUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentCollectionLinkUpdateInput = {
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  intendedAudience?: Maybe<Scalars['String']>;
  linkType: Scalars['String'];
  mediaTypeId?: Maybe<Scalars['ID']>;
  minimumMobileVersion?: Maybe<Scalars['String']>;
  mobileValue: Scalars['String'];
  moveDownInIndex?: Maybe<Scalars['Boolean']>;
  moveUpInIndex?: Maybe<Scalars['Boolean']>;
  subtitle?: Maybe<Scalars['String']>;
  tileColor?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type ContentCollectionLinkUpdateOutput = ContentCollectionLinkUpdateErrorResponse | ContentCollectionLinkUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentCollectionLinkUpdateSuccessResponse = {
  __typename?: 'ContentCollectionLinkUpdateSuccessResponse';
  contentCollectionLink?: Maybe<ContentCollectionLinkNode>;
};

export type ContentCollectionNode = Node & {
  __typename?: 'ContentCollectionNode';
  activityGroups: CourseActivityGroupNodeConnection;
  contentCollectionLinkNodes: Array<Maybe<ContentCollectionLinkNode>>;
  contentCollectionLinks: Array<Maybe<ContentLinkNode>>;
  contentTranslationAvailability: ContentTranslationAvailabilityNodeConnection;
  createdAt: Scalars['DateTime'];
  designatedApplication: ContentCollectionDesignatedApplication;
  director?: Maybe<ContentCollectionDirectorNames>;
  id: Scalars['ID'];
  pathwaytopicSet: PathwayTopicNodeConnection;
  scheduledContent?: Maybe<ScheduledContentNode>;
  screens: GenericScreenNodeConnection;
  sections: DataDefinedScreenSectionNodeConnection;
  slug?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  subtitleTranslationKey?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  titleTranslationKey: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};


export type ContentCollectionNodeActivityGroupsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ContentCollectionNodeContentTranslationAvailabilityArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ContentCollectionNodePathwaytopicSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ContentCollectionNodeScreensArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ContentCollectionNodeSectionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ContentCollectionNodeConnection = {
  __typename?: 'ContentCollectionNodeConnection';
  edges: Array<Maybe<ContentCollectionNodeEdge>>;
  pageInfo: PageInfo;
};

export type ContentCollectionNodeEdge = {
  __typename?: 'ContentCollectionNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<ContentCollectionNode>;
};

export enum ContentCollectionPlatform {
  Dhcs = 'DHCS',
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export enum ContentCollectionRenderComponent {
  Banner = 'BANNER',
  CareCard = 'CARE_CARD',
  Grid = 'GRID',
  Horizontal = 'HORIZONTAL',
  RecommendedNextStepBanner = 'RECOMMENDED_NEXT_STEP_BANNER',
  Tile = 'TILE',
  Vertical = 'VERTICAL'
}

export type ContentCollectionUpdateErrorResponse = {
  __typename?: 'ContentCollectionUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentCollectionUpdateInput = {
  designatedApplication: ContentCollectionDesignatedApplication;
  director?: Maybe<ContentCollectionDirectorNames>;
  id: Scalars['ID'];
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ContentCollectionUpdateOutput = ContentCollectionUpdateErrorResponse | ContentCollectionUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentCollectionUpdateSuccessResponse = {
  __typename?: 'ContentCollectionUpdateSuccessResponse';
  contentCollection?: Maybe<ContentCollectionNode>;
};

export type ContentLanguageCreateErrorResponse = {
  __typename?: 'ContentLanguageCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentLanguageCreateInput = {
  code: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  spokenLanguages?: Maybe<Array<Scalars['String']>>;
};

export type ContentLanguageCreateOutput = ContentLanguageCreateErrorResponse | ContentLanguageCreateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentLanguageCreateSuccessResponse = {
  __typename?: 'ContentLanguageCreateSuccessResponse';
  contentLanguage?: Maybe<ContentLanguageNode>;
};

export type ContentLanguageNode = Node & {
  __typename?: 'ContentLanguageNode';
  code: Scalars['String'];
  contentTranslationAvailability: ContentTranslationAvailabilityNodeConnection;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  onlyShowTranslatedContent: Scalars['Boolean'];
  spokenLanguages?: Maybe<Array<Scalars['String']>>;
  texttracktranslationSet: TextTrackTranslationNodeConnection;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};


export type ContentLanguageNodeContentTranslationAvailabilityArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ContentLanguageNodeTexttracktranslationSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ContentLanguageUpdateErrorResponse = {
  __typename?: 'ContentLanguageUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentLanguageUpdateInput = {
  code: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  spokenLanguages?: Maybe<Array<Scalars['String']>>;
};

export type ContentLanguageUpdateOutput = ContentLanguageUpdateErrorResponse | ContentLanguageUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentLanguageUpdateSuccessResponse = {
  __typename?: 'ContentLanguageUpdateSuccessResponse';
  contentLanguage?: Maybe<ContentLanguageNode>;
};

export type ContentLinkNode = AssessmentLinkNode | CircleSeriesLinkNode | CircleSessionLinkNode | CircleTopicLinkNode | CourseLinkNode | ExternalLinkNode | HrEventLinkNode | HrResourceLinkNode | InternalLinkNode | MeditationLinkNode | ProgramLinkNode | ScreenLinkNode;

export type ContentNode = {
  __typename?: 'ContentNode';
  id: Scalars['ID'];
  score: Scalars['Float'];
  type: ContentType;
};

export type ContentResponsesNode = {
  __typename?: 'ContentResponsesNode';
  account: MemberNode;
  assessment?: Maybe<AssessmentNode>;
  assessmentFlow?: Maybe<AssessmentFlowNode>;
  assessmentJourney?: Maybe<AssessmentJourneyNode>;
  careRecommendation: Array<CareRecommendationNode>;
  content?: Maybe<Scalars['JSONString']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  delta?: Maybe<Scalars['JSONString']>;
  id: Scalars['ID'];
  latestWho5PercentileAverage?: Maybe<Scalars['Int']>;
  member?: Maybe<MemberNode>;
  phq9Score?: Maybe<Scalars['Int']>;
  phq9SelfharmScore?: Maybe<Scalars['Int']>;
  timestamp: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  who5Percentile?: Maybe<Scalars['Int']>;
  who5Score?: Maybe<Scalars['Int']>;
};

export type ContentSubmissionError = BaseSurveyError & {
  __typename?: 'ContentSubmissionError';
  debug: Scalars['String'];
  message: Scalars['String'];
};

export type ContentTagCategoryCreateErrorResponse = {
  __typename?: 'ContentTagCategoryCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagCategoryCreateInput = {
  displayOrder?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type ContentTagCategoryCreateOutput = ContentTagCategoryCreateErrorResponse | ContentTagCategoryCreateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentTagCategoryCreateSuccessResponse = {
  __typename?: 'ContentTagCategoryCreateSuccessResponse';
  contentTagCategory?: Maybe<ContentTagCategoryNode>;
};

export type ContentTagCategoryDeleteErrorResponse = {
  __typename?: 'ContentTagCategoryDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagCategoryDeleteInput = {
  id: Scalars['ID'];
};

export type ContentTagCategoryDeleteOutput = ContentTagCategoryDeleteErrorResponse | ContentTagCategoryDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type ContentTagCategoryDeleteSuccessResponse = {
  __typename?: 'ContentTagCategoryDeleteSuccessResponse';
  contentTagCategory?: Maybe<ContentTagCategoryNode>;
};

export type ContentTagCategoryNode = Node & {
  __typename?: 'ContentTagCategoryNode';
  contentTags: ContentTagNodeConnection;
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  slug: Scalars['String'];
  uuid: Scalars['UUID'];
};


export type ContentTagCategoryNodeContentTagsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ContentTagCategoryUpdateErrorResponse = {
  __typename?: 'ContentTagCategoryUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagCategoryUpdateInput = {
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ContentTagCategoryUpdateOutput = ContentTagCategoryUpdateErrorResponse | ContentTagCategoryUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentTagCategoryUpdateSuccessResponse = {
  __typename?: 'ContentTagCategoryUpdateSuccessResponse';
  contentTagCategory?: Maybe<ContentTagCategoryNode>;
};

export type ContentTagCreateErrorResponse = {
  __typename?: 'ContentTagCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagCreateInput = {
  contentTagCategoryId: Scalars['ID'];
  displayOrder?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ContentTagCreateOutput = ContentTagCreateErrorResponse | ContentTagCreateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentTagCreateSuccessResponse = {
  __typename?: 'ContentTagCreateSuccessResponse';
  contentTag?: Maybe<ContentTagNode>;
};

export type ContentTagDeleteErrorResponse = {
  __typename?: 'ContentTagDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagDeleteInput = {
  id: Scalars['ID'];
};

export type ContentTagDeleteOutput = ContentTagDeleteErrorResponse | ContentTagDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type ContentTagDeleteSuccessResponse = {
  __typename?: 'ContentTagDeleteSuccessResponse';
  contentTag?: Maybe<ContentTagNode>;
};

export type ContentTagListScreenNode = ScreenNodeInterface & {
  __typename?: 'ContentTagListScreenNode';
  description?: Maybe<Scalars['String']>;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type ContentTagNode = Node & {
  __typename?: 'ContentTagNode';
  category: ContentTagCategoryNode;
  contentTagRelations?: Maybe<ContentTagRelationNodeConnection>;
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  slug: Scalars['String'];
  uuid: Scalars['UUID'];
};


export type ContentTagNodeContentTagRelationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  objectType?: Maybe<Scalars['String']>;
};

export type ContentTagNodeConnection = {
  __typename?: 'ContentTagNodeConnection';
  edges: Array<Maybe<ContentTagNodeEdge>>;
  pageInfo: PageInfo;
};

export type ContentTagNodeEdge = {
  __typename?: 'ContentTagNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<ContentTagNode>;
};

export type ContentTagRelatedObject = CourseNode | MeditationNode | ProgramNode;

export type ContentTagRelationCreateErrorResponse = {
  __typename?: 'ContentTagRelationCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagRelationCreateInput = {
  contentTagId: Scalars['ID'];
  displayOrder?: Maybe<Scalars['Int']>;
  objectId: Scalars['String'];
  objectType: ContentTagRelationObjectType;
};

export type ContentTagRelationCreateOutput = ContentTagRelationCreateErrorResponse | ContentTagRelationCreateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentTagRelationCreateSuccessResponse = {
  __typename?: 'ContentTagRelationCreateSuccessResponse';
  contentTagRelation?: Maybe<ContentTagRelationNode>;
};

export type ContentTagRelationDeleteErrorResponse = {
  __typename?: 'ContentTagRelationDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagRelationDeleteInput = {
  id: Scalars['ID'];
};

export type ContentTagRelationDeleteOutput = ContentTagRelationDeleteErrorResponse | ContentTagRelationDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type ContentTagRelationDeleteSuccessResponse = {
  __typename?: 'ContentTagRelationDeleteSuccessResponse';
  contentTagRelation?: Maybe<ContentTagRelationNode>;
};

export type ContentTagRelationNode = Node & {
  __typename?: 'ContentTagRelationNode';
  contentTag: ContentTagNode;
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  objectId: Scalars['String'];
  objectName?: Maybe<Scalars['String']>;
  objectType: ContentTagRelationObjectType;
  relatedObject?: Maybe<ContentTagRelatedObject>;
  uuid: Scalars['UUID'];
};

export type ContentTagRelationNodeConnection = {
  __typename?: 'ContentTagRelationNodeConnection';
  edges: Array<Maybe<ContentTagRelationNodeEdge>>;
  pageInfo: PageInfo;
};

export type ContentTagRelationNodeEdge = {
  __typename?: 'ContentTagRelationNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<ContentTagRelationNode>;
};

export enum ContentTagRelationObjectType {
  Course = 'COURSE',
  Meditation = 'MEDITATION',
  Program = 'PROGRAM'
}

export type ContentTagRelationUpdateErrorResponse = {
  __typename?: 'ContentTagRelationUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagRelationUpdateInput = {
  contentTagId: Scalars['ID'];
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  objectId: Scalars['String'];
  objectType: ContentTagRelationObjectType;
};

export type ContentTagRelationUpdateOutput = ContentTagRelationUpdateErrorResponse | ContentTagRelationUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentTagRelationUpdateSuccessResponse = {
  __typename?: 'ContentTagRelationUpdateSuccessResponse';
  contentTagRelation?: Maybe<ContentTagRelationNode>;
};

export type ContentTagScreenNode = ScreenNodeInterface & {
  __typename?: 'ContentTagScreenNode';
  description?: Maybe<Scalars['String']>;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type ContentTagUpdateErrorResponse = {
  __typename?: 'ContentTagUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTagUpdateInput = {
  contentTagCategoryId: Scalars['ID'];
  displayOrder?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ContentTagUpdateOutput = ContentTagUpdateErrorResponse | ContentTagUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentTagUpdateSuccessResponse = {
  __typename?: 'ContentTagUpdateSuccessResponse';
  contentTag?: Maybe<ContentTagNode>;
};

export type ContentTranslationAvailabilityCreateErrorResponse = {
  __typename?: 'ContentTranslationAvailabilityCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTranslationAvailabilityCreateInput = {
  availabilityState?: Maybe<Scalars['String']>;
  languageId: Scalars['ID'];
  programUuid: Scalars['UUID'];
};

export type ContentTranslationAvailabilityCreateOutput = ContentTranslationAvailabilityCreateErrorResponse | ContentTranslationAvailabilityCreateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentTranslationAvailabilityCreateSuccessResponse = {
  __typename?: 'ContentTranslationAvailabilityCreateSuccessResponse';
  contentTranslationAvailability?: Maybe<ContentTranslationAvailabilityNode>;
};

export type ContentTranslationAvailabilityNode = Node & {
  __typename?: 'ContentTranslationAvailabilityNode';
  availabilityState?: Maybe<Scalars['String']>;
  contentCollection?: Maybe<ContentCollectionNode>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  language?: Maybe<ContentLanguageNode>;
  program?: Maybe<ProgramNode>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type ContentTranslationAvailabilityNodeConnection = {
  __typename?: 'ContentTranslationAvailabilityNodeConnection';
  edges: Array<Maybe<ContentTranslationAvailabilityNodeEdge>>;
  pageInfo: PageInfo;
};

export type ContentTranslationAvailabilityNodeEdge = {
  __typename?: 'ContentTranslationAvailabilityNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<ContentTranslationAvailabilityNode>;
};

export type ContentTranslationAvailabilityUpdateErrorResponse = {
  __typename?: 'ContentTranslationAvailabilityUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ContentTranslationAvailabilityUpdateInput = {
  availabilityState?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ContentTranslationAvailabilityUpdateOutput = ContentTranslationAvailabilityUpdateErrorResponse | ContentTranslationAvailabilityUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type ContentTranslationAvailabilityUpdateSuccessResponse = {
  __typename?: 'ContentTranslationAvailabilityUpdateSuccessResponse';
  contentTranslationAvailability?: Maybe<ContentTranslationAvailabilityNode>;
};

export type ContentTranslationNode = {
  __typename?: 'ContentTranslationNode';
  field: Scalars['String'];
  translationKey: Scalars['String'];
  translationText: Scalars['String'];
};

export enum ContentType {
  Circle = 'CIRCLE',
  Meditation = 'MEDITATION',
  Program = 'PROGRAM'
}

export type ContentUnitNode = {
  __typename?: 'ContentUnitNode';
  contents?: Maybe<Array<ContentNode>>;
  modelMetadata: ModelMetadataNode;
};

export enum ConversationKind {
  Coaching = 'COACHING',
  LiveCoaching = 'LIVE_COACHING',
  Therapy = 'THERAPY'
}

export type ConversationNode = Node & {
  __typename?: 'ConversationNode';
  active: Scalars['Boolean'];
  coach?: Maybe<CoachNode>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  inactiveAt?: Maybe<Scalars['DateTime']>;
  isMatchedOverFiveDaysAgo?: Maybe<Scalars['Boolean']>;
  isNewMatch?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<ConversationKind>;
  member?: Maybe<MemberNode>;
  messages?: Maybe<MessageNodeConnection>;
  myNewestMessage?: Maybe<MessageNode>;
  newestMessage?: Maybe<MessageNode>;
  oldMatchNotContacted?: Maybe<Scalars['Boolean']>;
  oldestMessage?: Maybe<MessageNode>;
  provider?: Maybe<CoachNode>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type ConversationNodeMessagesArgs = {
  acknowledged?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  orderBy?: Maybe<Scalars['String']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  receiverUuid?: Maybe<Scalars['UUID']>;
  senderUuid?: Maybe<Scalars['UUID']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type ConversationNodeConnection = {
  __typename?: 'ConversationNodeConnection';
  edges: Array<Maybe<ConversationNodeEdge>>;
  pageInfo: PageInfo;
};

export type ConversationNodeEdge = {
  __typename?: 'ConversationNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<ConversationNode>;
};

export type CostEstimateNode = {
  __typename?: 'CostEstimateNode';
  coinsurance?: Maybe<Scalars['Float']>;
  copay?: Maybe<Scalars['Float']>;
  error?: Maybe<IneligibleReason>;
  estimatedInsuranceResponsibility?: Maybe<Scalars['Float']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  ineligibleReason?: Maybe<IneligibleReason>;
  outOfPocketRemaining?: Maybe<Scalars['Float']>;
  patientResponsibility?: Maybe<Scalars['Float']>;
  planType?: Maybe<InsurancePlanType>;
  remainingDeductible?: Maybe<Scalars['Float']>;
};

export type CostEstimation = {
  __typename?: 'CostEstimation';
  coinsurance?: Maybe<Scalars['Float']>;
  copay?: Maybe<Scalars['Float']>;
  error?: Maybe<Scalars['String']>;
  estimatedInsuranceResponsibility?: Maybe<Scalars['Float']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  outOfPocketRemaining?: Maybe<Scalars['Float']>;
  patientResponsibility?: Maybe<Scalars['Float']>;
  planType?: Maybe<Scalars['String']>;
  remainingDeductible?: Maybe<Scalars['Float']>;
};

export type CountryNode = {
  __typename?: 'CountryNode';
  alias?: Maybe<Array<Scalars['String']>>;
  displayOrder: Scalars['Int'];
  id: Scalars['ID'];
  isoCode: Scalars['String'];
  name: Scalars['String'];
};

export type CourseActivityGroupCreateErrorResponse = {
  __typename?: 'CourseActivityGroupCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseActivityGroupCreateInput = {
  contentCollectionId?: Maybe<Scalars['ID']>;
  courseSectionId?: Maybe<Scalars['ID']>;
  group: CourseActivityGroupGroup;
  isOptional: Scalars['Boolean'];
};

export type CourseActivityGroupCreateOutput = CourseActivityGroupCreateErrorResponse | CourseActivityGroupCreateSuccessResponse | InternalToolPermissionDeniedError;

export type CourseActivityGroupCreateSuccessResponse = {
  __typename?: 'CourseActivityGroupCreateSuccessResponse';
  courseActivityGroup?: Maybe<CourseActivityGroupNode>;
};

export type CourseActivityGroupDeleteErrorResponse = {
  __typename?: 'CourseActivityGroupDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseActivityGroupDeleteInput = {
  id: Scalars['ID'];
};

export type CourseActivityGroupDeleteOutput = CourseActivityGroupDeleteErrorResponse | CourseActivityGroupDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type CourseActivityGroupDeleteSuccessResponse = {
  __typename?: 'CourseActivityGroupDeleteSuccessResponse';
  courseActivityGroup?: Maybe<CourseActivityGroupNode>;
};

export enum CourseActivityGroupGroup {
  Connect = 'CONNECT',
  Learn = 'LEARN',
  Practice = 'PRACTICE',
  Reflect = 'REFLECT'
}

export type CourseActivityGroupNode = Node & {
  __typename?: 'CourseActivityGroupNode';
  activities: Array<CourseActivityNode>;
  activity: CourseActivityNode;
  collection?: Maybe<ContentCollectionNode>;
  createdAt: Scalars['DateTime'];
  group: CourseActivityGroupGroup;
  groupType?: Maybe<CourseActivityGroupType>;
  id: Scalars['ID'];
  index: Scalars['Int'];
  isOptional: Scalars['Boolean'];
  section: CourseSectionNode;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};


export type CourseActivityGroupNodeActivityArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type CourseActivityGroupNodeConnection = {
  __typename?: 'CourseActivityGroupNodeConnection';
  edges: Array<Maybe<CourseActivityGroupNodeEdge>>;
  pageInfo: PageInfo;
};

export type CourseActivityGroupNodeEdge = {
  __typename?: 'CourseActivityGroupNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<CourseActivityGroupNode>;
};

export enum CourseActivityGroupType {
  Connect = 'CONNECT',
  Learn = 'LEARN',
  Practice = 'PRACTICE',
  Reflect = 'REFLECT'
}

export type CourseActivityGroupUpdateErrorResponse = {
  __typename?: 'CourseActivityGroupUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseActivityGroupUpdateInput = {
  contentCollectionId: Scalars['ID'];
  group: CourseActivityGroupGroup;
  id: Scalars['ID'];
  isOptional: Scalars['Boolean'];
  moveDownInIndex?: Maybe<Scalars['Boolean']>;
  moveUpInIndex?: Maybe<Scalars['Boolean']>;
};

export type CourseActivityGroupUpdateOutput = CourseActivityGroupUpdateErrorResponse | CourseActivityGroupUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type CourseActivityGroupUpdateSuccessResponse = {
  __typename?: 'CourseActivityGroupUpdateSuccessResponse';
  courseActivityGroup?: Maybe<CourseActivityGroupNode>;
};

export type CourseActivityNode = Node & {
  __typename?: 'CourseActivityNode';
  activityGroup: CourseActivityGroupNode;
  contentCollectionLink: ContentLinkNode;
  id: Scalars['ID'];
  isCompleted: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  nextActivity?: Maybe<CourseActivityNode>;
  section: CourseSectionNode;
  uuid: Scalars['UUID'];
};

export enum CourseAvailabilityState {
  Everyone = 'EVERYONE',
  Nobody = 'NOBODY',
  Reviewers = 'REVIEWERS'
}

export type CourseCanNotFinishBeforeStarting = {
  __typename?: 'CourseCanNotFinishBeforeStarting';
  courseId?: Maybe<Scalars['String']>;
  memberId?: Maybe<Scalars['String']>;
};

export type CourseCreateErrorResponse = {
  __typename?: 'CourseCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseCreateInput = {
  courseGraphicHeroId?: Maybe<Scalars['ID']>;
  description: Scalars['String'];
  duration: Scalars['Int'];
  mediaTypeId?: Maybe<Scalars['ID']>;
  subtitle: Scalars['String'];
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  videoContentId?: Maybe<Scalars['ID']>;
};

export type CourseCreateOutput = CourseCreateErrorResponse | CourseCreateSuccessResponse | InternalToolPermissionDeniedError;

export type CourseCreateSuccessResponse = {
  __typename?: 'CourseCreateSuccessResponse';
  course?: Maybe<CourseNode>;
};

export type CourseDeleteErrorResponse = {
  __typename?: 'CourseDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseDeleteInput = {
  id: Scalars['ID'];
};

export type CourseDeleteOutput = CourseDeleteErrorResponse | CourseDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type CourseDeleteSuccessResponse = {
  __typename?: 'CourseDeleteSuccessResponse';
  course?: Maybe<CourseNode>;
};

export type CourseDoesNotExist = {
  __typename?: 'CourseDoesNotExist';
  id?: Maybe<Scalars['String']>;
};

export type CourseGraphicHeroNode = Node & {
  __typename?: 'CourseGraphicHeroNode';
  backgroundColor?: Maybe<Scalars['String']>;
  graphic: ImageNode;
  id: Scalars['ID'];
  uuid: Scalars['UUID'];
};

export type CourseGuideNode = Node & {
  __typename?: 'CourseGuideNode';
  coach?: Maybe<CoachNode>;
  course: CourseNode;
  id: Scalars['ID'];
  provider?: Maybe<CoachNode>;
};

export type CourseGuideNodeConnection = {
  __typename?: 'CourseGuideNodeConnection';
  edges: Array<Maybe<CourseGuideNodeEdge>>;
  pageInfo: PageInfo;
};

export type CourseGuideNodeEdge = {
  __typename?: 'CourseGuideNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<CourseGuideNode>;
};

export type CourseHeroNode = CourseGraphicHeroNode | ImageNode | VideoContentNode;

export type CourseLinkNode = Node & {
  __typename?: 'CourseLinkNode';
  banner?: Maybe<ContentBannerNode>;
  course: CourseNode;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  mediaType?: Maybe<MediaTypeNode>;
  mobileValue?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type CourseNode = Node & {
  __typename?: 'CourseNode';
  availabilityState: CourseAvailabilityState;
  banner?: Maybe<ContentBannerNode>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  duration: Scalars['Int'];
  guideNodes: Array<CourseGuideNode>;
  guides: Array<CoachNode>;
  hero?: Maybe<CourseHeroNode>;
  id: Scalars['ID'];
  isNew: Scalars['Boolean'];
  isSearchable?: Maybe<Scalars['Boolean']>;
  mediaType?: Maybe<MediaTypeNode>;
  outcomes: Array<CourseOutcomeNode>;
  progress: CourseProgressNode;
  progressPercent: Scalars['Int'];
  searchKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  sections: Array<CourseSectionNode>;
  slug: Scalars['String'];
  subtitle: Scalars['String'];
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type CourseNodeConnection = {
  __typename?: 'CourseNodeConnection';
  edges: Array<Maybe<CourseNodeEdge>>;
  pageInfo: PageInfo;
};

export type CourseNodeEdge = {
  __typename?: 'CourseNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<CourseNode>;
};

export type CourseOutcomeCreateErrorResponse = {
  __typename?: 'CourseOutcomeCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseOutcomeCreateInput = {
  courseId?: Maybe<Scalars['ID']>;
  icon?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export type CourseOutcomeCreateOutput = CourseOutcomeCreateErrorResponse | CourseOutcomeCreateSuccessResponse | InternalToolPermissionDeniedError;

export type CourseOutcomeCreateSuccessResponse = {
  __typename?: 'CourseOutcomeCreateSuccessResponse';
  courseOutcome?: Maybe<CourseOutcomeNode>;
};

export type CourseOutcomeDeleteErrorResponse = {
  __typename?: 'CourseOutcomeDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseOutcomeDeleteInput = {
  id: Scalars['ID'];
};

export type CourseOutcomeDeleteOutput = CourseOutcomeDeleteErrorResponse | CourseOutcomeDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type CourseOutcomeDeleteSuccessResponse = {
  __typename?: 'CourseOutcomeDeleteSuccessResponse';
  courseOutcome?: Maybe<CourseOutcomeNode>;
};

export type CourseOutcomeNode = Node & {
  __typename?: 'CourseOutcomeNode';
  createdAt: Scalars['DateTime'];
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  text: Scalars['String'];
  textTranslationKey?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type CourseOutcomeUpdateErrorResponse = {
  __typename?: 'CourseOutcomeUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseOutcomeUpdateInput = {
  icon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type CourseOutcomeUpdateOutput = CourseOutcomeUpdateErrorResponse | CourseOutcomeUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type CourseOutcomeUpdateSuccessResponse = {
  __typename?: 'CourseOutcomeUpdateSuccessResponse';
  courseOutcome?: Maybe<CourseOutcomeNode>;
};

export type CourseProgressMutationInput = {
  activityGroupId: Scalars['ID'];
  activityId: Scalars['ID'];
  courseId: Scalars['ID'];
  platform?: Maybe<Scalars['String']>;
  sectionId: Scalars['ID'];
};

export type CourseProgressMutationOutput = ActivityDoesNotExist | ActivityGroupDoesNotExist | CourseCanNotFinishBeforeStarting | CourseDoesNotExist | CourseProgressMutationResponse | SectionDoesNotExist;

export type CourseProgressMutationResponse = {
  __typename?: 'CourseProgressMutationResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CourseProgressNode = {
  __typename?: 'CourseProgressNode';
  completed: Scalars['Int'];
  completedAt?: Maybe<Scalars['DateTime']>;
  remaining: Scalars['Int'];
  startedAt?: Maybe<Scalars['DateTime']>;
  total: Scalars['Int'];
};

export type CourseSectionCreateErrorResponse = {
  __typename?: 'CourseSectionCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseSectionCreateInput = {
  courseId?: Maybe<Scalars['ID']>;
  subtitle: Scalars['String'];
  title: Scalars['String'];
};

export type CourseSectionCreateOutput = CourseSectionCreateErrorResponse | CourseSectionCreateSuccessResponse | InternalToolPermissionDeniedError;

export type CourseSectionCreateSuccessResponse = {
  __typename?: 'CourseSectionCreateSuccessResponse';
  courseSection?: Maybe<CourseSectionNode>;
};

export type CourseSectionDeleteErrorResponse = {
  __typename?: 'CourseSectionDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseSectionDeleteInput = {
  id: Scalars['ID'];
};

export type CourseSectionDeleteOutput = CourseSectionDeleteErrorResponse | CourseSectionDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type CourseSectionDeleteSuccessResponse = {
  __typename?: 'CourseSectionDeleteSuccessResponse';
  courseSection?: Maybe<CourseSectionNode>;
};

export type CourseSectionDoesNotExist = {
  __typename?: 'CourseSectionDoesNotExist';
  id?: Maybe<Scalars['ID']>;
};

export type CourseSectionNode = Node & {
  __typename?: 'CourseSectionNode';
  activityGroups: Array<CourseActivityGroupNode>;
  course: CourseNode;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  isCompleted: Scalars['Boolean'];
  isLocked: Scalars['Boolean'];
  slug: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type CourseSectionReviewInput = {
  feedbackText?: Maybe<Scalars['String']>;
  improvedMyWellBeing?: Maybe<Scalars['Int']>;
  rating: Scalars['Int'];
  sectionId: Scalars['ID'];
  trustTheCourse?: Maybe<Scalars['Int']>;
  whatYouLikedAboutThisSection?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CourseSectionReviewResponse = {
  __typename?: 'CourseSectionReviewResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CourseSectionUpdateErrorResponse = {
  __typename?: 'CourseSectionUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseSectionUpdateInput = {
  id: Scalars['ID'];
  moveDownInIndex?: Maybe<Scalars['Boolean']>;
  moveUpInIndex?: Maybe<Scalars['Boolean']>;
  subtitle: Scalars['String'];
  title: Scalars['String'];
};

export type CourseSectionUpdateOutput = CourseSectionUpdateErrorResponse | CourseSectionUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type CourseSectionUpdateSuccessResponse = {
  __typename?: 'CourseSectionUpdateSuccessResponse';
  courseSection?: Maybe<CourseSectionNode>;
};

export type CourseUpdateErrorResponse = {
  __typename?: 'CourseUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type CourseUpdateInput = {
  availabilityState: CourseAvailabilityState;
  description: Scalars['String'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  mediaTypeId?: Maybe<Scalars['ID']>;
  subtitle: Scalars['String'];
  thumbnailImageUrl?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CourseUpdateOutput = CourseUpdateErrorResponse | CourseUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type CourseUpdateSuccessResponse = {
  __typename?: 'CourseUpdateSuccessResponse';
  course?: Maybe<CourseNode>;
};

export type CoursesScreenNode = ScreenNodeInterface & {
  __typename?: 'CoursesScreenNode';
  description?: Maybe<Scalars['String']>;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type CptCodeNode = {
  __typename?: 'CptCodeNode';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
};

export type CreateAccountDeletionRequest = {
  __typename?: 'CreateAccountDeletionRequest';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateClientBucketInput = {
  automated: Scalars['Boolean'];
  bucketName: Scalars['String'];
  companyFolder?: Maybe<Scalars['String']>;
  companyUuid: Scalars['UUID'];
  notifyAccountUuid: Scalars['UUID'];
};

export type CreateClientBucketResponse = {
  __typename?: 'CreateClientBucketResponse';
  clientBucket?: Maybe<ClientBucketNode>;
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type CreateCoachingVisitMemberReviewMutation = {
  __typename?: 'CreateCoachingVisitMemberReviewMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateConversationMutation = {
  __typename?: 'CreateConversationMutation';
  conversation?: Maybe<ConversationNode>;
};

export type CreateCourseGuideMutationErrorResponse = {
  __typename?: 'CreateCourseGuideMutationErrorResponse';
  message: Scalars['String'];
};

export type CreateCourseGuideMutationInput = {
  courseId: Scalars['ID'];
  providerUuid: Scalars['UUID'];
};

export type CreateCourseGuideMutationOutput = CreateCourseGuideMutationErrorResponse | CreateCourseGuideMutationSuccessResponse;

export type CreateCourseGuideMutationSuccessResponse = {
  __typename?: 'CreateCourseGuideMutationSuccessResponse';
  guide?: Maybe<CourseGuideNode>;
};

export type CreateCourseHeroMutationErrorResponse = {
  __typename?: 'CreateCourseHeroMutationErrorResponse';
  message: Scalars['String'];
};

export type CreateCourseHeroMutationInput = {
  backgroundColor?: Maybe<Scalars['String']>;
  courseId: Scalars['ID'];
  imageAltText?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  videoPoster?: Maybe<Scalars['String']>;
  videoSourceHorizontal?: Maybe<Scalars['String']>;
  videoSourceVertical?: Maybe<Scalars['String']>;
  videoTextTrack?: Maybe<Scalars['String']>;
  videoTitle?: Maybe<Scalars['String']>;
};

export type CreateCourseHeroMutationOutput = CreateCourseHeroMutationErrorResponse | CreateCourseHeroMutationSuccessResponse;

export type CreateCourseHeroMutationSuccessResponse = {
  __typename?: 'CreateCourseHeroMutationSuccessResponse';
  hero?: Maybe<CourseHeroNode>;
};

export type CreateEditCompanyAdditionalBenefitOutput = CreateEditCompanyAdditionalBenefitSuccessResponse | InternalToolPermissionDeniedError;

export type CreateEditCompanyAdditionalBenefitSuccessResponse = {
  __typename?: 'CreateEditCompanyAdditionalBenefitSuccessResponse';
  companyAdditionalBenefit?: Maybe<AllCompanyAdditionalBenefitNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateEditCompanySegmentOutput = CreateEditCompanySegmentSuccessResponse | InternalToolPermissionDeniedError;

export type CreateEditCompanySegmentSuccessResponse = {
  __typename?: 'CreateEditCompanySegmentSuccessResponse';
  companySegment?: Maybe<CompanySegmentNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateEditCrisisProviderCompanyAssignmentOutput = CreateEditCrisisProviderCompanyAssignmentSuccessResponse | InternalToolPermissionDeniedError;

export type CreateEditCrisisProviderCompanyAssignmentSuccessResponse = {
  __typename?: 'CreateEditCrisisProviderCompanyAssignmentSuccessResponse';
  crisisProviderCompanyAssignment?: Maybe<CrisisProviderCompanyAssignmentNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateEditCrisisProviderCountryAssignmentOutput = CreateEditCrisisProviderCountryAssignmentSuccessResponse | InternalToolPermissionDeniedError;

export type CreateEditCrisisProviderCountryAssignmentSuccessResponse = {
  __typename?: 'CreateEditCrisisProviderCountryAssignmentSuccessResponse';
  crisisProviderCountryAssignment?: Maybe<CrisisProviderCountryAssignmentNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateEditCrisisProviderOutput = CreateEditCrisisProviderSuccessResponse | InternalToolPermissionDeniedError;

export type CreateEditCrisisProviderSuccessResponse = {
  __typename?: 'CreateEditCrisisProviderSuccessResponse';
  crisisProvider?: Maybe<CrisisProviderNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateEligibilityCheckCoachingVisit = {
  coachingVisitUuid: Scalars['UUID'];
  productType?: Maybe<Scalars['String']>;
  scheduledTime: Scalars['DateTime'];
};

export type CreateEligibilityCheckCoachingVisitForMember = {
  coachingVisitUuid: Scalars['UUID'];
  memberUuid: Scalars['UUID'];
  productType?: Maybe<Scalars['String']>;
  scheduledTime: Scalars['DateTime'];
};

export type CreateEligibilityCheckCoachingVisitResponse = {
  __typename?: 'CreateEligibilityCheckCoachingVisitResponse';
  eligibilityCheck?: Maybe<EligibilityCheckNode>;
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type CreateEventFormattedResponse = CreateEventResult | ExpectedError;

export type CreateEventMutation = {
  __typename?: 'CreateEventMutation';
  formattedResponse?: Maybe<CreateEventFormattedResponse>;
  /** @deprecated Please use the formatted_response field */
  ok?: Maybe<Scalars['Boolean']>;
  patientResponsibility?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  /** @deprecated Please use the formatted_response field */
  uuid?: Maybe<Scalars['UUID']>;
};

export type CreateEventResult = {
  __typename?: 'CreateEventResult';
  costEstimation?: Maybe<CostEstimation>;
  ok?: Maybe<Scalars['Boolean']>;
  patientResponsibility?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type CreateMemberPathwayMutationInput = {
  pathwayUuid: Scalars['UUID'];
};

export type CreateMemberPathwayMutationResponse = {
  __typename?: 'CreateMemberPathwayMutationResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateNotificationMutation = {
  __typename?: 'CreateNotificationMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateOrUpdateEmployerCptRateInput = {
  employerCptRates: Array<Maybe<EmployerCptRateInput>>;
  employerInsurance: Scalars['Int'];
};

export type CreateOrUpdateEmployerCptRateResponse = {
  __typename?: 'CreateOrUpdateEmployerCptRateResponse';
  employerCptRates?: Maybe<Array<Maybe<EmployerCptRate>>>;
  ok: Scalars['Boolean'];
};

export type CreateOrUpdateEmployerInsuranceInput = {
  benefitEndDate: Scalars['DateTime'];
  benefitStartDate: Scalars['DateTime'];
  claimCpid?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  companyUuid: Scalars['UUID'];
  controlNumber: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  insuranceCompany: Scalars['Int'];
  renderingProviderType: RenderingProviderType;
  useAccumulatorConfiguration: Scalars['Boolean'];
};

export type CreateOrUpdateEmployerInsuranceResponse = {
  __typename?: 'CreateOrUpdateEmployerInsuranceResponse';
  employerInsurance?: Maybe<EmployerInsurance>;
  ok: Scalars['Boolean'];
};

export type CreateOrUpdateInsuranceCompanyInput = {
  cpid: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  payerId: Scalars['String'];
};

export type CreateOrUpdateInsuranceCompanyResponse = {
  __typename?: 'CreateOrUpdateInsuranceCompanyResponse';
  insuranceCompany?: Maybe<InsuranceCompanyNode>;
  ok: Scalars['Boolean'];
};

export type CreateOrUpdatePayerInformationInput = {
  addressOne: Scalars['String'];
  addressTwo?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  lastNameOne: Scalars['String'];
  lastNameTwo?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type CreateOrUpdateProviderReview = {
  __typename?: 'CreateOrUpdateProviderReview';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateOrUpdatePsychiatristReview = {
  __typename?: 'CreateOrUpdatePsychiatristReview';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreatePatientIntakeFormInput = {
  formTemplateId?: Maybe<Scalars['ID']>;
  providerMatchUuid?: Maybe<Scalars['UUID']>;
};

export type CreateProviderReview = {
  __typename?: 'CreateProviderReview';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreatePsychiatryVisitMemberReviewMutation = {
  __typename?: 'CreatePsychiatryVisitMemberReviewMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateTestEligiblePersonResult = {
  __typename?: 'CreateTestEligiblePersonResult';
  eligiblePerson: EligiblePersonNode;
  signUpToken: SignUpTokenDetailsNode;
};

export type CreateTestMemberResult = {
  __typename?: 'CreateTestMemberResult';
  member?: Maybe<TestMemberNode>;
};

export type CreateTestPammMatch = {
  __typename?: 'CreateTestPammMatch';
  ok?: Maybe<Scalars['Boolean']>;
};

export type CreateTestProviderResult = {
  __typename?: 'CreateTestProviderResult';
  provider?: Maybe<TestProviderNode>;
};

export type CreateVisitMutation = {
  __typename?: 'CreateVisitMutation';
  coachingVisitUuid?: Maybe<Scalars['UUID']>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type CrisisProviderCompanyAssignmentNode = {
  __typename?: 'CrisisProviderCompanyAssignmentNode';
  company: CompanyDropdownNode;
  createdAt?: Maybe<Scalars['DateTime']>;
  crisisProvider: CrisisProviderNode;
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  uuid: Scalars['UUID'];
};

export type CrisisProviderCountryAssignmentNode = {
  __typename?: 'CrisisProviderCountryAssignmentNode';
  country: CountryNode;
  createdAt?: Maybe<Scalars['DateTime']>;
  crisisProvider: CrisisProviderNode;
  id: Scalars['ID'];
  phoneNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uuid: Scalars['UUID'];
};

export type CrisisProviderNode = {
  __typename?: 'CrisisProviderNode';
  companyAssignments?: Maybe<Array<Maybe<CrisisProviderCompanyAssignmentNode>>>;
  countryAssignments?: Maybe<Array<Maybe<CrisisProviderCountryAssignmentNode>>>;
  defaultPhoneNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type DailyPauseCalendarReminder = {
  __typename?: 'DailyPauseCalendarReminder';
  eventData: CalendarEventNode;
  googleCalendarUrl: Scalars['String'];
  icsUrl: Scalars['String'];
};

export type DataDefinedScreenNode = ScreenNodeInterface & {
  __typename?: 'DataDefinedScreenNode';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  designatedApplication: ScreenDesignatedApplication;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<GenericScreenNode>;
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type DataDefinedScreenSectionNode = Node & {
  __typename?: 'DataDefinedScreenSectionNode';
  collection: ContentCollectionNode;
  contentCollectionLinks: Array<ContentLinkNode>;
  createdAt: Scalars['DateTime'];
  ctaContentLink?: Maybe<ContentCollectionLinkNode>;
  ctaLink?: Maybe<ContentLinkNode>;
  ctaLinkText?: Maybe<Scalars['String']>;
  ctaLinkTextTranslationKey?: Maybe<Scalars['String']>;
  englishLanguageVisibility?: Maybe<EnglishLanguageVisibility>;
  id: Scalars['ID'];
  index: Scalars['Int'];
  maxContent: Scalars['Int'];
  minContent?: Maybe<Scalars['Int']>;
  minimumMobileVersion: Scalars['String'];
  renderComponent?: Maybe<ContentCollectionRenderComponent>;
  screen: GenericScreenNode;
  showTitle: Scalars['Boolean'];
  slug?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  subtitleTranslationKey?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  titleTranslationKey: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type DataDefinedScreenSectionNodeConnection = {
  __typename?: 'DataDefinedScreenSectionNodeConnection';
  edges: Array<Maybe<DataDefinedScreenSectionNodeEdge>>;
  pageInfo: PageInfo;
};

export type DataDefinedScreenSectionNodeEdge = {
  __typename?: 'DataDefinedScreenSectionNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<DataDefinedScreenSectionNode>;
};



export type DeleteCalendarProfileMutation = {
  __typename?: 'DeleteCalendarProfileMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteCompanyAdditionalBenefitOutput = DeleteCompanyAdditionalBenefitSuccessResponse | InternalToolPermissionDeniedError;

export type DeleteCompanyAdditionalBenefitSuccessResponse = {
  __typename?: 'DeleteCompanyAdditionalBenefitSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteCourseGuideMutationErrorResponse = {
  __typename?: 'DeleteCourseGuideMutationErrorResponse';
  message: Scalars['String'];
};

export type DeleteCourseGuideMutationInput = {
  guideId: Scalars['ID'];
};

export type DeleteCourseGuideMutationOutput = DeleteCourseGuideMutationErrorResponse | DeleteCourseGuideMutationSuccessResponse;

export type DeleteCourseGuideMutationSuccessResponse = {
  __typename?: 'DeleteCourseGuideMutationSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteCourseHeroMutationErrorResponse = {
  __typename?: 'DeleteCourseHeroMutationErrorResponse';
  message: Scalars['String'];
};

export type DeleteCourseHeroMutationInput = {
  courseId: Scalars['ID'];
};

export type DeleteCourseHeroMutationOutput = DeleteCourseHeroMutationErrorResponse | DeleteCourseHeroMutationSuccessResponse;

export type DeleteCourseHeroMutationSuccessResponse = {
  __typename?: 'DeleteCourseHeroMutationSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteTestMember = {
  __typename?: 'DeleteTestMember';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DeleteTestProvider = {
  __typename?: 'DeleteTestProvider';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum DeviceCategory {
  Dhcs = 'DHCS',
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export enum DifficultyAgreement {
  Agree = 'AGREE',
  Disagree = 'DISAGREE',
  NeitherDisagreeOrAgree = 'NEITHER_DISAGREE_OR_AGREE',
  StronglyAgree = 'STRONGLY_AGREE',
  StronglyDisagree = 'STRONGLY_DISAGREE'
}

export type DisableHrAdminMutationResult = DisableHrAdminSuccessOutput | PermissionDeniedError | UnknownHrAdminError;

export type DisableHrAdminSuccessOutput = {
  __typename?: 'DisableHRAdminSuccessOutput';
  hrAdmin?: Maybe<HrAdminNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type DownloadAppMutation = {
  __typename?: 'DownloadAppMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type DxCodeNode = {
  __typename?: 'DxCodeNode';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dsm?: Maybe<Scalars['String']>;
  isPrimaryDiagnosisCode?: Maybe<Scalars['Boolean']>;
  primaryGroup?: Maybe<Scalars['String']>;
  secondaryGroup?: Maybe<Scalars['String']>;
};

export type EditHrAdminRoleMutationResult = EditHrAdminRoleSuccessOutput | InvalidRoleError | PermissionDeniedError | UnknownHrAdminError;

export type EditHrAdminRoleSuccessOutput = {
  __typename?: 'EditHRAdminRoleSuccessOutput';
  hrAdmin?: Maybe<HrAdminNode>;
};

export type EligibilityCheckNode = {
  __typename?: 'EligibilityCheckNode';
  costEstimation: CostEstimateNode;
  error?: Maybe<Scalars['String']>;
  isEligible: Scalars['Boolean'];
  patientResponsibility: Scalars['Float'];
};

export type EligibilityStatusNode = {
  __typename?: 'EligibilityStatusNode';
  error?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['DateTime']>;
  isEligible?: Maybe<Scalars['Boolean']>;
};

export type EligiblePersonNode = {
  __typename?: 'EligiblePersonNode';
  company?: Maybe<CompanyDropdownNode>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  ineligible: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type EmailRoleInput = {
  email: Scalars['String'];
  role: Scalars['String'];
};

export type EmployerCptRate = {
  __typename?: 'EmployerCptRate';
  code: Scalars['String'];
  cptCodeType: Scalars['Int'];
  description: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  psychiatryVisitType?: Maybe<Scalars['String']>;
  qualifier: Scalars['String'];
  rate?: Maybe<Scalars['Float']>;
  serviceType: ServiceType;
};

export type EmployerCptRateInput = {
  cptCodeType: Scalars['Int'];
  id?: Maybe<Scalars['Int']>;
  rate: Scalars['Float'];
};

export type EmployerInsurance = {
  __typename?: 'EmployerInsurance';
  accumulatorConfiguration?: Maybe<Scalars['Int']>;
  benefitEndDate: Scalars['DateTime'];
  benefitStartDate: Scalars['DateTime'];
  claimCpid?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  companyUuid: Scalars['UUID'];
  controlNumber: Scalars['String'];
  id: Scalars['Int'];
  insuranceCompany: Scalars['Int'];
  renderingProviderType: RenderingProviderType;
};

export type EmployerInsuranceNode = {
  __typename?: 'EmployerInsuranceNode';
  accumulatorConfiguration?: Maybe<Scalars['Int']>;
  benefitEndDate?: Maybe<Scalars['DateTime']>;
  benefitStartDate?: Maybe<Scalars['DateTime']>;
  claimCpid?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  companyUuid: Scalars['UUID'];
  controlNumber: Scalars['String'];
  employerInsuranceId: Scalars['Int'];
  insuranceCompany: Scalars['Int'];
  name: Scalars['String'];
  policyNumber?: Maybe<Scalars['String']>;
  renderingProviderType: RenderingProviderType;
  therapyCptRatesSet?: Maybe<Scalars['Boolean']>;
};

export type EmployerValidationConfigNode = {
  __typename?: 'EmployerValidationConfigNode';
  error?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
};

export type EncryptionError = BaseError & {
  __typename?: 'EncryptionError';
  debug?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export enum EnglishLanguageVisibility {
  All = 'ALL',
  EnglishOnly = 'ENGLISH_ONLY',
  NonEnglishOnly = 'NON_ENGLISH_ONLY'
}

export type ExpectedError = {
  __typename?: 'ExpectedError';
  debug?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

export type ExploreCareOptionsScreenNode = ScreenNodeInterface & {
  __typename?: 'ExploreCareOptionsScreenNode';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  designatedApplication: ScreenDesignatedApplication;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<GenericScreenNode>;
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type ExploreScreenNode = ScreenNodeInterface & {
  __typename?: 'ExploreScreenNode';
  activities?: Maybe<ScreenSectionNode>;
  description?: Maybe<Scalars['String']>;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  topics: Array<ScreenSectionNode>;
  uuid: Scalars['UUID'];
};

export type ExternalLinkNode = Node & {
  __typename?: 'ExternalLinkNode';
  banner?: Maybe<ContentBannerNode>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  mediaType?: Maybe<MediaTypeNode>;
  mobileValue?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  subtitleTranslationKey?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  titleTranslationKey: Scalars['String'];
  url: Scalars['String'];
  uuid: Scalars['UUID'];
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type FeatureInvalidFeedbackChoice = {
  __typename?: 'FeatureInvalidFeedbackChoice';
  feedbackChoice?: Maybe<Scalars['String']>;
};

export type FeatureRecordDoesNotExist = {
  __typename?: 'FeatureRecordDoesNotExist';
  name?: Maybe<Scalars['String']>;
};

export type FeatureRecordReviewInput = {
  featureRecordName: Scalars['String'];
  feedbackChoice?: Maybe<Scalars['String']>;
  feedbackText?: Maybe<Scalars['String']>;
  isUseful?: Maybe<Scalars['Boolean']>;
};

export type FeatureRecordReviewResponse = {
  __typename?: 'FeatureRecordReviewResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type FeaturedBenefit = {
  __typename?: 'FeaturedBenefit';
  color?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** @deprecated Use uuid instead */
  id?: Maybe<Scalars['Int']>;
  imageUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  /** @deprecated Field no longer used. */
  needHelp?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export enum FeelingsAboutTherapyEnum {
  Committed = 'COMMITTED',
  Hesitant = 'HESITANT',
  Neutral = 'NEUTRAL'
}

export type FlushModelCacheResponse = {
  __typename?: 'FlushModelCacheResponse';
  errors?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type ForYouScreenNode = ScreenNodeInterface & {
  __typename?: 'ForYouScreenNode';
  actionsSection: ScreenSectionNode;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  designatedApplication: ScreenDesignatedApplication;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<GenericScreenNode>;
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};


export type GenericScreenNode = Node & {
  __typename?: 'GenericScreenNode';
  children: GenericScreenNodeConnection;
  collections: ContentCollectionNodeConnection;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  designatedApplication: ScreenDesignatedApplication;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentCollectionLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mobileMediaTypes: MediaTypeNodeConnection;
  name: Scalars['String'];
  parent?: Maybe<GenericScreenNode>;
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  sections: DataDefinedScreenSectionNodeConnection;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
  webMediaTypes: MediaTypeNodeConnection;
};


export type GenericScreenNodeChildrenArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GenericScreenNodeCollectionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GenericScreenNodeMobileMediaTypesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GenericScreenNodeSectionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type GenericScreenNodeWebMediaTypesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type GenericScreenNodeConnection = {
  __typename?: 'GenericScreenNodeConnection';
  edges: Array<Maybe<GenericScreenNodeEdge>>;
  pageInfo: PageInfo;
};

export type GenericScreenNodeEdge = {
  __typename?: 'GenericScreenNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<GenericScreenNode>;
};

export type GetAllReportsAndSectionsResult = GetAllReportsAndSectionsSuccessResult | LookerReportError | PermissionDeniedError;

export type GetAllReportsAndSectionsSuccessResult = {
  __typename?: 'GetAllReportsAndSectionsSuccessResult';
  reportsOrSections: Array<Maybe<PossibleReportAndSectionType>>;
};

export type GetMemberCostEstimate = {
  dateOfBirth: Scalars['DateTime'];
  employerInsuranceId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  policyMemberId: Scalars['String'];
};

export type GetOrCreateCoachingVisitVideoSessionMutation = {
  __typename?: 'GetOrCreateCoachingVisitVideoSessionMutation';
  videoSession?: Maybe<VideoSessionNode>;
};

export type GroupPracticeNode = {
  __typename?: 'GroupPracticeNode';
  providers?: Maybe<Array<Maybe<CoachNode>>>;
  uuid: Scalars['UUID'];
};

export type HrAdminAlreadyExistsError = BaseError & {
  __typename?: 'HRAdminAlreadyExistsError';
  debug?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type HrAdminCreateErrorResponse = {
  __typename?: 'HRAdminCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrAdminCreateInput = {
  isModernHealthCsm: Scalars['Boolean'];
  roleId: Scalars['ID'];
  userEmail: Scalars['String'];
};

export type HrAdminCreateOutput = HrAdminCreateErrorResponse | HrAdminCreateSuccessResponse | InternalToolPermissionDeniedError;

export type HrAdminCreateSuccessResponse = {
  __typename?: 'HRAdminCreateSuccessResponse';
  hrAdmin?: Maybe<HrAdminNode>;
};

export type HrAdminDeleteErrorResponse = {
  __typename?: 'HRAdminDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrAdminDeleteInput = {
  id: Scalars['ID'];
};

export type HrAdminDeleteOutput = HrAdminDeleteErrorResponse | HrAdminDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type HrAdminDeleteSuccessResponse = {
  __typename?: 'HRAdminDeleteSuccessResponse';
  hrAdmin?: Maybe<HrAdminNode>;
};

export type HrAdminNode = Node & {
  __typename?: 'HRAdminNode';
  disabled?: Maybe<Scalars['Boolean']>;
  disabledAt?: Maybe<Scalars['DateTime']>;
  eligiblePersons?: Maybe<Array<Maybe<EligiblePersonNode>>>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isModernHealthCsm: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  role: HrAdminRoleNode;
  uuid: Scalars['UUID'];
};

export type HrAdminOutput = HrAdminResponse | InternalToolPermissionDeniedError;

export enum HrAdminPermission {
  AccountsManage = 'ACCOUNTS_MANAGE',
  AccountsView = 'ACCOUNTS_VIEW',
  BenefitsManage = 'BENEFITS_MANAGE',
  BenefitsView = 'BENEFITS_VIEW',
  HrisManage = 'HRIS_MANAGE',
  HrisView = 'HRIS_VIEW',
  InsightsView = 'INSIGHTS_VIEW',
  ResourceView = 'RESOURCE_VIEW',
  SegmentsManage = 'SEGMENTS_MANAGE',
  SegmentsView = 'SEGMENTS_VIEW'
}

export type HrAdminResponse = {
  __typename?: 'HRAdminResponse';
  hrAdmin?: Maybe<HrAdminNode>;
};

export type HrAdminResult = {
  __typename?: 'HRAdminResult';
  results?: Maybe<Array<Maybe<HrAdminNode>>>;
};

export type HrAdminRoleCreateErrorResponse = {
  __typename?: 'HRAdminRoleCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrAdminRoleCreateInput = {
  description: Scalars['String'];
  displayOrder: Scalars['Int'];
  hidden: Scalars['Boolean'];
  name: Scalars['String'];
  permissions: Array<HrAdminPermission>;
};

export type HrAdminRoleCreateOutput = HrAdminRoleCreateErrorResponse | HrAdminRoleCreateSuccessResponse | InternalToolPermissionDeniedError;

export type HrAdminRoleCreateSuccessResponse = {
  __typename?: 'HRAdminRoleCreateSuccessResponse';
  hrAdminRole?: Maybe<HrAdminRoleNode>;
};

export type HrAdminRoleDeleteErrorResponse = {
  __typename?: 'HRAdminRoleDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrAdminRoleDeleteInput = {
  id: Scalars['ID'];
};

export type HrAdminRoleDeleteOutput = HrAdminRoleDeleteErrorResponse | HrAdminRoleDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type HrAdminRoleDeleteSuccessResponse = {
  __typename?: 'HRAdminRoleDeleteSuccessResponse';
  hrAdminRole?: Maybe<HrAdminRoleNode>;
};

export type HrAdminRoleNode = Node & {
  __typename?: 'HRAdminRoleNode';
  description: Scalars['String'];
  displayOrder: Scalars['Int'];
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  key: Scalars['String'];
  name: Scalars['String'];
  permissions: Array<HrAdminPermission>;
  uuid: Scalars['UUID'];
};

export type HrAdminRoleOutput = HrAdminRoleResponse | InternalToolPermissionDeniedError;

export type HrAdminRoleResponse = {
  __typename?: 'HRAdminRoleResponse';
  hrAdminRole?: Maybe<HrAdminRoleNode>;
};

export type HrAdminRoleUpdateErrorResponse = {
  __typename?: 'HRAdminRoleUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrAdminRoleUpdateInput = {
  description: Scalars['String'];
  displayOrder: Scalars['Int'];
  hidden: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  permissions: Array<HrAdminPermission>;
};

export type HrAdminRoleUpdateOutput = HrAdminRoleUpdateErrorResponse | HrAdminRoleUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type HrAdminRoleUpdateSuccessResponse = {
  __typename?: 'HRAdminRoleUpdateSuccessResponse';
  hrAdminRole?: Maybe<HrAdminRoleNode>;
};

export type HrAdminUpdateErrorResponse = {
  __typename?: 'HRAdminUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrAdminUpdateInput = {
  disabled: Scalars['Boolean'];
  id: Scalars['ID'];
  isModernHealthCsm: Scalars['Boolean'];
  roleId: Scalars['ID'];
};

export type HrAdminUpdateOutput = HrAdminUpdateErrorResponse | HrAdminUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type HrAdminUpdateSuccessResponse = {
  __typename?: 'HRAdminUpdateSuccessResponse';
  hrAdmin?: Maybe<HrAdminNode>;
};

export type HrCompanySegmentInput = {
  name: Scalars['String'];
  uuid?: Maybe<Scalars['UUID']>;
};

export type HrCreateEditCompanyAdditionalBenefitMutation = {
  __typename?: 'HRCreateEditCompanyAdditionalBenefitMutation';
  companyAdditionalBenefit?: Maybe<CompanyAdditionalBenefitNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type HrCreateEditCompanySegmentMutation = {
  __typename?: 'HRCreateEditCompanySegmentMutation';
  companySegment?: Maybe<CompanySegmentNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type HrDeleteCompanyAdditionalBenefitMutation = {
  __typename?: 'HRDeleteCompanyAdditionalBenefitMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type HrDeleteCompanySegmentMutation = {
  __typename?: 'HRDeleteCompanySegmentMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type HrEventCreateErrorResponse = {
  __typename?: 'HREventCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrEventCreateInput = {
  descriptiveDate: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  intendedAudience: HrResourceIntendedAudience;
  status: HrEventStatus;
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type HrEventCreateOutput = HrEventCreateErrorResponse | HrEventCreateSuccessResponse | InternalToolPermissionDeniedError;

export type HrEventCreateSuccessResponse = {
  __typename?: 'HREventCreateSuccessResponse';
  hrEvent?: Maybe<HrEventNode>;
};

export type HrEventDeleteErrorResponse = {
  __typename?: 'HREventDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrEventDeleteInput = {
  id: Scalars['ID'];
};

export type HrEventDeleteOutput = HrEventDeleteErrorResponse | HrEventDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type HrEventDeleteSuccessResponse = {
  __typename?: 'HREventDeleteSuccessResponse';
  hrEvent?: Maybe<HrEventNode>;
};

export type HrEventLinkNode = Node & {
  __typename?: 'HREventLinkNode';
  banner?: Maybe<ContentBannerNode>;
  hrEvent: HrEventNode;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  intendedAudience?: Maybe<HrResourceIntendedAudience>;
  mediaType?: Maybe<MediaTypeNode>;
  mobileValue?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type HrEventNode = Node & {
  __typename?: 'HREventNode';
  createdAt: Scalars['DateTime'];
  descriptiveDate: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  intendedAudience: HrResourceIntendedAudience;
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug: Scalars['String'];
  status: HrEventStatus;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
};

export type HrEventOutput = HrEventResponse | InternalToolPermissionDeniedError;

export type HrEventResponse = {
  __typename?: 'HREventResponse';
  hrEvent?: Maybe<HrEventNode>;
};

export enum HrEventStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type HrEventUpdateErrorResponse = {
  __typename?: 'HREventUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrEventUpdateInput = {
  descriptiveDate: Scalars['String'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  intendedAudience: HrResourceIntendedAudience;
  status: HrEventStatus;
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type HrEventUpdateOutput = HrEventUpdateErrorResponse | HrEventUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type HrEventUpdateSuccessResponse = {
  __typename?: 'HREventUpdateSuccessResponse';
  hrEvent?: Maybe<HrEventNode>;
};

export type HrisAppInfo = {
  appName: Scalars['String'];
  appUuid: Scalars['UUID'];
};

export type HrisAuthInfo = {
  publicToken: Scalars['String'];
};

export type HrisConnectTokenOutput = HrisConnectTokenResult | HrisRequestError | PermissionDeniedError;

export type HrisConnectTokenResult = {
  __typename?: 'HRISConnectTokenResult';
  token?: Maybe<Scalars['String']>;
};

export type HrisConnectionNode = {
  __typename?: 'HRISConnectionNode';
  appName: Scalars['String'];
  appUuid: Scalars['UUID'];
  createdTime: Scalars['DateTime'];
  disabledAt?: Maybe<Scalars['DateTime']>;
  hrAdmin?: Maybe<HrAdminNode>;
  uuid: Scalars['UUID'];
};

export type HrisConnectionsOutput = HrisConnectionsResult | HrisRequestError | PermissionDeniedError;

export type HrisConnectionsResult = {
  __typename?: 'HRISConnectionsResult';
  connections?: Maybe<Array<Maybe<HrisConnectionNode>>>;
};

export type HrisRequestError = BaseError & {
  __typename?: 'HRISRequestError';
  debug?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type HrMessageNode = {
  __typename?: 'HRMessageNode';
  companyUuid: Scalars['UUID'];
  contentLinks?: Maybe<Array<Maybe<HrMonitorContentLinkNode>>>;
  message?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
};

export type HrMessages = {
  __typename?: 'HRMessages';
  results?: Maybe<Array<Maybe<HrMessageNode>>>;
};

export type HrMessagesResult = HrMessages | PermissionDeniedError;

export type HrMonitorContentLinkNode = {
  __typename?: 'HRMonitorContentLinkNode';
  accentColor?: Maybe<Scalars['String']>;
  bannerContent: Scalars['String'];
  bannerCtaText: Scalars['String'];
  bannerImage?: Maybe<Scalars['String']>;
  bannerSubtitle?: Maybe<Scalars['String']>;
  bannerTitle?: Maybe<Scalars['String']>;
  titleColor?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type HrResourceCreateErrorResponse = {
  __typename?: 'HRResourceCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrResourceCreateInput = {
  image?: Maybe<Scalars['String']>;
  intendedAudience: HrResourceIntendedAudience;
  mediaTypeId?: Maybe<Scalars['ID']>;
  searchTags: Array<Maybe<Scalars['String']>>;
  status: HrResourceStatus;
  subtitle: Scalars['String'];
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type HrResourceCreateOutput = HrResourceCreateErrorResponse | HrResourceCreateSuccessResponse | InternalToolPermissionDeniedError;

export type HrResourceCreateSuccessResponse = {
  __typename?: 'HRResourceCreateSuccessResponse';
  hrResource?: Maybe<HrResourceNode>;
};

export type HrResourceDeleteErrorResponse = {
  __typename?: 'HRResourceDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrResourceDeleteInput = {
  id: Scalars['ID'];
};

export type HrResourceDeleteOutput = HrResourceDeleteErrorResponse | HrResourceDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type HrResourceDeleteSuccessResponse = {
  __typename?: 'HRResourceDeleteSuccessResponse';
  hrResource?: Maybe<HrResourceNode>;
};

export enum HrResourceIntendedAudience {
  Admin = 'ADMIN',
  Employee = 'EMPLOYEE',
  Manager = 'MANAGER'
}

export type HrResourceLinkNode = Node & {
  __typename?: 'HRResourceLinkNode';
  banner?: Maybe<ContentBannerNode>;
  hrResource: HrResourceNode;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  intendedAudience?: Maybe<HrResourceIntendedAudience>;
  mediaType?: Maybe<MediaTypeNode>;
  mobileValue?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type HrResourceNode = Node & {
  __typename?: 'HRResourceNode';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  intendedAudience: HrResourceIntendedAudience;
  mediaType?: Maybe<MediaTypeNode>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  searchTags: Array<Maybe<Scalars['String']>>;
  slug: Scalars['String'];
  status: HrResourceStatus;
  subtitle: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
};

export type HrResourceNodeConnection = {
  __typename?: 'HRResourceNodeConnection';
  edges: Array<Maybe<HrResourceNodeEdge>>;
  pageInfo: PageInfo;
};

export type HrResourceNodeEdge = {
  __typename?: 'HRResourceNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<HrResourceNode>;
};

export type HrResourceOutput = HrResourceResponse | InternalToolPermissionDeniedError;

export type HrResourceResponse = {
  __typename?: 'HRResourceResponse';
  hrResource?: Maybe<HrResourceNode>;
};

export type HrResourceScreenResult = {
  __typename?: 'HRResourceScreenResult';
  breadcrumbs: Array<ScreenNode>;
  screen: ScreenNode;
};

export enum HrResourceStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type HrResourceUpdateErrorResponse = {
  __typename?: 'HRResourceUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type HrResourceUpdateInput = {
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  intendedAudience: HrResourceIntendedAudience;
  mediaTypeId?: Maybe<Scalars['ID']>;
  searchTags: Array<Maybe<Scalars['String']>>;
  status: HrResourceStatus;
  subtitle: Scalars['String'];
  title: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type HrResourceUpdateOutput = HrResourceUpdateErrorResponse | HrResourceUpdateSuccessResponse | InternalToolPermissionDeniedError;

export type HrResourceUpdateSuccessResponse = {
  __typename?: 'HRResourceUpdateSuccessResponse';
  hrResource?: Maybe<HrResourceNode>;
};

export type HealthPlanCompaniesOutput = HealthPlanCompaniesResponse | InternalToolPermissionDeniedError;

export type HealthPlanCompaniesResponse = {
  __typename?: 'HealthPlanCompaniesResponse';
  companies?: Maybe<Array<Maybe<CompanyFeatureStatusNode>>>;
};

export type HomeScreenNode = ScreenNodeInterface & {
  __typename?: 'HomeScreenNode';
  bannerContent?: Maybe<ScheduledContentNode>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  designatedApplication: ScreenDesignatedApplication;
  featuredSection: ScreenSectionNode;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<GenericScreenNode>;
  platform: ScreenPlatform;
  scheduledContent?: Maybe<ScheduledContentNode>;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type ImageNode = Node & {
  __typename?: 'ImageNode';
  altText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  url: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type InAppReviewFlowCompletedMutation = {
  __typename?: 'InAppReviewFlowCompletedMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum InAppReviewStore {
  AppStore = 'APP_STORE',
  PlayStore = 'PLAY_STORE'
}

export enum IneligibleReason {
  InvalidDateRange = 'INVALID_DATE_RANGE',
  InvalidInput = 'INVALID_INPUT',
  NoCoverage = 'NO_COVERAGE'
}

export type InsuranceCompanyNode = {
  __typename?: 'InsuranceCompanyNode';
  cpid: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  payerId: Scalars['String'];
  supportsMulticlientAccumulator: Scalars['Boolean'];
};

export enum InsurancePlanType {
  Hdhp = 'HDHP',
  Ppo = 'PPO'
}

export type IntakeFormAnswerInput = {
  answer: Scalars['String'];
  id: Scalars['ID'];
  intakeFormTemplateId: Scalars['ID'];
  label: Scalars['String'];
  modType: Scalars['String'];
  options: Scalars['String'];
};

export enum IntakeFormCompletedOnPlatform {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type IntakeFormNode = {
  __typename?: 'IntakeFormNode';
  completedAt?: Maybe<Scalars['DateTime']>;
  completedBy?: Maybe<MemberNode>;
  completedOnPlatform?: Maybe<IntakeFormCompletedOnPlatform>;
  createdAt?: Maybe<Scalars['DateTime']>;
  exitedAt?: Maybe<Scalars['String']>;
  intakeFormQuestionResponses?: Maybe<Array<Maybe<IntakeFormQuestionResponseNode>>>;
  providerViewedAt?: Maybe<Scalars['DateTime']>;
  submitted: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  uuid: Scalars['UUID'];
};

export type IntakeFormQuestionResponseInputNode = {
  anythingElse?: Maybe<Scalars['String']>;
  currentPersonalAndProfessionalLife?: Maybe<Scalars['String']>;
  experiencedCoachingBefore?: Maybe<Array<Maybe<Scalars['String']>>>;
  howAreYouDerivingValue?: Maybe<Scalars['String']>;
  motivationToSeekCoaching?: Maybe<Scalars['String']>;
  outcomesToAchieveOne?: Maybe<Scalars['String']>;
  outcomesToAchieveThree?: Maybe<Scalars['String']>;
  outcomesToAchieveTwo?: Maybe<Scalars['String']>;
  postSessionsPersonalAndProfessionalLife?: Maybe<Scalars['String']>;
  rankSupportAccountability?: Maybe<Scalars['Int']>;
  rankSupportBrainStorming?: Maybe<Scalars['Int']>;
  rankSupportEncouragement?: Maybe<Scalars['Int']>;
  rankSupportExploringObstacles?: Maybe<Scalars['Int']>;
  rankSupportInsightIntoPotential?: Maybe<Scalars['Int']>;
  rankSupportVision?: Maybe<Scalars['Int']>;
};

export type IntakeFormQuestionResponseNode = {
  __typename?: 'IntakeFormQuestionResponseNode';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  intakeForm: IntakeFormNode;
  questionName?: Maybe<Scalars['String']>;
  questionResponseContent?: Maybe<Scalars['GenericScalar']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type InternalLinkNode = Node & {
  __typename?: 'InternalLinkNode';
  additionalInformation?: Maybe<Scalars['String']>;
  additionalInformationTitle?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
  banner?: Maybe<ContentBannerNode>;
  buttonText?: Maybe<Scalars['String']>;
  buttonTextTranslationKey?: Maybe<Scalars['String']>;
  childLinks?: Maybe<Array<Maybe<InternalLinkNode>>>;
  colorScheme?: Maybe<ColorScheme>;
  disabled?: Maybe<Scalars['Boolean']>;
  groupKey?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<Scalars['String']>>>;
  index?: Maybe<Scalars['Int']>;
  intendedAudience?: Maybe<HrResourceIntendedAudience>;
  labelText?: Maybe<Scalars['String']>;
  labelTextTranslationKey?: Maybe<Scalars['String']>;
  labelVariant?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  mobileValue?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  providerInitials?: Maybe<Scalars['String']>;
  recommended?: Maybe<Scalars['Boolean']>;
  referenceUuid?: Maybe<Scalars['UUID']>;
  subtitle?: Maybe<Scalars['String']>;
  subtitleTranslationKey?: Maybe<Scalars['String']>;
  tileColor?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  titleTranslationKey: Scalars['String'];
  uuid: Scalars['UUID'];
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type InternalToolDeleteOutput = InternalToolDeleteSuccessResponse | InternalToolPermissionDeniedError;

export type InternalToolDeleteSuccessResponse = {
  __typename?: 'InternalToolDeleteSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type InternalToolPermissionDeniedError = {
  __typename?: 'InternalToolPermissionDeniedError';
  message?: Maybe<Scalars['String']>;
};

export type InvalidArgumentError = BaseSurveyError & {
  __typename?: 'InvalidArgumentError';
  debug: Scalars['String'];
  message: Scalars['String'];
};

export type InvalidEmailError = BaseError & {
  __typename?: 'InvalidEmailError';
  debug?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type InvalidEnvironmentError = {
  __typename?: 'InvalidEnvironmentError';
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type InvalidRoleError = BaseError & {
  __typename?: 'InvalidRoleError';
  debug?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type InviteBulkHrAdminEmailError = {
  __typename?: 'InviteBulkHRAdminEmailError';
  errors: Array<Maybe<InviteBulkHrAdminEmailErrorDetail>>;
};

export type InviteBulkHrAdminEmailErrorDetail = {
  __typename?: 'InviteBulkHRAdminEmailErrorDetail';
  email: Scalars['String'];
  error: InviteBulkHrAdminEmailErrorOutput;
};

export type InviteBulkHrAdminEmailErrorOutput = HrAdminAlreadyExistsError | InvalidEmailError | UnknownUserError;

export type InviteBulkHrAdminResult = InvalidRoleError | InviteBulkHrAdminEmailError | InviteBulkHrAdminSuccessOutput | PermissionDeniedError;

export type InviteBulkHrAdminSuccessOutput = {
  __typename?: 'InviteBulkHRAdminSuccessOutput';
  hrAdmins?: Maybe<Array<Maybe<HrAdminNode>>>;
};

export type InviteDependentErrorResponse = {
  __typename?: 'InviteDependentErrorResponse';
  message: Scalars['String'];
};

export type InviteDependentInput = {
  anythingElse?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  dateOfBirth: Scalars['String'];
  dependentRelation: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  language?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  platform: Scalars['String'];
  specialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  zipCode?: Maybe<Scalars['String']>;
};

export type InviteDependentOutput = InviteDependentErrorResponse | InviteDependentSuccessResponse;

export type InviteDependentSuccessResponse = {
  __typename?: 'InviteDependentSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type InviteHrAdminMutationResult = InvalidEmailError | InviteHrAdminSuccessOutput | PermissionDeniedError | UnknownUserError;

export type InviteHrAdminSuccessOutput = {
  __typename?: 'InviteHRAdminSuccessOutput';
  hrAdmin?: Maybe<HrAdminNode>;
  ok?: Maybe<Scalars['Boolean']>;
};


export type LanguageNode = {
  __typename?: 'LanguageNode';
  code: Scalars['String'];
  name: Scalars['String'];
  nativeName: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type LaunchOpsCompanyNode = {
  __typename?: 'LaunchOpsCompanyNode';
  companySegments: Array<CompanySegmentNode>;
  name: Scalars['String'];
  ssoEnabled: Scalars['Boolean'];
  ssoOnly?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['UUID'];
};

export type LinkCronofyCalendarMutation = {
  __typename?: 'LinkCronofyCalendarMutation';
  ok?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['Int']>;
};

export type ListHrAdminQueryOutput = HrAdminResult | PermissionDeniedError | UnknownCompanyError;

export type LocationNode = {
  __typename?: 'LocationNode';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type LogHrisConnectionInput = {
  appInfo: HrisAppInfo;
  authInfo: HrisAuthInfo;
};

export type LogHrisConnectionPayload = {
  __typename?: 'LogHRISConnectionPayload';
  connection?: Maybe<HrisConnectionNode>;
};

export type LogHrisConnectionResult = EncryptionError | HrisRequestError | LogHrisConnectionPayload | PermissionDeniedError;

export type LookerReportError = BaseError & {
  __typename?: 'LookerReportError';
  debug?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type LookerSsoEmbedLink = {
  __typename?: 'LookerSsoEmbedLink';
  url?: Maybe<Scalars['String']>;
};

export type LookerSsoEmbedResult = LookerSsoEmbedLink | PermissionDeniedError | UnknownCompanyError | UnknownReportTypeError;

export type ManageCareTeamScreenNode = ScreenNodeInterface & {
  __typename?: 'ManageCareTeamScreenNode';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  designatedApplication: ScreenDesignatedApplication;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<GenericScreenNode>;
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type MarkCoachingVisitEnd = {
  __typename?: 'MarkCoachingVisitEnd';
  ok?: Maybe<Scalars['Boolean']>;
};

export type MarkCoachingVisitStart = {
  __typename?: 'MarkCoachingVisitStart';
  ok?: Maybe<Scalars['Boolean']>;
};

export type MatchedProvidersMutation = {
  __typename?: 'MatchedProvidersMutation';
  allowsFiltering?: Maybe<Scalars['Boolean']>;
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
  providersDidNotMatchPreferences?: Maybe<Array<Maybe<CoachNode>>>;
  providersMatchedPreferences?: Maybe<Array<Maybe<CoachNode>>>;
};

export type MediaTypeCreateErrorResponse = {
  __typename?: 'MediaTypeCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type MediaTypeCreateInput = {
  icon: Scalars['String'];
  mobileScreenId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  webScreenId?: Maybe<Scalars['ID']>;
};

export type MediaTypeCreateOutput = InternalToolPermissionDeniedError | MediaTypeCreateErrorResponse | MediaTypeCreateSuccessResponse;

export type MediaTypeCreateSuccessResponse = {
  __typename?: 'MediaTypeCreateSuccessResponse';
  mediaType?: Maybe<MediaTypeNode>;
};

export type MediaTypeDeleteErrorResponse = {
  __typename?: 'MediaTypeDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type MediaTypeDeleteInput = {
  id: Scalars['ID'];
};

export type MediaTypeDeleteOutput = InternalToolPermissionDeniedError | MediaTypeDeleteErrorResponse | MediaTypeDeleteSuccessResponse;

export type MediaTypeDeleteSuccessResponse = {
  __typename?: 'MediaTypeDeleteSuccessResponse';
  mediaType?: Maybe<MediaTypeNode>;
};

export type MediaTypeNode = Node & {
  __typename?: 'MediaTypeNode';
  contentcollectionlinkSet: ContentCollectionLinkNodeConnection;
  courseSet: CourseNodeConnection;
  createdAt: Scalars['DateTime'];
  hrmonitorcontentlinkSet: Array<HrMonitorContentLinkNode>;
  hrresourceSet: HrResourceNodeConnection;
  icon: Scalars['String'];
  id: Scalars['ID'];
  meditationSet: Array<MeditationNode>;
  mobileScreen?: Maybe<ScreenNode>;
  name: Scalars['String'];
  programSet: Array<ProgramNode>;
  scheduledcontentSet: ScheduledContentNodeConnection;
  scheduledcontentlinkSet: Array<ScheduledContentLinkNode>;
  screen?: Maybe<ScreenNode>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
  videocontentSet: VideoContentNodeConnection;
  webScreen?: Maybe<ScreenNode>;
};


export type MediaTypeNodeContentcollectionlinkSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MediaTypeNodeCourseSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MediaTypeNodeHrresourceSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MediaTypeNodeScheduledcontentSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MediaTypeNodeVideocontentSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type MediaTypeNodeConnection = {
  __typename?: 'MediaTypeNodeConnection';
  edges: Array<Maybe<MediaTypeNodeEdge>>;
  pageInfo: PageInfo;
};

export type MediaTypeNodeEdge = {
  __typename?: 'MediaTypeNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<MediaTypeNode>;
};

export type MediaTypeUpdateErrorResponse = {
  __typename?: 'MediaTypeUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type MediaTypeUpdateInput = {
  icon: Scalars['String'];
  id: Scalars['ID'];
  mobileScreenId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  webScreenId?: Maybe<Scalars['ID']>;
};

export type MediaTypeUpdateOutput = InternalToolPermissionDeniedError | MediaTypeUpdateErrorResponse | MediaTypeUpdateSuccessResponse;

export type MediaTypeUpdateSuccessResponse = {
  __typename?: 'MediaTypeUpdateSuccessResponse';
  mediaType?: Maybe<MediaTypeNode>;
};

export type MeditationCategoryNode = {
  __typename?: 'MeditationCategoryNode';
  displayName: Scalars['String'];
  displayOrder: Scalars['Int'];
  meditations?: Maybe<Array<Maybe<MeditationNode>>>;
};


export type MeditationCategoryNodeMeditationsArgs = {
  languageCode?: Maybe<Scalars['String']>;
};

export type MeditationFinishMutation = {
  __typename?: 'MeditationFinishMutation';
  meditationProgress?: Maybe<MeditationProgressNode>;
};

export enum MeditationLanguageCode {
  De = 'DE',
  EnUs = 'EN_US',
  Es = 'ES',
  Fr = 'FR',
  FrCa = 'FR_CA',
  Hi = 'HI',
  It = 'IT',
  Ja = 'JA',
  Ko = 'KO',
  My = 'MY',
  Pl = 'PL',
  Pt = 'PT',
  ZhHans = 'ZH_HANS'
}

export type MeditationLinkNode = Node & {
  __typename?: 'MeditationLinkNode';
  banner?: Maybe<ContentBannerNode>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  mediaType?: Maybe<MediaTypeNode>;
  meditation: MeditationNode;
  mobileValue?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type MeditationNode = {
  __typename?: 'MeditationNode';
  audioFile: Scalars['String'];
  audioFileTranslationKey: Scalars['String'];
  banner?: Maybe<ContentBannerNode>;
  category: Scalars['String'];
  categoryTranslationKey?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  defaultOrdering?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  duration: Scalars['Int'];
  hideFromIndexQueries?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  image: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isNew: Scalars['Boolean'];
  isSearchable?: Maybe<Scalars['Boolean']>;
  isStarted?: Maybe<Scalars['Boolean']>;
  languageCode: MeditationLanguageCode;
  mediaType?: Maybe<MediaTypeNode>;
  meditationCategory?: Maybe<MeditationCategoryNode>;
  meditationId: Scalars['Int'];
  meditationProgress: Array<MeditationProgressNode>;
  messageResources: Array<MessageResourceNode>;
  name: Scalars['String'];
  nameTranslationKey: Scalars['String'];
  progress: Array<MeditationProgressNode>;
  progressPercent: Scalars['Int'];
  searchKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  slug?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type MeditationProgressNode = {
  __typename?: 'MeditationProgressNode';
  completedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  meditation?: Maybe<MeditationNode>;
  meditationName?: Maybe<Scalars['String']>;
  owner: MemberNode;
  pillarWeek?: Maybe<Scalars['Int']>;
  progressPercentage?: Maybe<Scalars['Float']>;
  startedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MeditationStartMutation = {
  __typename?: 'MeditationStartMutation';
  meditationProgress?: Maybe<MeditationProgressNode>;
};

export type MeditationUpdateProgressMutation = {
  __typename?: 'MeditationUpdateProgressMutation';
  meditationProgress?: Maybe<MeditationProgressNode>;
};

export type MeditationsScreenNode = ScreenNodeInterface & {
  __typename?: 'MeditationsScreenNode';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  designatedApplication: ScreenDesignatedApplication;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<GenericScreenNode>;
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export enum MemberAvailability {
  Afternoon = 'Afternoon',
  Evening = 'Evening',
  Morning = 'Morning'
}

export enum MemberCarePreferenceFeelingsAboutTherapy {
  Committed = 'COMMITTED',
  Hesitant = 'HESITANT',
  Neutral = 'NEUTRAL'
}

export type MemberCarePreferenceNode = {
  __typename?: 'MemberCarePreferenceNode';
  createdAt: Scalars['DateTime'];
  feelingsAboutTherapy?: Maybe<MemberCarePreferenceFeelingsAboutTherapy>;
  id: Scalars['ID'];
  inactiveAt?: Maybe<Scalars['DateTime']>;
  isActive: Scalars['Boolean'];
  member: MemberNode;
  otherSpecialtiesFreeform?: Maybe<Scalars['String']>;
  specialtiesSelected?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MemberFilterPreferenceNode = {
  __typename?: 'MemberFilterPreferenceNode';
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<MemberFilterPreferenceOptionNode>>>;
  title?: Maybe<Scalars['String']>;
};

export type MemberFilterPreferenceOptionNode = {
  __typename?: 'MemberFilterPreferenceOptionNode';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type MemberInput = {
  birth_date_m?: Maybe<Scalars['Int']>;
  employment_health_althoughsick_m?: Maybe<Scalars['Float']>;
  employment_health_burnedout_m?: Maybe<Scalars['Float']>;
  employment_health_stickness_m?: Maybe<Scalars['Float']>;
  feelings_about_therapy_m?: Maybe<Scalars['String']>;
  gad2_nervous_m?: Maybe<Scalars['Float']>;
  gad2_score_m?: Maybe<Scalars['Float']>;
  gad2_worrying_m?: Maybe<Scalars['Float']>;
  goal_category_01_m?: Maybe<Scalars['String']>;
  goal_category_02_m?: Maybe<Scalars['String']>;
  goal_category_03_m?: Maybe<Scalars['String']>;
  is_dependent_m?: Maybe<Scalars['Int']>;
  language_preferences_m?: Maybe<Scalars['String']>;
  modality_preference_m?: Maybe<Scalars['String']>;
  phq2_feelingdown_m?: Maybe<Scalars['Float']>;
  phq2_littleinterest_m?: Maybe<Scalars['Float']>;
  phq2_score_m?: Maybe<Scalars['Float']>;
  recommendation_m?: Maybe<Scalars['String']>;
  specialties_selected_01_m?: Maybe<Scalars['String']>;
  specialties_selected_02_m?: Maybe<Scalars['String']>;
  specialties_selected_03_m?: Maybe<Scalars['String']>;
  subtopic_of_focus_01_m?: Maybe<Scalars['String']>;
  subtopic_of_focus_02_m?: Maybe<Scalars['String']>;
  subtopic_of_focus_03_m?: Maybe<Scalars['String']>;
  topic_of_focus_01_m?: Maybe<Scalars['String']>;
  topic_of_focus_02_m?: Maybe<Scalars['String']>;
  topic_of_focus_03_m?: Maybe<Scalars['String']>;
  triage_score_m?: Maybe<Scalars['Float']>;
  who5_activevigorous_m?: Maybe<Scalars['Float']>;
  who5_calmrelaxed_m?: Maybe<Scalars['Float']>;
  who5_freshrested_m?: Maybe<Scalars['Float']>;
  who5_goodspirits_m?: Maybe<Scalars['Float']>;
  who5_score_m?: Maybe<Scalars['Float']>;
};

export type MemberInsuranceNode = {
  __typename?: 'MemberInsuranceNode';
  employerInsuranceId?: Maybe<Scalars['String']>;
  policyMemberId?: Maybe<Scalars['String']>;
  policyNumber?: Maybe<Scalars['String']>;
  primaryFirstName?: Maybe<Scalars['String']>;
  primaryLastName?: Maybe<Scalars['String']>;
  relationshipCode?: Maybe<Scalars['String']>;
};

export type MemberNode = {
  __typename?: 'MemberNode';
  age?: Maybe<Scalars['Int']>;
  allowNotifications: Scalars['Boolean'];
  availability?: Maybe<Array<Scalars['String']>>;
  avatar?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['Date']>;
  careRecommendations: Array<CareRecommendationNode>;
  city?: Maybe<Scalars['String']>;
  clevertapId?: Maybe<Scalars['String']>;
  coachAssignments?: Maybe<Array<Maybe<CoachAssignmentNode>>>;
  company?: Maybe<CompanyNode>;
  companyAdditionalBenefits?: Maybe<Array<Maybe<CompanyAdditionalBenefitNode>>>;
  companySegment?: Maybe<CompanySegmentNode>;
  contentLanguage?: Maybe<ContentLanguageNode>;
  conversationsWithUnreadMessages?: Maybe<Array<Maybe<ConversationNode>>>;
  country?: Maybe<Scalars['String']>;
  credentials?: Maybe<Scalars['String']>;
  crisisProviderCompanyAssignments?: Maybe<Array<Maybe<CrisisProviderCompanyAssignmentNode>>>;
  crisisProviderCountryAssignments?: Maybe<Array<Maybe<CrisisProviderCountryAssignmentNode>>>;
  crisisProviders?: Maybe<Array<Maybe<CrisisProviderNode>>>;
  defaultVisitDuration: Scalars['Float'];
  eligiblePersonEmail?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailConfirmed: Scalars['Boolean'];
  featuredBenefits?: Maybe<Array<Maybe<FeaturedBenefit>>>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  goalInterests?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['Int']>;
  insuranceStatus?: Maybe<Scalars['String']>;
  intakeForm?: Maybe<IntakeFormNode>;
  isAccountDeletionInProgress?: Maybe<Scalars['Boolean']>;
  isActiveCobraRifMember?: Maybe<Scalars['Boolean']>;
  isCompanyHpiEnabled?: Maybe<Scalars['Boolean']>;
  isCompanyPsychiatryEnabled?: Maybe<Scalars['Boolean']>;
  isCompanyPsychiatryNonHpiEnabled?: Maybe<Scalars['Boolean']>;
  isDependent?: Maybe<Scalars['Boolean']>;
  isEnrolledInAutopayments?: Maybe<Scalars['Boolean']>;
  isMobile?: Maybe<Scalars['Boolean']>;
  isTest?: Maybe<Scalars['Boolean']>;
  joinedAt: Scalars['Date'];
  languagePreference?: Maybe<Scalars['String']>;
  languagePreferences: Array<Scalars['String']>;
  lastActive?: Maybe<Scalars['DateTime']>;
  lastLoggedInAt?: Maybe<Scalars['DateTime']>;
  lastMessageSentAt?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  lastVisitCompletedAt?: Maybe<Scalars['DateTime']>;
  localTimezone?: Maybe<Scalars['String']>;
  newEmailAddressNotConfirmed?: Maybe<Scalars['String']>;
  notificationPreferences?: Maybe<NotificationPreferencesNode>;
  oldEmailAddress?: Maybe<Scalars['String']>;
  onboardingStatus?: Maybe<AccountOnboardingStatus>;
  parentUuid?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  /** @deprecated No longer used after feature flag removed */
  phq9Access?: Maybe<Phq9Access>;
  phq9SelfharmScores?: Maybe<Array<Maybe<Phq9SelfharmScoreNode>>>;
  providerSpecialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  psychiatryVisitsCompleted?: Maybe<PsychiatryVisitsCompletedNode>;
  registrationSource?: Maybe<Scalars['String']>;
  role: AccountRole;
  sex?: Maybe<Scalars['String']>;
  sharedPreferences?: Maybe<Array<Maybe<AccountSharedPreferencesRecordNode>>>;
  ssoOnly?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['Date']>;
  state?: Maybe<Scalars['String']>;
  surveys: Array<Who5SurveyNode>;
  therapyAccessShortcut?: Maybe<Scalars['Boolean']>;
  topicSelectionGroup?: Maybe<TopicSelectionGroupNode>;
  uuid: Scalars['UUID'];
  visitsRemaining?: Maybe<VisitsRemainingNode>;
  zipCode?: Maybe<Scalars['String']>;
};

export type MemberNonPhiNode = {
  __typename?: 'MemberNonPHINode';
  accountSet: Array<MemberNode>;
  allowNotifications: Scalars['Boolean'];
  assessmentflowSet: Array<AssessmentFlowNode>;
  assessmentjourneySet: Array<AssessmentJourneyNode>;
  availability?: Maybe<Array<Scalars['String']>>;
  avatar?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['Date']>;
  bufferTime: Scalars['Float'];
  calendarProfiles: Array<CalendarProfileNode>;
  careNavigationRequests: Array<CareNavigationRequestNode>;
  careRecommendations: Array<CareRecommendationNode>;
  city?: Maybe<Scalars['String']>;
  clevertapId?: Maybe<Scalars['String']>;
  coachAssignments: Array<CoachAssignmentNode>;
  coachCoachOption: Array<ProviderOptionOffer>;
  coachingVisits: Array<CoachingVisitNode>;
  company?: Maybe<CompanyDropdownNode>;
  companysegmentSet: Array<CompanySegmentNode>;
  confirmedEmailConfirmationToken?: Maybe<Scalars['UUID']>;
  contentresponsesSet: Array<ContentResponsesNode>;
  conversationsAsCoach: ConversationNodeConnection;
  conversationsAsMember: ConversationNodeConnection;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  credentials?: Maybe<Scalars['String']>;
  credentialsStructured?: Maybe<Scalars['String']>;
  defaultVisitDuration: Scalars['Float'];
  deviceOs?: Maybe<AccountDeviceOs>;
  deviceToken?: Maybe<Scalars['String']>;
  digitalBio?: Maybe<Scalars['String']>;
  eligiblePerson: Array<EligiblePersonNode>;
  email?: Maybe<Scalars['String']>;
  emailConfirmationToken?: Maybe<Scalars['UUID']>;
  emailConfirmed?: Maybe<Scalars['Boolean']>;
  enrolledInAutoPayments?: Maybe<Scalars['Boolean']>;
  groupPractice?: Maybe<MemberNode>;
  guides: CourseGuideNodeConnection;
  hasOwnAvatar: Scalars['Boolean'];
  id: Scalars['ID'];
  insuranceStatus?: Maybe<AccountInsuranceStatus>;
  intakeformSet: Array<IntakeFormNode>;
  introduction?: Maybe<Scalars['String']>;
  introductionStructured?: Maybe<Scalars['String']>;
  isContentReviewer: Scalars['Boolean'];
  isHyperwalletPayee: Scalars['Boolean'];
  isMarkedMinor: Scalars['Boolean'];
  isSpecificProviderForCompany: Scalars['Boolean'];
  isSpecificProviderOrder: Scalars['Int'];
  isTest: Scalars['Boolean'];
  isUnregistered: Scalars['Boolean'];
  joinedAt: Scalars['Date'];
  languagePreferences: Array<Scalars['String']>;
  lateCancellationThreshold: Scalars['Float'];
  licensedCountries: Array<Scalars['String']>;
  licensedStates: Array<Scalars['String']>;
  localTimezone?: Maybe<AccountLocalTimezone>;
  mailingAddress?: Maybe<Scalars['String']>;
  matchRequestsFulfilled: Array<ProviderMatchAttemptNode>;
  maximumMemberSlots?: Maybe<Scalars['Int']>;
  meditations: Array<MeditationProgressNode>;
  memberAssignments: Array<CoachAssignmentNode>;
  memberCarePreferences: Array<MemberCarePreferenceNode>;
  memberCoachOption: Array<ProviderOptionOffer>;
  memberRating: Array<RatingNode>;
  newClientCapacity?: Maybe<Scalars['Int']>;
  newEmailAddressNotConfirmed?: Maybe<Scalars['String']>;
  notificationPreferences?: Maybe<NotificationPreferencesNode>;
  npi?: Maybe<Scalars['String']>;
  officeHours: Scalars['JSONString'];
  oldEmailAddress?: Maybe<Scalars['String']>;
  onboardingStatus?: Maybe<AccountOnboardingStatus>;
  parent?: Maybe<MemberNode>;
  pathwayProgress: ProviderMemberPathwayNodeConnection;
  pathwayprogressSet: ProviderMemberPathwayNodeConnection;
  pathwayproviderSet: PathwayProviderNodeConnection;
  phoneNumber?: Maybe<Scalars['String']>;
  programs: Array<ProgramProgressNode>;
  providerCertifications: Array<ProviderCertificationNode>;
  providerInvoicingOnly: Scalars['Boolean'];
  providerRating: Array<RatingNode>;
  providerSchedulingType?: Maybe<AccountProviderSchedulingType>;
  providerSpecialties?: Maybe<Array<Scalars['String']>>;
  providerTaxCountry?: Maybe<CountryNode>;
  providerType?: Maybe<AccountProviderType>;
  providerUpdatedProfileAt?: Maybe<Scalars['DateTime']>;
  providers: Array<MemberNode>;
  psychiatristSubtype?: Maybe<AccountPsychiatristSubtype>;
  races: Array<Scalars['String']>;
  receivedMessages: MessageNodeConnection;
  registrationSource?: Maybe<AccountRegistrationSource>;
  reviewerReview: Array<ReviewNode>;
  role: AccountRole;
  scheduledcontentactivitySet: Array<ScheduledContentActivityNode>;
  scimExternalId?: Maybe<Scalars['String']>;
  scimId?: Maybe<Scalars['String']>;
  scimUsername?: Maybe<Scalars['String']>;
  scoreBias?: Maybe<Scalars['Float']>;
  sentMessages: MessageNodeConnection;
  sex?: Maybe<Scalars['String']>;
  sharedPreferences: Array<AccountSharedPreferencesRecordNode>;
  startDate?: Maybe<Scalars['Date']>;
  state?: Maybe<Scalars['String']>;
  surveys: Array<Who5SurveyNode>;
  therapistModalities?: Maybe<Array<Scalars['String']>>;
  therapyAccessShortcut: Scalars['Boolean'];
  topicSelectionGroups: Array<TopicSelectionGroupNode>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  uuid: Scalars['UUID'];
  zipCode?: Maybe<Scalars['String']>;
  zoomUserId?: Maybe<Scalars['String']>;
};


export type MemberNonPhiNodeConversationsAsCoachArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MemberNonPhiNodeConversationsAsMemberArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MemberNonPhiNodeGuidesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MemberNonPhiNodePathwayProgressArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MemberNonPhiNodePathwayprogressSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MemberNonPhiNodePathwayproviderSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type MemberNonPhiNodeReceivedMessagesArgs = {
  acknowledged?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  orderBy?: Maybe<Scalars['String']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  receiverUuid?: Maybe<Scalars['UUID']>;
  senderUuid?: Maybe<Scalars['UUID']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type MemberNonPhiNodeSentMessagesArgs = {
  acknowledged?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  orderBy?: Maybe<Scalars['String']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  receiverUuid?: Maybe<Scalars['UUID']>;
  senderUuid?: Maybe<Scalars['UUID']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type MemberNonPhiOutput = AccountDoesNotExist | MemberNonPhiNode;

export type MemberPageNode = {
  __typename?: 'MemberPageNode';
  countFiltered?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  members?: Maybe<Array<Maybe<MemberNode>>>;
  skip?: Maybe<Scalars['Int']>;
};

export type MemberPathwayNode = Node & {
  __typename?: 'MemberPathwayNode';
  coachAssignment?: Maybe<CoachAssignmentNode>;
  company?: Maybe<CompanyDropdownNode>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completionPercent: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  currentSessionIndex: Scalars['Int'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  member: MemberNode;
  pathway: ProviderPathwayNode;
  pathwayProvider: PathwayProviderNode;
  pathwayTopics: Array<Maybe<PathwayTopicNode>>;
  startedAt?: Maybe<Scalars['DateTime']>;
  state: PathwayProgressState;
  surfacedProvider?: Maybe<MemberNode>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type MemberPreferencesInput = {
  races?: Maybe<Array<Maybe<Scalars['String']>>>;
  showInternationalProviders?: Maybe<Scalars['Boolean']>;
};

export type MemberProfileInput = {
  allowNotifications?: Maybe<Scalars['Boolean']>;
  availability?: Maybe<Array<Maybe<MemberAvailability>>>;
  birthDate?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  clevertapId?: Maybe<Scalars['String']>;
  companySegmentUuid?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  languagePreferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName?: Maybe<Scalars['String']>;
  localTimezone?: Maybe<Scalars['String']>;
  oldPassword?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  therapyAccessShortcut?: Maybe<Scalars['Boolean']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type MergeEligiblePersonInput = {
  file_segment_id: Scalars['Int'];
  newEligiblePersonUuid: Scalars['UUID'];
  oldEligiblePersonUuid: Scalars['UUID'];
};

export type MergeEligiblePersonResponse = {
  __typename?: 'MergeEligiblePersonResponse';
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type MessageActionsNode = {
  __typename?: 'MessageActionsNode';
  contentCollectionLinks: Array<Maybe<InternalLinkNode>>;
  name: Scalars['String'];
};

export enum MessageKind {
  Coaching = 'COACHING',
  Group = 'GROUP',
  LiveCoaching = 'LIVE_COACHING',
  Therapy = 'THERAPY'
}

export type MessageNode = Node & {
  __typename?: 'MessageNode';
  acknowledgedAt?: Maybe<Scalars['DateTime']>;
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  conversation?: Maybe<ConversationNode>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  encryptedContent: Scalars['String'];
  id: Scalars['ID'];
  kind: MessageKind;
  messageResources: Array<MessageResourceNode>;
  readAt?: Maybe<Scalars['DateTime']>;
  receiver?: Maybe<MemberNode>;
  sender?: Maybe<MemberNode>;
  sentAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  uuid?: Maybe<Scalars['UUID']>;
};

export type MessageNodeConnection = {
  __typename?: 'MessageNodeConnection';
  edges: Array<Maybe<MessageNodeEdge>>;
  pageInfo: PageInfo;
};

export type MessageNodeEdge = {
  __typename?: 'MessageNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<MessageNode>;
};

export type MessageResourceInput = {
  companyAdditionalBenefitId?: Maybe<Scalars['Int']>;
  meditationId?: Maybe<Scalars['Int']>;
  order?: Maybe<Scalars['Int']>;
  programId?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type MessageResourceNode = {
  __typename?: 'MessageResourceNode';
  companyAdditionalBenefit?: Maybe<CompanyAdditionalBenefitNode>;
  meditation?: Maybe<MeditationNode>;
  order: Scalars['Int'];
  program?: Maybe<ProgramNode>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type ModelMetadataNode = {
  __typename?: 'ModelMetadataNode';
  modelName: Scalars['String'];
  modelVersion: Scalars['String'];
};

export type MultiselectConfig = {
  __typename?: 'MultiselectConfig';
  maxSelectable?: Maybe<Scalars['Int']>;
  minSelectable?: Maybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptCareRecommendation?: Maybe<AcceptCareRecommendationMutation>;
  acceptContracts?: Maybe<AcceptContractsMutation>;
  addCareNavigationRequest?: Maybe<AddCareNavigationRequestMutation>;
  addCoach?: Maybe<AddCoachMutation>;
  addLanguage?: Maybe<AddLanguageResponseType>;
  addMemberCarePreference?: Maybe<AddMemberCarePreferenceMutation>;
  addNote?: Maybe<AddNoteMutation>;
  addSymptomsExperienced?: Maybe<AddSymptomsExperiencedMutation>;
  addTranslation?: Maybe<AddTranslationResponseType>;
  addTranslationKey?: Maybe<AddTranslationKeyResponseType>;
  addUpdateCompanyFeature?: Maybe<AddUpdateCompanyFeatureMutation>;
  bypassAssessments?: Maybe<BypassAssessmentsMutation>;
  cancelEvent?: Maybe<CancelEventMutation>;
  cancelMemberPathway?: Maybe<CancelMemberPathwayMutationResponse>;
  changeAccountTopics?: Maybe<ChangeAccountTopicsOutput>;
  checkEligibility: CheckEligibilityResponse;
  chooseProvider?: Maybe<ChooseProviderMutation>;
  circleAdminCreateBooleanQuestion?: Maybe<CircleAdminCreateBooleanQuestionMutationResponse>;
  circleAdminCreateFacilitator?: Maybe<CircleAdminCreateFacilitatorMutationResponse>;
  circleAdminCreateFeaturedItem?: Maybe<CircleAdminCreateFeaturedItemMutationResponse>;
  circleAdminCreateFreeResponseQuestion?: Maybe<CircleAdminCreateFreeResponseQuestionMutationResponse>;
  circleAdminCreateMultipleChoiceQuestion?: Maybe<CircleAdminCreateMultipleChoiceQuestionMutationResponse>;
  circleAdminCreateOnDemandTopic?: Maybe<CircleAdminCreateOnDemandTopicMutationResponse>;
  circleAdminCreateRsvpQuestionTopic?: Maybe<CircleAdminCreateRsvpQuestionTopicMutationResponse>;
  circleAdminCreateSegmentedScaleQuestion?: Maybe<CircleAdminCreateSegmentedScaleQuestionMutationResponse>;
  circleAdminCreateSeries?: Maybe<CircleAdminCreateSeriesMutationResponse>;
  circleAdminCreateSession?: Maybe<CircleAdminCreateSessionMutationResponse>;
  circleAdminCreateShortResponseQuestion?: Maybe<CircleAdminCreateShortResponseQuestionMutationResponse>;
  circleAdminCreateTopic?: Maybe<CircleAdminCreateTopicMutationResponse>;
  circleAdminDeleteFeaturedItem?: Maybe<CircleAdminDeleteFeaturedItemMutationResponse>;
  circleAdminDeleteRsvpQuestionTopic?: Maybe<CircleAdminDeleteRsvpQuestionTopicMutationResponse>;
  circleAdminRetryFailedScheduledTasks: CircleRetryFailedScheduledTasksMutationResponse;
  circleAdminUpdateFacilitator?: Maybe<CircleAdminUpdateFacilitatorMutationResponse>;
  circleAdminUpdateOnDemandTopic?: Maybe<CircleAdminUpdateOnDemandTopicMutationResponse>;
  circleAdminUpdateSeries?: Maybe<CircleAdminUpdateSeriesMutationResponse>;
  circleAdminUpdateSession?: Maybe<CircleAdminUpdateSessionMutationResponse>;
  circleAdminUpdateTopic?: Maybe<CircleAdminUpdateTopicMutationResponse>;
  circleCancelAuthenticatedRsvp: CircleCancelAuthenticatedRsvpMutationResponse;
  circleCancelUnauthenticatedRsvp: CircleCancelUnauthenticatedRsvpMutationResponse;
  circleCreateAuthenticatedRsvp?: Maybe<CircleCreateAuthenticatedRsvpMutationResponse>;
  circleCreateItemFeedback: CircleCreateItemFeedbackMutationResponse;
  circleCreateUnauthenticatedCompanyRsvp?: Maybe<CircleCreateUnauthenticatedCompanyRsvpMutationResponse>;
  circleCreateUnauthenticatedRsvp?: Maybe<CircleCreateUnauthenticatedRsvpMutationResponse>;
  circleUserViewedOnDemandTopic: CircleUserViewedOnDemandTopicMutationResponse;
  completeTestPammInitialEvaluation?: Maybe<CompleteTestPammInitialEvaluation>;
  confirmVisitWithoutPayment?: Maybe<ConfirmVisitWithoutPaymentMutation>;
  createAccountDeletionRequest?: Maybe<CreateAccountDeletionRequest>;
  createClientBucket?: Maybe<CreateClientBucketResponse>;
  createCoachingVisitMemberReview?: Maybe<CreateCoachingVisitMemberReviewMutation>;
  createContentCollection?: Maybe<ContentCollectionCreateOutput>;
  createContentCollectionLink?: Maybe<ContentCollectionLinkCreateOutput>;
  createContentLanguage?: Maybe<ContentLanguageCreateOutput>;
  createContentTag?: Maybe<ContentTagCreateOutput>;
  createContentTagCategory?: Maybe<ContentTagCategoryCreateOutput>;
  createContentTagRelation?: Maybe<ContentTagRelationCreateOutput>;
  createContentTranslationAvailability?: Maybe<ContentTranslationAvailabilityCreateOutput>;
  createConversation?: Maybe<CreateConversationMutation>;
  createCourse?: Maybe<CourseCreateOutput>;
  createCourseActivityGroup?: Maybe<CourseActivityGroupCreateOutput>;
  createCourseGuide?: Maybe<CreateCourseGuideMutationOutput>;
  createCourseHero?: Maybe<CreateCourseHeroMutationOutput>;
  createCourseOutcome?: Maybe<CourseOutcomeCreateOutput>;
  createCourseSection?: Maybe<CourseSectionCreateOutput>;
  createEditCompanyAdditionalBenefit?: Maybe<CreateEditCompanyAdditionalBenefitOutput>;
  createEditCompanySegment?: Maybe<CreateEditCompanySegmentOutput>;
  createEditCrisisProvider?: Maybe<CreateEditCrisisProviderOutput>;
  createEditCrisisProviderCompanyAssignment?: Maybe<CreateEditCrisisProviderCompanyAssignmentOutput>;
  createEditCrisisProviderCountryAssignment?: Maybe<CreateEditCrisisProviderCountryAssignmentOutput>;
  createEligibilityCheckCoachingVisit?: Maybe<CreateEligibilityCheckCoachingVisitResponse>;
  createEligibilityCheckCoachingVisitForMember?: Maybe<CreateEligibilityCheckCoachingVisitResponse>;
  createEvent?: Maybe<CreateEventMutation>;
  createHrAdmin?: Maybe<HrAdminCreateOutput>;
  createHrAdminRole?: Maybe<HrAdminRoleCreateOutput>;
  createHrEvent?: Maybe<HrEventCreateOutput>;
  createHrResource?: Maybe<HrResourceCreateOutput>;
  createMediaType?: Maybe<MediaTypeCreateOutput>;
  createMemberPathway?: Maybe<CreateMemberPathwayMutationResponse>;
  createNotification?: Maybe<CreateNotificationMutation>;
  createOrUpdateEmployerCptRates?: Maybe<CreateOrUpdateEmployerCptRateResponse>;
  createOrUpdateEmployerInsurance: CreateOrUpdateEmployerInsuranceResponse;
  createOrUpdateInsuranceCompany: CreateOrUpdateInsuranceCompanyResponse;
  createOrUpdatePatientNote?: Maybe<PatientNoteResponse>;
  createOrUpdatePayerInformation?: Maybe<CreateOrUpdatePayerInformationResponse>;
  createOrUpdateProviderReview?: Maybe<CreateOrUpdateProviderReview>;
  createOrUpdatePsychiatristReview?: Maybe<CreateOrUpdatePsychiatristReview>;
  createPatientIntakeForm?: Maybe<PatientIntakeFormResponse>;
  createProviderReview?: Maybe<CreateProviderReview>;
  createPsychiatryVisitMemberReview?: Maybe<CreatePsychiatryVisitMemberReviewMutation>;
  createSAMLPostPage?: Maybe<CreateSamlPostPageResponse>;
  createScreen?: Maybe<ScreenCreateOutput>;
  createScreenSection?: Maybe<ScreenSectionCreateOutput>;
  createTestEligiblePerson?: Maybe<CreateTestEligiblePersonResult>;
  createTestMember?: Maybe<CreateTestMemberResult>;
  createTestPammMatch?: Maybe<CreateTestPammMatch>;
  createTestProvider?: Maybe<CreateTestProviderResult>;
  createTextTrackTranslation?: Maybe<TextTrackTranslationCreateOutput>;
  createVideoContent?: Maybe<VideoContentCreateOutput>;
  createVisit?: Maybe<CreateVisitMutation>;
  deleteCalendarProfile?: Maybe<DeleteCalendarProfileMutation>;
  deleteCompanyAdditionalBenefit?: Maybe<DeleteCompanyAdditionalBenefitOutput>;
  deleteCompanySegment?: Maybe<InternalToolDeleteOutput>;
  deleteContentCollection?: Maybe<ContentCollectionDeleteOutput>;
  deleteContentCollectionLink?: Maybe<ContentCollectionLinkDeleteOutput>;
  deleteContentTag?: Maybe<ContentTagDeleteOutput>;
  deleteContentTagCategory?: Maybe<ContentTagCategoryDeleteOutput>;
  deleteContentTagRelation?: Maybe<ContentTagRelationDeleteOutput>;
  deleteCourse?: Maybe<CourseDeleteOutput>;
  deleteCourseActivityGroup?: Maybe<CourseActivityGroupDeleteOutput>;
  deleteCourseGuide?: Maybe<DeleteCourseGuideMutationOutput>;
  deleteCourseHero?: Maybe<DeleteCourseHeroMutationOutput>;
  deleteCourseOutcome?: Maybe<CourseOutcomeDeleteOutput>;
  deleteCourseSection?: Maybe<CourseSectionDeleteOutput>;
  deleteCrisisProvider?: Maybe<InternalToolDeleteOutput>;
  deleteCrisisProviderCompanyAssignment?: Maybe<InternalToolDeleteOutput>;
  deleteCrisisProviderCountryAssignment?: Maybe<InternalToolDeleteOutput>;
  deleteHrAdmin?: Maybe<HrAdminDeleteOutput>;
  deleteHrAdminRole?: Maybe<HrAdminRoleDeleteOutput>;
  deleteHrEvent?: Maybe<HrEventDeleteOutput>;
  deleteHrResource?: Maybe<HrResourceDeleteOutput>;
  deleteMediaType?: Maybe<MediaTypeDeleteOutput>;
  deleteScreen?: Maybe<ScreenDeleteOutput>;
  deleteScreenSection?: Maybe<ScreenSectionDeleteOutput>;
  deleteTestMember?: Maybe<DeleteTestMember>;
  deleteTestProvider?: Maybe<DeleteTestProvider>;
  deleteTextTrackTranslation?: Maybe<TextTrackTranslationDeleteOutput>;
  deleteVideoContent?: Maybe<VideoContentDeleteOutput>;
  disableHrAdmin?: Maybe<DisableHrAdminMutationResult>;
  downloadApp?: Maybe<DownloadAppMutation>;
  editHrAdminRole?: Maybe<EditHrAdminRoleMutationResult>;
  finishCourseActivity?: Maybe<CourseProgressMutationOutput>;
  finishMeditation?: Maybe<MeditationFinishMutation>;
  finishPage?: Maybe<PageFinishMutation>;
  finishProgram?: Maybe<ProgramFinishMutation>;
  flushModelCache?: Maybe<FlushModelCacheResponse>;
  /** @deprecated Please use CoachingVisitNode.zoomUrl instead */
  getVideoSession?: Maybe<GetOrCreateCoachingVisitVideoSessionMutation>;
  hrCreateEditCompanyAdditionalBenefit?: Maybe<HrCreateEditCompanyAdditionalBenefitMutation>;
  hrCreateEditCompanySegment?: Maybe<HrCreateEditCompanySegmentMutation>;
  hrDeleteCompanyAdditionalBenefit?: Maybe<HrDeleteCompanyAdditionalBenefitMutation>;
  hrDeleteCompanySegment?: Maybe<HrDeleteCompanySegmentMutation>;
  inAppReviewFlowCompleted?: Maybe<InAppReviewFlowCompletedMutation>;
  inviteBulkHrAdmins?: Maybe<InviteBulkHrAdminResult>;
  inviteDependent?: Maybe<InviteDependentOutput>;
  inviteHrAdmin?: Maybe<InviteHrAdminMutationResult>;
  linkCronofyCalendar?: Maybe<LinkCronofyCalendarMutation>;
  logHrisConnection?: Maybe<LogHrisConnectionResult>;
  markCoachingVisitEnd?: Maybe<MarkCoachingVisitEnd>;
  markCoachingVisitStart?: Maybe<MarkCoachingVisitStart>;
  matchedProviders?: Maybe<MatchedProvidersMutation>;
  mergeEligiblePerson?: Maybe<MergeEligiblePersonResponse>;
  newBulkMessage?: Maybe<NewBulkMessageMutation>;
  newMessage?: Maybe<NewMessageMutation>;
  overrideTranslation?: Maybe<OverrideTranslationResponseType>;
  phoneSupportGenerateOtp?: Maybe<PhoneSupportGenerateOtpOutput>;
  phoneSupportToggleTherapyAccessShortcut?: Maybe<PhoneSupportToggleTherapyAccessShortcutOutput>;
  phoneSupportUpdateMemberEmail?: Maybe<PhoneSupportUpdateMemberEmailOutput>;
  rateScheduledContent?: Maybe<RateScheduledContentMutation>;
  recommendCare?: Maybe<RecommendCareMutation>;
  recordPresenceChange?: Maybe<RecordPresenceChangeMutation>;
  recordScheduledContentActivity?: Maybe<RecordScheduledContentActivityMutation>;
  removeCoach?: Maybe<RemoveCoachMutation>;
  removeModelKeyFromCache?: Maybe<RemoveModelKeyFromCacheResponse>;
  requestManualProviderMatch?: Maybe<RequestManualProviderMatchMutation>;
  rescheduleEvent?: Maybe<RescheduleEventMutation>;
  resetEligibilityForMember?: Maybe<ResetEligibilityForMemberResponse>;
  resetTestAccountPassword?: Maybe<ResetTestAccountPasswordResult>;
  reviewProgram?: Maybe<ReviewProgramMutation>;
  saveContentResponses?: Maybe<SaveContentResponsesMutation>;
  saveNewClientCapacity?: Maybe<SaveNewClientCapacityMutation>;
  saveRating?: Maybe<SaveRatingMutation>;
  selectDifficulty?: Maybe<SelectDifficultyMutation>;
  selectModality?: Maybe<SelectModalityMutation>;
  selectPrimaryFocus?: Maybe<SelectPrimaryFocusMutation>;
  selectTopicsOfFocus?: Maybe<SelectTopicsOfFocusMutation>;
  sendMemberEmailReminder?: Maybe<SendMemberEmailReminderMutation>;
  sendMemberExtendTherapyEmailReminder?: Maybe<SendMemberExtendTherapyEmailReminderMutation>;
  startAssessmentFlow?: Maybe<StartAssessmentFlowMutation>;
  startAssessmentJourney?: Maybe<StartAssessmentJourneyResult>;
  startCareRecommendation?: Maybe<StartCareRecommendationMutation>;
  startCourseActivity?: Maybe<CourseProgressMutationOutput>;
  startMeditation?: Maybe<MeditationStartMutation>;
  startMemberPathway?: Maybe<StartMemberPathwayMutationResponse>;
  startPage?: Maybe<PageStartMutation>;
  startProgram?: Maybe<ProgramStartMutation>;
  submitAssessmentResponseForJourney?: Maybe<SubmitAssessmentResponseOutput>;
  submitAssessments?: Maybe<SubmitAssessmentsMutation>;
  submitCancelledSessionReview?: Maybe<CancelledSessionReviewOutput>;
  submitCourseSectionReview?: Maybe<SubmitCourseSectionReviewOutput>;
  submitFeatureReview?: Maybe<SubmitFeatureRecordReviewOutput>;
  submitModularizedAssessments?: Maybe<SubmitModularizedAssessmentsResult>;
  submitNps?: Maybe<SubmitNpsMutation>;
  submitPathwayAssessment?: Maybe<SubmitPathwayAssessmentMutationOutput>;
  submitPathwayReview?: Maybe<SubmitPathwayReviewOutput>;
  syncUuids?: Maybe<AllContentUuidsOutput>;
  timeToCareLabels?: Maybe<TimeToCareLabelMutation>;
  updateAccountSharedPreferences?: Maybe<UpdateAccountSharedPreferencesMutation>;
  updateAutoPaymentEnrollment?: Maybe<UpdateAutoPaymentEnrollmentResponse>;
  updateAvailableHours?: Maybe<UpdateAvailableHoursMutation>;
  updateCalendar?: Maybe<UpdateCalendarMutation>;
  updateClientBucket?: Maybe<UpdateClientBucketResponse>;
  updateCoachingVisit?: Maybe<UpdateCoachingVisitMutation>;
  updateContentCollection?: Maybe<ContentCollectionUpdateOutput>;
  updateContentCollectionLink?: Maybe<ContentCollectionLinkUpdateOutput>;
  updateContentLanguage?: Maybe<ContentLanguageUpdateOutput>;
  updateContentTag?: Maybe<ContentTagUpdateOutput>;
  updateContentTagCategory?: Maybe<ContentTagCategoryUpdateOutput>;
  updateContentTagRelation?: Maybe<ContentTagRelationUpdateOutput>;
  updateContentTranslationAvailability?: Maybe<ContentTranslationAvailabilityUpdateOutput>;
  updateConversation?: Maybe<UpdateConversationMutation>;
  updateCourse?: Maybe<CourseUpdateOutput>;
  updateCourseActivityGroup?: Maybe<CourseActivityGroupUpdateOutput>;
  updateCourseHero?: Maybe<UpdateCourseHeroMutationOutput>;
  updateCourseOutcome?: Maybe<CourseOutcomeUpdateOutput>;
  updateCourseSection?: Maybe<CourseSectionUpdateOutput>;
  updateHrAdmin?: Maybe<HrAdminUpdateOutput>;
  updateHrAdminRole?: Maybe<HrAdminRoleUpdateOutput>;
  updateHrEvent?: Maybe<HrEventUpdateOutput>;
  updateHrResource?: Maybe<HrResourceUpdateOutput>;
  updateIntakeForm?: Maybe<UpdateIntakeFormMutation>;
  updateMediaType?: Maybe<MediaTypeUpdateOutput>;
  updateMeditationProgress?: Maybe<MeditationUpdateProgressMutation>;
  updateMemberProfile?: Maybe<UpdateMemberProfileMutation>;
  updateMessage?: Maybe<UpdateMessageMutation>;
  updateMyName?: Maybe<UpdateNameResponse>;
  updateName?: Maybe<UpdateNameResponse>;
  updateNotificationPreferences?: Maybe<UpdateNotificationPreferencesMutation>;
  updatePageProgress?: Maybe<PageUpdateMultimediaProgress>;
  updatePatientIntakeForm?: Maybe<PatientIntakeFormResponse>;
  updateProviderProfile?: Maybe<UpdateProviderProfileResponse>;
  updateProviderReview?: Maybe<UpdateProviderReview>;
  updateScreen?: Maybe<ScreenUpdateOutput>;
  updateScreenSection?: Maybe<ScreenSectionUpdateOutput>;
  updateTextTrackTranslation?: Maybe<TextTrackTranslationUpdateOutput>;
  updateVideoContent?: Maybe<VideoContentUpdateOutput>;
  updateVisit?: Maybe<UpdateVisitMutation>;
  uploadCompanyCsv?: Maybe<UploadCsvResponse>;
  validatePendingCoachingVisit?: Maybe<ValidatePendingCoachingVisitMutation>;
};


export type MutationAcceptCareRecommendationArgs = {
  outcome?: Maybe<CareOption>;
  uuid: Scalars['UUID'];
};


export type MutationAcceptContractsArgs = {
  versionIds: Array<Maybe<Scalars['String']>>;
};


export type MutationAddCareNavigationRequestArgs = {
  contactEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  contactPreference: CareNavigationRequestContactPreference;
  inAppConsent?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  platform?: Maybe<DeviceCategory>;
  source?: Maybe<CareNavigationRequestSource>;
  subtopicsOfFocus?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  topic?: Maybe<CareNavigationRequestTopic>;
  updatePhone?: Maybe<Scalars['Boolean']>;
};


export type MutationAddCoachArgs = {
  coachUuid: Scalars['String'];
};


export type MutationAddLanguageArgs = {
  code: Scalars['String'];
  name: Scalars['String'];
  nativeName: Scalars['String'];
};


export type MutationAddMemberCarePreferenceArgs = {
  feelingsAboutTherapy?: Maybe<FeelingsAboutTherapyEnum>;
  otherSpecialtiesFreeform?: Maybe<Scalars['String']>;
  specialtiesSelected?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationAddNoteArgs = {
  coachAssignmentUuid: Scalars['UUID'];
  coachUuid: Scalars['UUID'];
  encryptedContent: Scalars['String'];
};


export type MutationAddSymptomsExperiencedArgs = {
  subtopicSelectionUuid: Scalars['UUID'];
  subtopicSymptoms?: Maybe<SubtopicSymptomsInput>;
  symptomsExperienced?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationAddTranslationArgs = {
  languageCode: Scalars['String'];
  translatedText: Scalars['String'];
  translationKey: Scalars['String'];
};


export type MutationAddTranslationKeyArgs = {
  defaultTranslation: Scalars['String'];
  key: Scalars['String'];
};


export type MutationAddUpdateCompanyFeatureArgs = {
  activate?: Maybe<Scalars['Boolean']>;
  companyUuid: Scalars['UUID'];
  featureName: Scalars['String'];
  featureType?: Maybe<Scalars['String']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
};


export type MutationBypassAssessmentsArgs = {
  careRecommendationUuid: Scalars['UUID'];
};


export type MutationCancelEventArgs = {
  enqueueVisitCancelledEmailEvent?: Maybe<Scalars['Boolean']>;
  uuid: Scalars['UUID'];
};


export type MutationCancelMemberPathwayArgs = {
  cancelMemberPathwayMutationInput: CancelMemberPathwayMutationInput;
};


export type MutationChangeAccountTopicsArgs = {
  args: ChangeTopicsInput;
};


export type MutationCheckEligibilityArgs = {
  input: CheckEligibilityInput;
};


export type MutationChooseProviderArgs = {
  providerUuid: Scalars['UUID'];
  uuid: Scalars['UUID'];
};


export type MutationCircleAdminCreateBooleanQuestionArgs = {
  data: CircleCreateBooleanQuestionDataInput;
};


export type MutationCircleAdminCreateFacilitatorArgs = {
  data: CircleCreateFacilitatorDataInput;
};


export type MutationCircleAdminCreateFeaturedItemArgs = {
  data: CircleCreateFeaturedItemDataInput;
};


export type MutationCircleAdminCreateFreeResponseQuestionArgs = {
  data: CircleCreateFreeResponseQuestionDataInput;
};


export type MutationCircleAdminCreateMultipleChoiceQuestionArgs = {
  data: CircleCreateMultipleChoiceQuestionDataInput;
};


export type MutationCircleAdminCreateOnDemandTopicArgs = {
  data: CircleCreateOnDemandDataInput;
};


export type MutationCircleAdminCreateRsvpQuestionTopicArgs = {
  data: CircleAdminCreateRsvpQuestionTopicDataInput;
};


export type MutationCircleAdminCreateSegmentedScaleQuestionArgs = {
  data: CircleCreateSegmentedScaleQuestionDataInput;
};


export type MutationCircleAdminCreateSeriesArgs = {
  data: CircleCreateSeriesDataInput;
};


export type MutationCircleAdminCreateSessionArgs = {
  data: CircleCreateSessionDataInput;
};


export type MutationCircleAdminCreateShortResponseQuestionArgs = {
  data: CircleCreateShortResponseQuestionDataInput;
};


export type MutationCircleAdminCreateTopicArgs = {
  data: CircleCreateTopicDataInput;
};


export type MutationCircleAdminDeleteFeaturedItemArgs = {
  featuredItemId: Scalars['ID'];
};


export type MutationCircleAdminDeleteRsvpQuestionTopicArgs = {
  rsvpQuestionTopicId: Scalars['ID'];
};


export type MutationCircleAdminRetryFailedScheduledTasksArgs = {
  scheduledTaskIds: Array<Scalars['ID']>;
};


export type MutationCircleAdminUpdateFacilitatorArgs = {
  data: CircleUpdateFacilitatorDataInput;
  facilitatorId: Scalars['ID'];
};


export type MutationCircleAdminUpdateOnDemandTopicArgs = {
  data: CircleUpdateOnDemandTopicDataInput;
  onDemandTopicId: Scalars['ID'];
};


export type MutationCircleAdminUpdateSeriesArgs = {
  data: CircleUpdateSeriesDataInput;
  seriesId: Scalars['ID'];
};


export type MutationCircleAdminUpdateSessionArgs = {
  data: CircleUpdateSessionDataInput;
  sessionId: Scalars['ID'];
};


export type MutationCircleAdminUpdateTopicArgs = {
  data: CircleUpdateTopicDataInput;
  topicId: Scalars['ID'];
};


export type MutationCircleCancelAuthenticatedRsvpArgs = {
  rsvpId: Scalars['ID'];
};


export type MutationCircleCancelUnauthenticatedRsvpArgs = {
  rsvpEditToken: Scalars['String'];
  rsvpId: Scalars['ID'];
};


export type MutationCircleCreateAuthenticatedRsvpArgs = {
  data: CircleCreateAuthenticatedRsvpDataInput;
};


export type MutationCircleCreateItemFeedbackArgs = {
  data: CircleCreateItemFeedbackInput;
};


export type MutationCircleCreateUnauthenticatedCompanyRsvpArgs = {
  data: CircleCreateUnauthenticatedCompanyRsvpDataInput;
};


export type MutationCircleCreateUnauthenticatedRsvpArgs = {
  data: CircleCreateUnauthenticatedRsvpDataInput;
};


export type MutationCircleUserViewedOnDemandTopicArgs = {
  onDemandTopicId: Scalars['ID'];
};


export type MutationCompleteTestPammInitialEvaluationArgs = {
  coachUuid: Scalars['UUID'];
  memberUuid: Scalars['UUID'];
};


export type MutationConfirmVisitWithoutPaymentArgs = {
  coachingVisitUuid: Scalars['UUID'];
};


export type MutationCreateClientBucketArgs = {
  input: CreateClientBucketInput;
};


export type MutationCreateCoachingVisitMemberReviewArgs = {
  abilityToHelpMe?: Maybe<Scalars['Int']>;
  coachingVisitUuid: Scalars['UUID'];
  exitedAt?: Maybe<Scalars['String']>;
  feedbackText?: Maybe<Scalars['String']>;
  improvedMyWellBeing?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  whatCouldHaveBeenBetter?: Maybe<Array<Maybe<Scalars['String']>>>;
  whatYouLikedAboutYourCoach?: Maybe<Array<Maybe<Scalars['String']>>>;
  workedOnAgreedUponGoals?: Maybe<Scalars['Int']>;
};


export type MutationCreateContentCollectionArgs = {
  contentCollection: ContentCollectionCreateInput;
};


export type MutationCreateContentCollectionLinkArgs = {
  contentCollectionLink: ContentCollectionLinkCreateInput;
};


export type MutationCreateContentLanguageArgs = {
  contentLanguage: ContentLanguageCreateInput;
};


export type MutationCreateContentTagArgs = {
  contentTag: ContentTagCreateInput;
};


export type MutationCreateContentTagCategoryArgs = {
  contentTagCategory: ContentTagCategoryCreateInput;
};


export type MutationCreateContentTagRelationArgs = {
  contentTagRelation: ContentTagRelationCreateInput;
};


export type MutationCreateContentTranslationAvailabilityArgs = {
  contentTranslationAvailability: ContentTranslationAvailabilityCreateInput;
};


export type MutationCreateConversationArgs = {
  coachUuid: Scalars['UUID'];
  kind?: Maybe<ConversationKind>;
};


export type MutationCreateCourseArgs = {
  course: CourseCreateInput;
};


export type MutationCreateCourseActivityGroupArgs = {
  courseActivityGroup: CourseActivityGroupCreateInput;
};


export type MutationCreateCourseGuideArgs = {
  courseGuideInput: CreateCourseGuideMutationInput;
};


export type MutationCreateCourseHeroArgs = {
  createCourseHeroInput: CreateCourseHeroMutationInput;
};


export type MutationCreateCourseOutcomeArgs = {
  courseOutcome: CourseOutcomeCreateInput;
};


export type MutationCreateCourseSectionArgs = {
  courseSection: CourseSectionCreateInput;
};


export type MutationCreateEditCompanyAdditionalBenefitArgs = {
  availableForDependents: Scalars['Boolean'];
  companies?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['Date']>;
  isModernHealthAddOn: Scalars['Boolean'];
  link: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  segments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  startDate?: Maybe<Scalars['Date']>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtopicOfFocus?: Maybe<Scalars['UUID']>;
  title: Scalars['String'];
  topicOfFocus?: Maybe<Scalars['UUID']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationCreateEditCompanySegmentArgs = {
  companySegment: CompanySegmentInput;
};


export type MutationCreateEditCrisisProviderArgs = {
  defaultPhoneNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationCreateEditCrisisProviderCompanyAssignmentArgs = {
  companyUuid: Scalars['UUID'];
  crisisProviderUuid: Scalars['UUID'];
  isActive?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationCreateEditCrisisProviderCountryAssignmentArgs = {
  countryId: Scalars['Int'];
  crisisProviderUuid: Scalars['UUID'];
  phoneNumber?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationCreateEligibilityCheckCoachingVisitArgs = {
  input: CreateEligibilityCheckCoachingVisit;
};


export type MutationCreateEligibilityCheckCoachingVisitForMemberArgs = {
  input: CreateEligibilityCheckCoachingVisitForMember;
};


export type MutationCreateEventArgs = {
  coach?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  end: Scalars['DateTime'];
  ignoreWorkingHours?: Maybe<Scalars['Boolean']>;
  member?: Maybe<Scalars['UUID']>;
  start: Scalars['DateTime'];
  summary?: Maybe<Scalars['String']>;
};


export type MutationCreateHrAdminArgs = {
  hrAdmin: HrAdminCreateInput;
};


export type MutationCreateHrAdminRoleArgs = {
  hrAdminRole: HrAdminRoleCreateInput;
};


export type MutationCreateHrEventArgs = {
  hrEvent: HrEventCreateInput;
};


export type MutationCreateHrResourceArgs = {
  hrResource: HrResourceCreateInput;
};


export type MutationCreateMediaTypeArgs = {
  mediaType: MediaTypeCreateInput;
};


export type MutationCreateMemberPathwayArgs = {
  createMemberPathwayMutationInput: CreateMemberPathwayMutationInput;
};


export type MutationCreateNotificationArgs = {
  receiverId: Scalars['UUID'];
  senderAction: Scalars['String'];
  senderId: Scalars['UUID'];
  senderType: Scalars['String'];
  type: Scalars['String'];
};


export type MutationCreateOrUpdateEmployerCptRatesArgs = {
  input: CreateOrUpdateEmployerCptRateInput;
};


export type MutationCreateOrUpdateEmployerInsuranceArgs = {
  input: CreateOrUpdateEmployerInsuranceInput;
};


export type MutationCreateOrUpdateInsuranceCompanyArgs = {
  input: CreateOrUpdateInsuranceCompanyInput;
};


export type MutationCreateOrUpdatePatientNoteArgs = {
  input?: Maybe<PatientNoteInput>;
};


export type MutationCreateOrUpdatePayerInformationArgs = {
  payerInformation: CreateOrUpdatePayerInformationInput;
};


export type MutationCreateOrUpdateProviderReviewArgs = {
  abilityToHelpClient: Scalars['Int'];
  clearPlanToWorkTowardGoals: Scalars['Int'];
  coachingVisitUuid: Scalars['UUID'];
  feedbackText?: Maybe<Scalars['String']>;
  workedOnAgreedUponGoals: Scalars['Int'];
};


export type MutationCreateOrUpdatePsychiatristReviewArgs = {
  clientIsInterestedInPursuingPammServices: Scalars['Boolean'];
  clientNotInterestedInPammReason?: Maybe<Scalars['String']>;
  coachingVisitUuid: Scalars['UUID'];
  pammIsClinicallyIndicatedForTheClient: Scalars['Boolean'];
};


export type MutationCreatePatientIntakeFormArgs = {
  input?: Maybe<CreatePatientIntakeFormInput>;
};


export type MutationCreateProviderReviewArgs = {
  abilityToHelpClient: Scalars['Int'];
  clearPlanToWorkTowardGoals: Scalars['Int'];
  coachingVisitUuid: Scalars['UUID'];
  feedbackText?: Maybe<Scalars['String']>;
  workedOnAgreedUponGoals: Scalars['Int'];
};


export type MutationCreatePsychiatryVisitMemberReviewArgs = {
  abilityToHelpMe?: Maybe<Scalars['Int']>;
  coachingVisitUuid: Scalars['UUID'];
  exitedAt?: Maybe<Scalars['String']>;
  feedbackText?: Maybe<Scalars['String']>;
  improvedMyWellBeing?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  understandingOfTreatmentPlan?: Maybe<Scalars['Int']>;
  understoodRecommendations?: Maybe<Scalars['String']>;
  whatCouldHaveBeenBetter?: Maybe<Array<Maybe<Scalars['String']>>>;
  whatYouLiked?: Maybe<Array<Maybe<Scalars['String']>>>;
  willContinueWorking?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateSamlPostPageArgs = {
  productUuid: Scalars['UUID'];
};


export type MutationCreateScreenArgs = {
  screen: ScreenCreateInput;
};


export type MutationCreateScreenSectionArgs = {
  screenSection: ScreenSectionCreateInput;
};


export type MutationCreateTestEligiblePersonArgs = {
  companyUuid: Scalars['UUID'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type MutationCreateTestMemberArgs = {
  companyUuid: Scalars['UUID'];
  dateOfBirth: Scalars['Date'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  isHrAdmin?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  password: Scalars['String'];
};


export type MutationCreateTestPammMatchArgs = {
  coachUuid: Scalars['UUID'];
  createTestSessions?: Maybe<Scalars['Boolean']>;
  initialEvaluationStart: Scalars['DateTime'];
  memberUuid: Scalars['UUID'];
};


export type MutationCreateTestProviderArgs = {
  companyUuid: Scalars['UUID'];
  dateOfBirth: Scalars['Date'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  newClientCapacity?: Maybe<Scalars['Int']>;
  password: Scalars['String'];
  providerSchedulingType: Scalars['String'];
  providerType: Scalars['String'];
};


export type MutationCreateTextTrackTranslationArgs = {
  textTrackTranslation: TextTrackTranslationCreateInput;
};


export type MutationCreateVideoContentArgs = {
  videoContent: VideoContentCreateInput;
};


export type MutationCreateVisitArgs = {
  actualDuration?: Maybe<Scalars['Int']>;
  coachAssignmentUuid: Scalars['UUID'];
  cptCode?: Maybe<Scalars['String']>;
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isTherapy?: Maybe<Scalars['Boolean']>;
  modalityType?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  primaryDiagnosisCode?: Maybe<Scalars['String']>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  secondaryDiagnosisCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<Scalars['String']>;
  visitInfo?: Maybe<Scalars['String']>;
};


export type MutationDeleteCalendarProfileArgs = {
  id?: Maybe<Scalars['Int']>;
  profileId: Scalars['String'];
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationDeleteCompanyAdditionalBenefitArgs = {
  uuid: Scalars['UUID'];
};


export type MutationDeleteCompanySegmentArgs = {
  uuid: Scalars['UUID'];
};


export type MutationDeleteContentCollectionArgs = {
  contentCollection: ContentCollectionDeleteInput;
};


export type MutationDeleteContentCollectionLinkArgs = {
  contentCollectionLink: ContentCollectionLinkDeleteInput;
};


export type MutationDeleteContentTagArgs = {
  contentTag: ContentTagDeleteInput;
};


export type MutationDeleteContentTagCategoryArgs = {
  contentTagCategory: ContentTagCategoryDeleteInput;
};


export type MutationDeleteContentTagRelationArgs = {
  contentTagRelation: ContentTagRelationDeleteInput;
};


export type MutationDeleteCourseArgs = {
  course: CourseDeleteInput;
};


export type MutationDeleteCourseActivityGroupArgs = {
  courseActivityGroup: CourseActivityGroupDeleteInput;
};


export type MutationDeleteCourseGuideArgs = {
  courseGuideInput: DeleteCourseGuideMutationInput;
};


export type MutationDeleteCourseHeroArgs = {
  deleteCourseHeroInput: DeleteCourseHeroMutationInput;
};


export type MutationDeleteCourseOutcomeArgs = {
  courseOutcome: CourseOutcomeDeleteInput;
};


export type MutationDeleteCourseSectionArgs = {
  courseSection: CourseSectionDeleteInput;
};


export type MutationDeleteCrisisProviderArgs = {
  uuid: Scalars['UUID'];
};


export type MutationDeleteCrisisProviderCompanyAssignmentArgs = {
  uuid: Scalars['UUID'];
};


export type MutationDeleteCrisisProviderCountryAssignmentArgs = {
  uuid: Scalars['UUID'];
};


export type MutationDeleteHrAdminArgs = {
  hrAdmin: HrAdminDeleteInput;
};


export type MutationDeleteHrAdminRoleArgs = {
  hrAdminRole: HrAdminRoleDeleteInput;
};


export type MutationDeleteHrEventArgs = {
  hrEvent: HrEventDeleteInput;
};


export type MutationDeleteHrResourceArgs = {
  hrResource: HrResourceDeleteInput;
};


export type MutationDeleteMediaTypeArgs = {
  mediaType: MediaTypeDeleteInput;
};


export type MutationDeleteScreenArgs = {
  screen: ScreenDeleteInput;
};


export type MutationDeleteScreenSectionArgs = {
  screenSection: ScreenSectionDeleteInput;
};


export type MutationDeleteTestMemberArgs = {
  uuid: Scalars['UUID'];
};


export type MutationDeleteTestProviderArgs = {
  uuid: Scalars['UUID'];
};


export type MutationDeleteTextTrackTranslationArgs = {
  textTrackTranslation: TextTrackTranslationDeleteInput;
};


export type MutationDeleteVideoContentArgs = {
  videoContent: VideoContentDeleteInput;
};


export type MutationDisableHrAdminArgs = {
  hrAdminUuid: Scalars['UUID'];
};


export type MutationEditHrAdminRoleArgs = {
  hrAdminUuid: Scalars['UUID'];
  role: Scalars['String'];
};


export type MutationFinishCourseActivityArgs = {
  finishCourseActivityInput: CourseProgressMutationInput;
};


export type MutationFinishMeditationArgs = {
  meditationName?: Maybe<Scalars['String']>;
  meditationUuid?: Maybe<Scalars['UUID']>;
};


export type MutationFinishPageArgs = {
  input?: Maybe<Scalars['JSONString']>;
  pageName?: Maybe<Scalars['String']>;
  pageUuid?: Maybe<Scalars['UUID']>;
  programName?: Maybe<Scalars['String']>;
};


export type MutationFinishProgramArgs = {
  programName?: Maybe<Scalars['String']>;
  programUuid?: Maybe<Scalars['UUID']>;
};


export type MutationGetVideoSessionArgs = {
  uuid: Scalars['UUID'];
};


export type MutationHrCreateEditCompanyAdditionalBenefitArgs = {
  availableForDependents: Scalars['Boolean'];
  countries?: Maybe<Array<Maybe<Scalars['String']>>>;
  description: Scalars['String'];
  endDate?: Maybe<Scalars['Date']>;
  link: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  segments?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  startDate?: Maybe<Scalars['Date']>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  subtopicOfFocus?: Maybe<Scalars['UUID']>;
  title: Scalars['String'];
  topicOfFocus?: Maybe<Scalars['UUID']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type MutationHrCreateEditCompanySegmentArgs = {
  companySegment: HrCompanySegmentInput;
};


export type MutationHrDeleteCompanyAdditionalBenefitArgs = {
  uuid: Scalars['UUID'];
};


export type MutationHrDeleteCompanySegmentArgs = {
  uuid: Scalars['UUID'];
};


export type MutationInAppReviewFlowCompletedArgs = {
  store: InAppReviewStore;
};


export type MutationInviteBulkHrAdminsArgs = {
  emails: Array<Maybe<EmailRoleInput>>;
};


export type MutationInviteDependentArgs = {
  inviteDependent: InviteDependentInput;
};


export type MutationInviteHrAdminArgs = {
  email: Scalars['String'];
};


export type MutationLinkCronofyCalendarArgs = {
  code: Scalars['String'];
  redirectUri?: Maybe<Scalars['String']>;
};


export type MutationLogHrisConnectionArgs = {
  connection: LogHrisConnectionInput;
};


export type MutationMarkCoachingVisitEndArgs = {
  uuid: Scalars['UUID'];
};


export type MutationMarkCoachingVisitStartArgs = {
  uuid: Scalars['UUID'];
};


export type MutationMatchedProvidersArgs = {
  careRecommendationUuid: Scalars['UUID'];
  pagination?: Maybe<PaginationInput>;
  preferences?: Maybe<MemberPreferencesInput>;
  providerTypeOverride?: Maybe<Scalars['String']>;
};


export type MutationMergeEligiblePersonArgs = {
  input: MergeEligiblePersonInput;
};


export type MutationNewBulkMessageArgs = {
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  clientsUuids: Array<Maybe<Scalars['UUID']>>;
  encryptedContent: Scalars['String'];
  kind?: Maybe<Scalars['String']>;
  messageResources?: Maybe<Array<Maybe<MessageResourceInput>>>;
  messageUuid?: Maybe<Scalars['UUID']>;
  senderUuid: Scalars['UUID'];
};


export type MutationNewMessageArgs = {
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  clientsUuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  encryptedContent: Scalars['String'];
  kind?: Maybe<Scalars['String']>;
  messageResources?: Maybe<Array<Maybe<MessageResourceInput>>>;
  messageUuid?: Maybe<Scalars['UUID']>;
  senderUuid: Scalars['UUID'];
};


export type MutationOverrideTranslationArgs = {
  languageCode: Scalars['String'];
  overrideText: Scalars['String'];
  translationKey: Scalars['String'];
};


export type MutationPhoneSupportGenerateOtpArgs = {
  uuid: Scalars['UUID'];
};


export type MutationPhoneSupportToggleTherapyAccessShortcutArgs = {
  uuid: Scalars['UUID'];
};


export type MutationPhoneSupportUpdateMemberEmailArgs = {
  memberUuid: Scalars['UUID'];
  newEmail: Scalars['String'];
};


export type MutationRateScheduledContentArgs = {
  rating: ScheduledContentFeedbackRatingType;
  review?: Maybe<Scalars['String']>;
  scheduledContentUuid: Scalars['UUID'];
};


export type MutationRecommendCareArgs = {
  modalityPreference?: Maybe<CareRecommendationModality>;
  uuid: Scalars['UUID'];
};


export type MutationRecordPresenceChangeArgs = {
  coachUuid?: Maybe<Scalars['UUID']>;
  eventDatetime?: Maybe<Scalars['DateTime']>;
  onProviderDashboard?: Maybe<Scalars['Boolean']>;
  onlineForLiveCoaching?: Maybe<Scalars['Boolean']>;
  onlineForMyClients?: Maybe<Scalars['Boolean']>;
};


export type MutationRecordScheduledContentActivityArgs = {
  activityType: ScheduledContentActivityType;
  scheduledContentUuid: Scalars['UUID'];
};


export type MutationRemoveCoachArgs = {
  coachUuid: Scalars['String'];
};


export type MutationRemoveModelKeyFromCacheArgs = {
  modelName: Scalars['String'];
};


export type MutationRequestManualProviderMatchArgs = {
  preferences: Scalars['JSONString'];
  uuid: Scalars['UUID'];
};


export type MutationRescheduleEventArgs = {
  newStart: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};


export type MutationResetEligibilityForMemberArgs = {
  input: ResetEligibilityForMember;
};


export type MutationResetTestAccountPasswordArgs = {
  uuid: Scalars['UUID'];
};


export type MutationReviewProgramArgs = {
  dislikedReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  likedReasons?: Maybe<Array<Maybe<Scalars['String']>>>;
  programUuid: Scalars['UUID'];
  rating?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
};


export type MutationSaveContentResponsesArgs = {
  content: Scalars['JSONString'];
};


export type MutationSaveNewClientCapacityArgs = {
  providerSchedulingType?: Maybe<Scalars['String']>;
  updatedNewClientCapacity?: Maybe<Scalars['Int']>;
};


export type MutationSaveRatingArgs = {
  coachingVisitUuid: Scalars['UUID'];
  contentType?: Maybe<RatingContentTypeEnum>;
  feedbackText?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  reasons?: Maybe<Array<Maybe<Scalars['String']>>>;
};


export type MutationSelectDifficultyArgs = {
  difficultyAgreement: DifficultyAgreement;
  uuid: Scalars['UUID'];
};


export type MutationSelectModalityArgs = {
  modalityPreference?: Maybe<CareRecommendationModality>;
  uuid: Scalars['UUID'];
};


export type MutationSelectPrimaryFocusArgs = {
  subtopicSelectionUuid: Scalars['UUID'];
};


export type MutationSelectTopicsOfFocusArgs = {
  careRecommendationUuid: Scalars['UUID'];
  topicSelections?: Maybe<Array<Maybe<TopicInput>>>;
};


export type MutationSendMemberEmailReminderArgs = {
  coachingVisitUuid?: Maybe<Scalars['UUID']>;
};


export type MutationSendMemberExtendTherapyEmailReminderArgs = {
  memberUuid?: Maybe<Scalars['UUID']>;
};


export type MutationStartAssessmentFlowArgs = {
  associatedVisitUuid?: Maybe<Scalars['UUID']>;
  careRecommendationUuid?: Maybe<Scalars['UUID']>;
  flowType?: Maybe<Scalars['String']>;
};


export type MutationStartAssessmentJourneyArgs = {
  input: StartAssessmentJourneyInput;
};


export type MutationStartCareRecommendationArgs = {
  onboarding?: Maybe<Scalars['Boolean']>;
};


export type MutationStartCourseActivityArgs = {
  startCourseActivityInput: CourseProgressMutationInput;
};


export type MutationStartMeditationArgs = {
  meditationName?: Maybe<Scalars['String']>;
  meditationUuid?: Maybe<Scalars['UUID']>;
};


export type MutationStartMemberPathwayArgs = {
  startMemberPathwayMutationInput: StartMemberPathwayMutationInput;
};


export type MutationStartPageArgs = {
  pageName?: Maybe<Scalars['String']>;
  pageUuid?: Maybe<Scalars['UUID']>;
  programName?: Maybe<Scalars['String']>;
};


export type MutationStartProgramArgs = {
  programName?: Maybe<Scalars['String']>;
  programUuid?: Maybe<Scalars['UUID']>;
};


export type MutationSubmitAssessmentResponseForJourneyArgs = {
  input: SubmitAssessmentResultInput;
};


export type MutationSubmitAssessmentsArgs = {
  assessmentFlowUuid?: Maybe<Scalars['UUID']>;
  careRecommendationUuid?: Maybe<Scalars['UUID']>;
  content: Scalars['JSONString'];
};


export type MutationSubmitCancelledSessionReviewArgs = {
  cancelledSessionReview: CancelledSessionReviewInput;
};


export type MutationSubmitCourseSectionReviewArgs = {
  courseSectionReview: CourseSectionReviewInput;
};


export type MutationSubmitFeatureReviewArgs = {
  featureReview: FeatureRecordReviewInput;
};


export type MutationSubmitModularizedAssessmentsArgs = {
  input: SubmitModularizedAssessmentInput;
};


export type MutationSubmitNpsArgs = {
  coachingVisitUuid?: Maybe<Scalars['UUID']>;
  feedbackText?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
};


export type MutationSubmitPathwayAssessmentArgs = {
  data: SubmitPathwayAssessmentMutationInput;
};


export type MutationSubmitPathwayReviewArgs = {
  pathwayReview: PathwayReviewInput;
};


export type MutationSyncUuidsArgs = {
  uuidSpecifications: Array<Maybe<UuidSpecificationInput>>;
};


export type MutationTimeToCareLabelsArgs = {
  providersList: ProviderListInput;
};


export type MutationUpdateAccountSharedPreferencesArgs = {
  key: Scalars['String'];
  value: Scalars['String'];
};


export type MutationUpdateAvailableHoursArgs = {
  availableHours?: Maybe<Array<Maybe<AvailableHourInput>>>;
};


export type MutationUpdateCalendarArgs = {
  isActive: Scalars['Boolean'];
  isTarget: Scalars['Boolean'];
  uuid: Scalars['UUID'];
};


export type MutationUpdateClientBucketArgs = {
  input: UpdateClientBucketInput;
};


export type MutationUpdateCoachingVisitArgs = {
  actualDuration?: Maybe<Scalars['Int']>;
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isTherapy?: Maybe<Scalars['Boolean']>;
  modalityType?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  reviews?: Maybe<Array<Maybe<ReviewInputNode>>>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  state?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  visitInfo?: Maybe<Scalars['String']>;
};


export type MutationUpdateContentCollectionArgs = {
  contentCollection: ContentCollectionUpdateInput;
};


export type MutationUpdateContentCollectionLinkArgs = {
  contentCollectionLink: ContentCollectionLinkUpdateInput;
};


export type MutationUpdateContentLanguageArgs = {
  contentLanguage: ContentLanguageUpdateInput;
};


export type MutationUpdateContentTagArgs = {
  contentTag: ContentTagUpdateInput;
};


export type MutationUpdateContentTagCategoryArgs = {
  contentTagCategory: ContentTagCategoryUpdateInput;
};


export type MutationUpdateContentTagRelationArgs = {
  contentTagRelation: ContentTagRelationUpdateInput;
};


export type MutationUpdateContentTranslationAvailabilityArgs = {
  contentTranslationAvailability: ContentTranslationAvailabilityUpdateInput;
};


export type MutationUpdateConversationArgs = {
  active?: Maybe<Scalars['Boolean']>;
  kind?: Maybe<ConversationKind>;
  uuid: Scalars['UUID'];
};


export type MutationUpdateCourseArgs = {
  course: CourseUpdateInput;
};


export type MutationUpdateCourseActivityGroupArgs = {
  courseActivityGroup: CourseActivityGroupUpdateInput;
};


export type MutationUpdateCourseHeroArgs = {
  updateCourseHeroInput: UpdateCourseHeroMutationInput;
};


export type MutationUpdateCourseOutcomeArgs = {
  courseOutcome: CourseOutcomeUpdateInput;
};


export type MutationUpdateCourseSectionArgs = {
  courseSection: CourseSectionUpdateInput;
};


export type MutationUpdateHrAdminArgs = {
  hrAdmin: HrAdminUpdateInput;
};


export type MutationUpdateHrAdminRoleArgs = {
  hrAdminRole: HrAdminRoleUpdateInput;
};


export type MutationUpdateHrEventArgs = {
  hrEvent: HrEventUpdateInput;
};


export type MutationUpdateHrResourceArgs = {
  hrResource: HrResourceUpdateInput;
};


export type MutationUpdateIntakeFormArgs = {
  exitedAt?: Maybe<Scalars['String']>;
  formInput?: Maybe<IntakeFormQuestionResponseInputNode>;
  intakeFormUuid: Scalars['UUID'];
  submitted?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateMediaTypeArgs = {
  mediaType: MediaTypeUpdateInput;
};


export type MutationUpdateMeditationProgressArgs = {
  meditationUuid: Scalars['UUID'];
  progressPercentage: Scalars['Float'];
};


export type MutationUpdateMemberProfileArgs = {
  memberProfile: MemberProfileInput;
};


export type MutationUpdateMessageArgs = {
  acknowledgedAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  encryptedContent?: Maybe<Scalars['String']>;
  messageUuid: Scalars['UUID'];
  readAt?: Maybe<Scalars['DateTime']>;
};


export type MutationUpdateMyNameArgs = {
  newName: Scalars['String'];
};


export type MutationUpdateNameArgs = {
  updateNameInput?: Maybe<UpdateNameInput>;
};


export type MutationUpdateNotificationPreferencesArgs = {
  notificationPreferences: NotificationPreferencesInput;
};


export type MutationUpdatePageProgressArgs = {
  multimediaProgressPercentage: Scalars['Float'];
  pageUuid: Scalars['UUID'];
};


export type MutationUpdatePatientIntakeFormArgs = {
  input?: Maybe<UpdatePatientIntakeFormInput>;
};


export type MutationUpdateProviderProfileArgs = {
  data: ProviderProfileInput;
};


export type MutationUpdateProviderReviewArgs = {
  abilityToHelpClient: Scalars['Int'];
  clearPlanToWorkTowardGoals: Scalars['Int'];
  coachingVisitUuid: Scalars['UUID'];
  feedbackText?: Maybe<Scalars['String']>;
  workedOnAgreedUponGoals: Scalars['Int'];
};


export type MutationUpdateScreenArgs = {
  screen: ScreenUpdateInput;
};


export type MutationUpdateScreenSectionArgs = {
  screenSection: ScreenSectionUpdateInput;
};


export type MutationUpdateTextTrackTranslationArgs = {
  textTrackTranslation: TextTrackTranslationUpdateInput;
};


export type MutationUpdateVideoContentArgs = {
  videoContent: VideoContentUpdateInput;
};


export type MutationUpdateVisitArgs = {
  actualDuration?: Maybe<Scalars['Int']>;
  coachingVisitUuid: Scalars['UUID'];
  cptCode?: Maybe<Scalars['String']>;
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isTherapy?: Maybe<Scalars['Boolean']>;
  modalityType?: Maybe<Scalars['String']>;
  organizationImprovements?: Maybe<Scalars['String']>;
  primaryDiagnosisCode?: Maybe<Scalars['String']>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  secondaryDiagnosisCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  state?: Maybe<Scalars['String']>;
  visitInfo?: Maybe<Scalars['String']>;
};


export type MutationUploadCompanyCsvArgs = {
  companyUuid: Scalars['UUID'];
  file: Scalars['Upload'];
};


export type MutationValidatePendingCoachingVisitArgs = {
  coachingVisitUuid: Scalars['UUID'];
};

export type NewBulkMessageMutation = {
  __typename?: 'NewBulkMessageMutation';
  messagesList?: Maybe<Array<Maybe<MessageNode>>>;
};

export type NewMessageMutation = {
  __typename?: 'NewMessageMutation';
  message?: Maybe<MessageNode>;
  messagesList?: Maybe<Array<Maybe<MessageNode>>>;
};

export type Node = {
  id: Scalars['ID'];
};

export type NoteNode = {
  __typename?: 'NoteNode';
  coachAssignment: CoachAssignmentNode;
  createdAt: Scalars['DateTime'];
  encryptedContent: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type NotificationPreferencesInput = {
  chatNotifications?: Maybe<Scalars['Boolean']>;
  courseReminders?: Maybe<Scalars['Boolean']>;
  dailyPauseRemindersEmail?: Maybe<Scalars['Boolean']>;
  dailyPauseRemindersPush?: Maybe<Scalars['Boolean']>;
  wellBeingReminders?: Maybe<Scalars['Boolean']>;
};

export type NotificationPreferencesNode = {
  __typename?: 'NotificationPreferencesNode';
  chatNotifications: Scalars['Boolean'];
  courseReminders: Scalars['Boolean'];
  dailyPauseRemindersEmail: Scalars['Boolean'];
  dailyPauseRemindersPush: Scalars['Boolean'];
  wellBeingReminders: Scalars['Boolean'];
};

export type OverrideTranslationResponseType = {
  __typename?: 'OverrideTranslationResponseType';
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
  translation?: Maybe<TranslationNode>;
};

export enum PageContentHorizontalAlignment {
  Center = 'CENTER',
  Start = 'START'
}

export enum PageContentVerticalAlignment {
  Middle = 'MIDDLE',
  Top = 'TOP'
}

export type PageFinishMutation = {
  __typename?: 'PageFinishMutation';
  error?: Maybe<Scalars['String']>;
  pageProgress?: Maybe<PageProgressNode>;
};

export enum PageFirstBackgroundImagePosition {
  BottomCenter = 'BOTTOM_CENTER',
  BottomLeft = 'BOTTOM_LEFT',
  BottomRight = 'BOTTOM_RIGHT'
}

export enum PageImageSize {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage: Scalars['Boolean'];
  hasPreviousPage: Scalars['Boolean'];
  startCursor?: Maybe<Scalars['String']>;
};

export type PageNode = {
  __typename?: 'PageNode';
  answerOptions?: Maybe<Scalars['JSONString']>;
  audioFile?: Maybe<Scalars['String']>;
  backgroundColor?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  contentHorizontalAlignment: PageContentHorizontalAlignment;
  contentVerticalAlignment: PageContentVerticalAlignment;
  createdAt: Scalars['DateTime'];
  currentPageProgress?: Maybe<PageProgressNode>;
  firstBackgroundImagePosition?: Maybe<PageFirstBackgroundImagePosition>;
  firstBackgroundImageUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imagePosition?: Maybe<Scalars['String']>;
  imageSize?: Maybe<PageImageSize>;
  multiselectConfig?: Maybe<Scalars['JSONString']>;
  name: Scalars['String'];
  number: Scalars['Int'];
  pageProgress: Array<PageProgressNode>;
  parsedAnswerOptions?: Maybe<Array<AnswerOption>>;
  parsedMultiselectConfig?: Maybe<MultiselectConfig>;
  program: ProgramNode;
  secondBackgroundImagePosition?: Maybe<PageSecondBackgroundImagePosition>;
  secondBackgroundImageUrl?: Maybe<Scalars['String']>;
  textColor?: Maybe<Scalars['String']>;
  translationKey?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
  videoContent?: Maybe<VideoContentNode>;
};

export type PageProgressNode = {
  __typename?: 'PageProgressNode';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  input: Scalars['JSONString'];
  multimediaProgressPercentage?: Maybe<Scalars['Float']>;
  page?: Maybe<PageNode>;
  parsedInput?: Maybe<Array<UserInput>>;
  programProgress: ProgramProgressNode;
  startedAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum PageSecondBackgroundImagePosition {
  BottomCenter = 'BOTTOM_CENTER',
  BottomLeft = 'BOTTOM_LEFT',
  BottomRight = 'BOTTOM_RIGHT'
}

export type PageStartMutation = {
  __typename?: 'PageStartMutation';
  error?: Maybe<Scalars['String']>;
  pageProgress?: Maybe<PageProgressNode>;
};

export type PageUpdateMultimediaProgress = {
  __typename?: 'PageUpdateMultimediaProgress';
  pageProgress?: Maybe<PageProgressNode>;
};

export type PaginationInput = {
  pageNumber?: Maybe<Scalars['Int']>;
  pageSize?: Maybe<Scalars['Int']>;
};

export type PathwayAssessmentInvalid = {
  __typename?: 'PathwayAssessmentInvalid';
  message?: Maybe<Scalars['String']>;
};

export type PathwayAssessmentSubmitted = {
  __typename?: 'PathwayAssessmentSubmitted';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum PathwayAvailabilityState {
  Everyone = 'EVERYONE',
  Nobody = 'NOBODY',
  Reviewers = 'REVIEWERS'
}

export type PathwayDoesNotExist = {
  __typename?: 'PathwayDoesNotExist';
  uuid?: Maybe<Scalars['UUID']>;
};

export type PathwayNode = Node & {
  __typename?: 'PathwayNode';
  assessment: AssessmentNode;
  assessmentSessionOrdering: Array<Scalars['Int']>;
  availabilityState: PathwayAvailabilityState;
  careActions?: Maybe<Array<Maybe<ContentLinkNode>>>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  memberPathway?: Maybe<MemberPathwayNode>;
  metadata: Scalars['GenericScalar'];
  pathwayprogressSet: ProviderMemberPathwayNodeConnection;
  providers: PathwayProviderNodeConnection;
  sessionCount: Scalars['Int'];
  slug: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
  topics: PathwayTopicNodeConnection;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};


export type PathwayNodePathwayprogressSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PathwayNodeProvidersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type PathwayNodeTopicsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export enum PathwayProgressState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS'
}

export type PathwayProviderNode = Node & {
  __typename?: 'PathwayProviderNode';
  active: Scalars['Boolean'];
  biography: Scalars['String'];
  createdAt: Scalars['DateTime'];
  featured: Scalars['Boolean'];
  featuredAvatar?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  pathway: ProviderPathwayNode;
  provider: CoachNode;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type PathwayProviderNodeConnection = {
  __typename?: 'PathwayProviderNodeConnection';
  edges: Array<Maybe<PathwayProviderNodeEdge>>;
  pageInfo: PageInfo;
};

export type PathwayProviderNodeEdge = {
  __typename?: 'PathwayProviderNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<PathwayProviderNode>;
};

export type PathwayReviewInput = {
  confidenceInIncorporatingSkills?: Maybe<Scalars['Int']>;
  confidenceInSkillsLearned?: Maybe<Scalars['Int']>;
  feedbackText?: Maybe<Scalars['String']>;
  likelyToRecommend?: Maybe<Scalars['Int']>;
  likelyToRecommendFeedbackText?: Maybe<Scalars['String']>;
  pathwayUuid: Scalars['UUID'];
  rating?: Maybe<Scalars['Int']>;
  whatCouldHaveBeenBetter?: Maybe<Array<Maybe<Scalars['String']>>>;
  whatYouLikedAboutPathway?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PathwaySessionNode = {
  __typename?: 'PathwaySessionNode';
  coachingVisit?: Maybe<CoachingVisitNode>;
  state: PathwaySessionState;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export enum PathwaySessionState {
  Completed = 'COMPLETED',
  Joinable = 'JOINABLE',
  Locked = 'LOCKED',
  Scheduled = 'SCHEDULED',
  Unscheduled = 'UNSCHEDULED'
}

export type PathwayTopicGoalNode = {
  __typename?: 'PathwayTopicGoalNode';
  icon: Scalars['String'];
  title: Scalars['String'];
};

export type PathwayTopicNode = Node & {
  __typename?: 'PathwayTopicNode';
  assessmentActivity?: Maybe<AssessmentActivityNode>;
  contentCollection?: Maybe<ContentCollectionNode>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  duration: Scalars['Int'];
  goals: Array<Maybe<PathwayTopicGoalNode>>;
  id: Scalars['ID'];
  pathway: ProviderPathwayNode;
  recommendedActivities?: Maybe<Array<Maybe<ContentLinkNode>>>;
  sessionDetail?: Maybe<PathwaySessionNode>;
  subtitle: Scalars['String'];
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type PathwayTopicNodeConnection = {
  __typename?: 'PathwayTopicNodeConnection';
  edges: Array<Maybe<PathwayTopicNodeEdge>>;
  pageInfo: PageInfo;
};

export type PathwayTopicNodeEdge = {
  __typename?: 'PathwayTopicNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<PathwayTopicNode>;
};

export type PatientChartNode = {
  __typename?: 'PatientChartNode';
  additionalPhoneNumber?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderIdentity?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  locations?: Maybe<Array<Maybe<LocationNode>>>;
  phoneNumber?: Maybe<Scalars['String']>;
  pronouns?: Maybe<Scalars['String']>;
  quickNotes?: Maybe<Scalars['String']>;
  sex?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type PatientIntakeFormAnswersNode = {
  __typename?: 'PatientIntakeFormAnswersNode';
  answer: Scalars['String'];
  id: Scalars['ID'];
  intakeFormTemplateId: Scalars['ID'];
  label: Scalars['String'];
  modType?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['String']>;
};

export type PatientIntakeFormNode = {
  __typename?: 'PatientIntakeFormNode';
  id: Scalars['ID'];
  intakeFormAnswers?: Maybe<Array<Maybe<PatientIntakeFormAnswersNode>>>;
  name?: Maybe<Scalars['String']>;
};

export type PatientIntakeFormResponse = {
  __typename?: 'PatientIntakeFormResponse';
  error?: Maybe<Scalars['String']>;
  intakeForm?: Maybe<PatientIntakeFormNode>;
  ok: Scalars['Boolean'];
};

export type PatientIntakeFormTemplateFieldNode = {
  __typename?: 'PatientIntakeFormTemplateFieldNode';
  fieldType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  options?: Maybe<Scalars['String']>;
  optionsArray?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PatientIntakeFormTemplateNode = {
  __typename?: 'PatientIntakeFormTemplateNode';
  fields?: Maybe<Array<Maybe<PatientIntakeFormTemplateFieldNode>>>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type PatientNoteAnswersNode = {
  __typename?: 'PatientNoteAnswersNode';
  answer: Scalars['String'];
  id: Scalars['ID'];
  label: Scalars['String'];
  modType?: Maybe<Scalars['String']>;
  noteTemplateQuestionId: Scalars['ID'];
  options?: Maybe<Scalars['String']>;
};

export type PatientNoteInput = {
  memberUuid: Scalars['UUID'];
  name: Scalars['String'];
  noteTemplateId: Scalars['ID'];
};

export type PatientNoteNode = {
  __typename?: 'PatientNoteNode';
  formAnswers?: Maybe<Array<Maybe<PatientNoteAnswersNode>>>;
  id: Scalars['String'];
  memberUuid?: Maybe<Scalars['UUID']>;
  name: Scalars['String'];
  noteTemplateId?: Maybe<Scalars['ID']>;
};

export type PatientNoteResponse = {
  __typename?: 'PatientNoteResponse';
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
  patientNote?: Maybe<PatientNoteNode>;
};

export type PayerInformationNode = {
  __typename?: 'PayerInformationNode';
  accountUuid?: Maybe<Scalars['UUID']>;
  addressOne: Scalars['String'];
  addressTwo?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  emailAddress: Scalars['String'];
  enrolledInAutoPayments?: Maybe<Scalars['Boolean']>;
  firstName: Scalars['String'];
  lastNameOne: Scalars['String'];
  lastNameTwo?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type PaymentInfoForVisitNode = {
  __typename?: 'PaymentInfoForVisitNode';
  chargeAmount: Scalars['Float'];
};

export type PaymentRequestNode = {
  __typename?: 'PaymentRequestNode';
  accountUuid: Scalars['UUID'];
  chargeAmount: Scalars['Float'];
  eligibilityReferenceUuid: Scalars['UUID'];
  isFullyPaid: Scalars['Boolean'];
  productUuid: Scalars['UUID'];
  status: PaymentRequestStatus;
  timeOfService: Scalars['DateTime'];
  transactions?: Maybe<Array<Maybe<TransactionNode>>>;
};

export enum PaymentRequestStatus {
  Cancelled = 'CANCELLED',
  FullyPaid = 'FULLY_PAID',
  FullyRefunded = 'FULLY_REFUNDED',
  FullChargeback = 'FULL_CHARGEBACK',
  PartiallyPaid = 'PARTIALLY_PAID',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  PartialChargeback = 'PARTIAL_CHARGEBACK',
  PendingAutopay = 'PENDING_AUTOPAY',
  PendingPayment = 'PENDING_PAYMENT',
  PendingRefund = 'PENDING_REFUND'
}

export type PermissionDeniedError = BaseError & {
  __typename?: 'PermissionDeniedError';
  debug?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type PersonNode = {
  __typename?: 'PersonNode';
  createdAt: Scalars['DateTime'];
  name: Scalars['String'];
  personType: PersonType;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export enum PersonType {
  Human = 'HUMAN',
  Superhero = 'SUPERHERO'
}

export type PhoneSupportBenefitsNode = {
  __typename?: 'PhoneSupportBenefitsNode';
  hasCareNavigationAccess?: Maybe<Scalars['Boolean']>;
  hasDependentAccess?: Maybe<Scalars['Boolean']>;
  hasHpiCoverage?: Maybe<Scalars['Boolean']>;
  hasPammCoverage?: Maybe<Scalars['Boolean']>;
  hasPathwaysAccess?: Maybe<Scalars['Boolean']>;
};

export type PhoneSupportCobraEligibilityPeriod = {
  __typename?: 'PhoneSupportCobraEligibilityPeriod';
  endDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
};

export type PhoneSupportCompanyNode = {
  __typename?: 'PhoneSupportCompanyNode';
  companyCode?: Maybe<Scalars['String']>;
  currentContractPeriod?: Maybe<PhoneSupportContractPeriod>;
  name?: Maybe<Scalars['String']>;
  ssoEnabled?: Maybe<Scalars['Boolean']>;
  ssoOnly?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type PhoneSupportContractPeriod = {
  __typename?: 'PhoneSupportContractPeriod';
  endDate?: Maybe<Scalars['Date']>;
  startDate?: Maybe<Scalars['Date']>;
};

export type PhoneSupportCrisisProviderNode = {
  __typename?: 'PhoneSupportCrisisProviderNode';
  companyPhoneNumber?: Maybe<Scalars['String']>;
  countryPhoneNumber?: Maybe<Scalars['String']>;
};

export type PhoneSupportDependentInfoNode = {
  __typename?: 'PhoneSupportDependentInfoNode';
  benefits?: Maybe<PhoneSupportBenefitsNode>;
  careRecommendation?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  coachingVisitsRemaining?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  coveredCoachingVisits?: Maybe<Scalars['Int']>;
  coveredTherapyVisits?: Maybe<Scalars['Int']>;
  crisisProvider?: Maybe<PhoneSupportCrisisProviderNode>;
  providerMatch?: Maybe<PhoneSupportProviderMatchNode>;
  state?: Maybe<Scalars['String']>;
  therapyAccessShortcut?: Maybe<Scalars['Boolean']>;
  therapyVisitsRemaining?: Maybe<Scalars['Int']>;
  wellBeingScore?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type PhoneSupportDependentInfoOutput = InternalToolPermissionDeniedError | PhoneSupportDependentInfoSuccessResponse;

export type PhoneSupportDependentInfoSuccessResponse = {
  __typename?: 'PhoneSupportDependentInfoSuccessResponse';
  info?: Maybe<PhoneSupportDependentInfoNode>;
};

export type PhoneSupportDependentSearchResultNode = {
  __typename?: 'PhoneSupportDependentSearchResultNode';
  active?: Maybe<Scalars['Boolean']>;
  birthDate?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type PhoneSupportGenerateOtpOutput = InternalToolPermissionDeniedError | PhoneSupportGenerateOtpSuccessResponse;

export type PhoneSupportGenerateOtpSuccessResponse = {
  __typename?: 'PhoneSupportGenerateOTPSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
  otp?: Maybe<Scalars['String']>;
};

export type PhoneSupportMemberInfoNode = {
  __typename?: 'PhoneSupportMemberInfoNode';
  benefits?: Maybe<PhoneSupportBenefitsNode>;
  careRecommendation?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  coachingVisitsRemaining?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  coveredCoachingVisits?: Maybe<Scalars['Int']>;
  coveredTherapyVisits?: Maybe<Scalars['Int']>;
  crisisProvider?: Maybe<PhoneSupportCrisisProviderNode>;
  hasAccount?: Maybe<Scalars['Boolean']>;
  providerMatch?: Maybe<PhoneSupportProviderMatchNode>;
  state?: Maybe<Scalars['String']>;
  therapyAccessShortcut?: Maybe<Scalars['Boolean']>;
  therapyVisitsRemaining?: Maybe<Scalars['Int']>;
  wellBeingScore?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type PhoneSupportMemberInfoOutput = InternalToolPermissionDeniedError | PhoneSupportMemberInfoSuccessResponse;

export type PhoneSupportMemberInfoSuccessResponse = {
  __typename?: 'PhoneSupportMemberInfoSuccessResponse';
  info?: Maybe<PhoneSupportMemberInfoNode>;
};

export type PhoneSupportMemberNode = {
  __typename?: 'PhoneSupportMemberNode';
  active?: Maybe<Scalars['Boolean']>;
  birthDate?: Maybe<Scalars['Date']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type PhoneSupportMemberSearchOutput = InternalToolPermissionDeniedError | PhoneSupportMemberSearchSuccessResponse;

export type PhoneSupportMemberSearchResultNode = {
  __typename?: 'PhoneSupportMemberSearchResultNode';
  birthDate?: Maybe<Scalars['Date']>;
  cobraEligibilityPeriod?: Maybe<PhoneSupportCobraEligibilityPeriod>;
  eligible?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  member?: Maybe<PhoneSupportMemberNode>;
  registered?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['UUID']>;
};

export type PhoneSupportMemberSearchSuccessResponse = {
  __typename?: 'PhoneSupportMemberSearchSuccessResponse';
  company?: Maybe<PhoneSupportCompanyNode>;
  dependents?: Maybe<Array<Maybe<PhoneSupportDependentSearchResultNode>>>;
  eligiblePersons?: Maybe<Array<Maybe<PhoneSupportMemberSearchResultNode>>>;
};

export type PhoneSupportProviderMatchNode = {
  __typename?: 'PhoneSupportProviderMatchNode';
  coaches?: Maybe<Array<Maybe<Scalars['String']>>>;
  mentalHealthCoaches?: Maybe<Array<Maybe<Scalars['String']>>>;
  therapists?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PhoneSupportToggleTherapyAccessShortcutOutput = InternalToolPermissionDeniedError | PhoneSupportToggleTherapyAccessShortcutSuccessResponse;

export type PhoneSupportToggleTherapyAccessShortcutSuccessResponse = {
  __typename?: 'PhoneSupportToggleTherapyAccessShortcutSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type PhoneSupportUpdateMemberEmailOutput = InternalToolPermissionDeniedError | PhoneSupportUpdateMemberEmailSuccessResponse;

export type PhoneSupportUpdateMemberEmailSuccessResponse = {
  __typename?: 'PhoneSupportUpdateMemberEmailSuccessResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type Phq9Access = {
  __typename?: 'Phq9Access';
  lastAccess?: Maybe<Scalars['DateTime']>;
  phq9SelfHarmScore?: Maybe<Scalars['Int']>;
  showTakeOverScreen?: Maybe<Scalars['Boolean']>;
};

export type Phq9SelfharmScoreNode = Node & {
  __typename?: 'Phq9SelfharmScoreNode';
  assessmentFlowId?: Maybe<Scalars['Int']>;
  date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  score?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type PossibleReportAndSectionType = AvailableReportType | AvailableSectionType | UnavailableReportType | UnavailableSectionType;

export type PossibleReportType = AvailableReportType | UnavailableReportType;

export enum ProductType {
  PsychiatryFollowUp = 'PSYCHIATRY_FOLLOW_UP',
  PsychiatryInitialEvaluation = 'PSYCHIATRY_INITIAL_EVALUATION',
  Therapy = 'THERAPY'
}

export enum ProgramAvailabilityState {
  Everyone = 'EVERYONE',
  Nobody = 'NOBODY',
  Reviewers = 'REVIEWERS'
}

export type ProgramFinishMutation = {
  __typename?: 'ProgramFinishMutation';
  programProgress?: Maybe<ProgramProgressNode>;
};

export type ProgramLinkNode = Node & {
  __typename?: 'ProgramLinkNode';
  banner?: Maybe<ContentBannerNode>;
  id: Scalars['ID'];
  index?: Maybe<Scalars['Int']>;
  mediaType?: Maybe<MediaTypeNode>;
  mobileValue?: Maybe<Scalars['String']>;
  program: ProgramNode;
  uuid: Scalars['UUID'];
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type ProgramNode = {
  __typename?: 'ProgramNode';
  availabilityState: ProgramAvailabilityState;
  banner?: Maybe<ContentBannerNode>;
  category?: Maybe<Scalars['String']>;
  categoryTranslationKey: Scalars['String'];
  contentTranslationAvailability: ContentTranslationAvailabilityNodeConnection;
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['JSONString']>;
  defaultOrdering?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['Int']>;
  hideFromIndexQueries?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  internalName: Scalars['String'];
  isCompleted?: Maybe<Scalars['Boolean']>;
  isNew: Scalars['Boolean'];
  isProgramBuilder: Scalars['Boolean'];
  isSearchable?: Maybe<Scalars['Boolean']>;
  isStarted?: Maybe<Scalars['Boolean']>;
  lockedBy?: Maybe<ProgramNode>;
  mediaType?: Maybe<MediaTypeNode>;
  messageResources: Array<MessageResourceNode>;
  name: Scalars['String'];
  nameTranslationKey: Scalars['String'];
  nextProgram?: Maybe<ProgramNode>;
  pages: Array<PageNode>;
  programId: Scalars['Int'];
  programProgress: Array<ProgramProgressNode>;
  progressPercent: Scalars['Int'];
  searchKeywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  showRatings?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  sourceStrings?: Maybe<Array<Maybe<ContentTranslationNode>>>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};


export type ProgramNodeContentTranslationAvailabilityArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ProgramProgressNode = {
  __typename?: 'ProgramProgressNode';
  activated: Scalars['Boolean'];
  activatedAt?: Maybe<Scalars['DateTime']>;
  completedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  owner: MemberNode;
  pageProgress: Array<PageProgressNode>;
  program?: Maybe<ProgramNode>;
  startedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProgramStartMutation = {
  __typename?: 'ProgramStartMutation';
  programProgress?: Maybe<ProgramProgressNode>;
};

export type ProgramsScreenNode = ScreenNodeInterface & {
  __typename?: 'ProgramsScreenNode';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  designatedApplication: ScreenDesignatedApplication;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<GenericScreenNode>;
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export enum ProviderAssignmentDisplayType {
  Coach = 'COACH',
  PathwaySpecialist = 'PATHWAY_SPECIALIST',
  Psychiatrist = 'PSYCHIATRIST',
  Therapist = 'THERAPIST'
}

export type ProviderCertificationNode = {
  __typename?: 'ProviderCertificationNode';
  certification: CertificationNode;
  provider: MemberNode;
  uuid: Scalars['UUID'];
};

export type ProviderCoachingVisitNode = Node & {
  __typename?: 'ProviderCoachingVisitNode';
  actualDuration?: Maybe<Scalars['Int']>;
  coachAssignment?: Maybe<CoachAssignmentNode>;
  id: Scalars['ID'];
  isCoupleSession?: Maybe<Scalars['Boolean']>;
  isPathway?: Maybe<Scalars['Boolean']>;
  isPsychiatryInitialEvaluation?: Maybe<Scalars['Boolean']>;
  isTherapy: Scalars['Boolean'];
  memberUuid?: Maybe<Scalars['String']>;
  modalityType: CoachingVisitModalityType;
  organizationImprovements?: Maybe<Scalars['String']>;
  previousProviderReview?: Maybe<CoachingVisitProviderReviewNode>;
  providerUuid?: Maybe<Scalars['String']>;
  providerVideoEndTime?: Maybe<Scalars['DateTime']>;
  providerVideoStartTime?: Maybe<Scalars['DateTime']>;
  scheduledDuration?: Maybe<Scalars['Int']>;
  scheduledTime: Scalars['DateTime'];
  state: CoachingVisitState;
  uuid: Scalars['UUID'];
  videoService?: Maybe<Scalars['String']>;
  videoSessionUrl?: Maybe<Scalars['String']>;
  visitInfo?: Maybe<Scalars['String']>;
  visitType?: Maybe<Scalars['String']>;
};

export type ProviderCoachingVisitNodeConnection = {
  __typename?: 'ProviderCoachingVisitNodeConnection';
  edgeCount?: Maybe<Scalars['Int']>;
  edges: Array<Maybe<ProviderCoachingVisitNodeEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ProviderCoachingVisitNodeEdge = {
  __typename?: 'ProviderCoachingVisitNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<ProviderCoachingVisitNode>;
};

export type ProviderLabelNode = {
  __typename?: 'ProviderLabelNode';
  providerLabel?: Maybe<Scalars['String']>;
  providerUuid?: Maybe<Scalars['UUID']>;
};

export type ProviderListInput = {
  providerUuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};

export type ProviderMatchAttemptNode = {
  __typename?: 'ProviderMatchAttemptNode';
  careRecommendation?: Maybe<CareRecommendationNode>;
  chosenAt?: Maybe<Scalars['DateTime']>;
  chosenOffer?: Maybe<ProviderOptionOffer>;
  coachAssignment?: Maybe<CoachAssignmentNode>;
  manualMatchCompletedAt?: Maybe<Scalars['DateTime']>;
  manualRequestAt?: Maybe<Scalars['DateTime']>;
  providerOptionOffers: Array<ProviderOptionOffer>;
  providerType: ProviderMatchAttemptProviderType;
  recommendedAt?: Maybe<Scalars['DateTime']>;
  startedAt: Scalars['DateTime'];
  state: ProviderMatchAttemptState;
  uuid: Scalars['UUID'];
};

export enum ProviderMatchAttemptProviderType {
  Coach = 'COACH',
  Psychiatrist = 'PSYCHIATRIST',
  Therapist = 'THERAPIST'
}

export enum ProviderMatchAttemptState {
  Chosen = 'CHOSEN',
  ManualMatchCompleted = 'MANUAL_MATCH_COMPLETED',
  ManualRequest = 'MANUAL_REQUEST',
  Recommended = 'RECOMMENDED',
  Started = 'STARTED'
}

export type ProviderMemberPathwayNode = Node & {
  __typename?: 'ProviderMemberPathwayNode';
  coachAssignment?: Maybe<CoachAssignmentNode>;
  company?: Maybe<CompanyDropdownNode>;
  completedAt?: Maybe<Scalars['DateTime']>;
  completionPercent: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  currentSessionIndex: Scalars['Int'];
  duration: Scalars['Int'];
  id: Scalars['ID'];
  member: MemberNode;
  pathway: ProviderPathwayNode;
  pathwayProvider: PathwayProviderNode;
  pathwayTopics: Array<Maybe<PathwayTopicNode>>;
  startedAt?: Maybe<Scalars['DateTime']>;
  state: PathwayProgressState;
  surfacedProvider?: Maybe<MemberNode>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type ProviderMemberPathwayNodeConnection = {
  __typename?: 'ProviderMemberPathwayNodeConnection';
  edges: Array<Maybe<ProviderMemberPathwayNodeEdge>>;
  pageInfo: PageInfo;
};

export type ProviderMemberPathwayNodeEdge = {
  __typename?: 'ProviderMemberPathwayNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<ProviderMemberPathwayNode>;
};

export type ProviderOptionOffer = {
  __typename?: 'ProviderOptionOffer';
  createdAt: Scalars['DateTime'];
  member: MemberNode;
  order: Scalars['Int'];
  provider?: Maybe<CoachNode>;
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
  uuid: Scalars['UUID'];
};

export type ProviderPathwayNode = Node & {
  __typename?: 'ProviderPathwayNode';
  assessment: AssessmentNode;
  assessmentSessionOrdering: Array<Scalars['Int']>;
  availabilityState: PathwayAvailabilityState;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  memberPathway?: Maybe<ProviderMemberPathwayNode>;
  metadata: Scalars['JSONString'];
  pathwayprogressSet: ProviderMemberPathwayNodeConnection;
  providers: PathwayProviderNodeConnection;
  sessionCount: Scalars['Int'];
  slug: Scalars['String'];
  subtitle: Scalars['String'];
  title: Scalars['String'];
  topics: PathwayTopicNodeConnection;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};


export type ProviderPathwayNodePathwayprogressSetArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ProviderPathwayNodeProvidersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type ProviderPathwayNodeTopicsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ProviderProfileInput = {
  city: Scalars['String'];
  country: Scalars['String'];
  firstName: Scalars['String'];
  languagePreferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  lastName: Scalars['String'];
  providerSpecialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  state: Scalars['String'];
  therapistModalities?: Maybe<Array<Maybe<Scalars['String']>>>;
  zipCode: Scalars['String'];
};

export type PsychiatryVisitsCompletedNode = {
  __typename?: 'PsychiatryVisitsCompletedNode';
  followUpVisitsCompleted?: Maybe<Scalars['Int']>;
  initialEvaluationVisitsCompleted?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  /** Query all Series */
  adminCircleSeriesCollection: CircleSeriesCollection;
  allCompanies?: Maybe<AllCompaniesOutput>;
  allCompanyAdditionalBenefits?: Maybe<AllCompanyAdditionalBenefitOutput>;
  allContentLanguages?: Maybe<AllContentLanguagesOutput>;
  allContentTagCategories?: Maybe<AllContentTagCategoryOutput>;
  allContentTagRelations?: Maybe<AllContentTagRelationsOutput>;
  allContentTags?: Maybe<AllContentTagsOutput>;
  allContentTranslationAvailabilities?: Maybe<AllContentTranslationAvailabilitiesOutput>;
  allGuides?: Maybe<AllCourseGuidesOutput>;
  allHeroes?: Maybe<AllCourseHeroesOutput>;
  allHrAdminRoles?: Maybe<AllHrAdminRolesOutput>;
  allHrAdmins?: Maybe<AllHrAdminsOutput>;
  allHrEvents?: Maybe<AllHrEventsOutput>;
  allHrResources?: Maybe<AllHrResourcesOutput>;
  allMediaTypes?: Maybe<AllMediaTypesOutput>;
  allProviders?: Maybe<AllProvidersOutput>;
  allScheduledContent?: Maybe<AllScheduledContentOutput>;
  allScreens?: Maybe<AllScreensOutput>;
  allSpecialties?: Maybe<Array<Maybe<Scalars['String']>>>;
  allTimezones?: Maybe<Array<Maybe<TimezoneNode>>>;
  allVideoContent?: Maybe<AllVideoContentOutput>;
  assessment?: Maybe<AssessmentNode>;
  assessmentDetail?: Maybe<AssessmentDetailNode>;
  assessmentOverview?: Maybe<Array<Maybe<AssessmentOverviewNode>>>;
  assessmentQuestion?: Maybe<AssessmentQuestionNode>;
  assessments?: Maybe<Array<Maybe<AssessmentNode>>>;
  availableHours?: Maybe<Array<Maybe<AvailableHourNode>>>;
  calendarAuthLink?: Maybe<CalendarAuthLinkNode>;
  calendarProfiles?: Maybe<Array<Maybe<CalendarProfileNode>>>;
  careRecommendationsForMembers?: Maybe<CareRecommendationsForMembersOutput>;
  /** Query all facilitators */
  circleAdminFacilitatorCollection: CircleAdminFacilitatorCollectionResponse;
  /** Returns a collection of FeaturedItem objects */
  circleAdminFeaturedItemCollection: CircleAdminFeaturedItemCollectionResponse;
  /** Query an OnDemandTopic by id */
  circleAdminOnDemandById: CircleAdminOnDemandTopicQueryResponse;
  /** Query all question definitions */
  circleAdminRsvpQuestionDefinitions: CircleAdminRsvpQuestionDefinitionsResponse;
  /** Query Scheduled Tasks by taskState */
  circleAdminScheduledTasksConnection: CircleAdminScheduledTaskConnectionResponse;
  circleAdminSessionRegistrantCollection: CircleSessionRegistrantCollectionResponse;
  /**
   * Returns a list of available calendar links
   * for an RSVP
   */
  circleCalendarLinksByRsvp?: Maybe<CircleCalendarLinksByRsvpQueryResponse>;
  /** Query a specific facilitator by id */
  circleFacilitator?: Maybe<CircleFacilitatorNode>;
  /**
   * Returns a collection of featured items
   * or null if no items should be featured.
   */
  circleFeaturedCollection: CircleFeaturedCollection;
  /** the list of all supported languages for live circles and on-demand content */
  circleLanguages: Array<CircleLanguage>;
  /** the list of more/international languages for live circles and on-demand content, sorted by user preference */
  circleMoreLanguages: Array<CircleLanguage>;
  circleOnDemandBySlug: CircleOnDemandBySlugQueryResponse;
  circleOnDemandConnection: CircleOnDemandConnectionQueryResponse;
  /** Query a specific Rsvp by id */
  circleRsvp?: Maybe<CircleRsvpQueryResponse>;
  circleRsvps?: Maybe<CircleRsvpsQueryResponse>;
  /** Query a specific series by uuid */
  circleSeries?: Maybe<CircleSeriesNode>;
  /** Query a specific series by slug */
  circleSeriesBySlug?: Maybe<CircleSeriesNode>;
  /** Query all available series the platform offers */
  circleSeriesCollection: CircleSeriesCollection;
  circleSession?: Maybe<CircleSessionNode>;
  /**
   * Returns sessions for a given circle between from and to.
   * If from is not provided, now() is used.
   */
  circleSessionConnection: CircleSessionConnection;
  circleSessionsByDateTime: CircleSessionsByDateTimeResponse;
  /** Query a specific topic by uuid */
  circleTopic?: Maybe<CircleTopicNode>;
  /** Query a specific topic by slug */
  circleTopicBySlug?: Maybe<CircleTopicNode>;
  /** Returns Topics can be filtered by seriesId or by languageCode */
  circleTopicConnection: CircleTopicConnection;
  /** the structure for the circles language overview screen */
  circlesLanguageOverviewScreen?: Maybe<CirclesLanguageOverviewScreenResponse>;
  /** the structure for the circles on demand overview screen */
  circlesOnDemandOverviewScreen?: Maybe<CirclesOnDemandOverviewScreenResponse>;
  clients?: Maybe<ClientSummaryNodeConnection>;
  coachAssignments?: Maybe<Array<Maybe<CoachAssignmentNode>>>;
  coachAvailability?: Maybe<Array<Maybe<AvailablePeriodNode>>>;
  coachingVisit?: Maybe<CoachingVisitNode>;
  coachingVisitClaimable?: Maybe<CoachingVisitClaimable>;
  coachingVisitToReport?: Maybe<Array<Maybe<CoachingVisitNode>>>;
  coachingVisits?: Maybe<Array<Maybe<CoachingVisitNode>>>;
  companies?: Maybe<Array<Maybe<CompanyDropdownNode>>>;
  companiesWithSegments?: Maybe<CompaniesWithSegmentsOutput>;
  company: CompanyOutput;
  companyAdditionalBenefits?: Maybe<Array<Maybe<CompanyAdditionalBenefitNode>>>;
  companyFeatures?: Maybe<AllCompanyFeaturesOutput>;
  companySegments?: Maybe<CompanySegmentsOutput>;
  completedScheduledContent?: Maybe<ScheduledContentConnection>;
  contentCollection?: Maybe<ContentCollectionNode>;
  contentCollections?: Maybe<Array<Maybe<ContentCollectionNode>>>;
  contentResponses?: Maybe<ContentResponsesNode>;
  contentTagListScreen?: Maybe<ContentTagListScreenNode>;
  contentTagScreenBySlug?: Maybe<ContentTagScreenNode>;
  conversation?: Maybe<ConversationNode>;
  conversations?: Maybe<ConversationNodeConnection>;
  course?: Maybe<CourseNode>;
  courseActivityGroup?: Maybe<CourseActivityGroupNode>;
  courseBySlug?: Maybe<CourseNode>;
  courseSection?: Maybe<CourseSectionNode>;
  courseSectionBySlug?: Maybe<CourseSectionNode>;
  courses?: Maybe<Array<Maybe<CourseNode>>>;
  coursesScreen?: Maybe<CoursesScreenNode>;
  crisisProviderCompanyAssignments?: Maybe<Array<Maybe<CrisisProviderCompanyAssignmentNode>>>;
  crisisProviderCountryAssignments?: Maybe<Array<Maybe<CrisisProviderCountryAssignmentNode>>>;
  crisisProviders?: Maybe<Array<Maybe<CrisisProviderNode>>>;
  dailyPauseCalendarReminder?: Maybe<DailyPauseCalendarReminder>;
  exploreCareOptionsScreen?: Maybe<ExploreCareOptionsScreenNode>;
  exploreScreen?: Maybe<ExploreScreenNode>;
  featuredPathwayProviders?: Maybe<Array<Maybe<PathwayProviderNode>>>;
  forYouScreen?: Maybe<ForYouScreenNode>;
  getAllClientFiles?: Maybe<Array<Maybe<ClientFileNode>>>;
  getAllReportsAndSections?: Maybe<GetAllReportsAndSectionsResult>;
  getBenefitUnit?: Maybe<BenefitUnitNode>;
  getCancelledSessionReview?: Maybe<CancelledSessionReviewResponse>;
  getClientBuckets?: Maybe<Array<Maybe<ClientBucketNode>>>;
  getClientFileDetails?: Maybe<ClientFileEventDetailsNode>;
  getClientFilesByCompanyUuid?: Maybe<Array<Maybe<ClientFileNode>>>;
  getCoachMemberMatchingUnit?: Maybe<CoachMemberMatchingUnitNode>;
  getContentUnit?: Maybe<ContentUnitNode>;
  getCptCodes?: Maybe<Array<Maybe<CptCodeNode>>>;
  getCptCodesByServiceType?: Maybe<Array<Maybe<CptCodeNode>>>;
  getDxCodes?: Maybe<Array<Maybe<DxCodeNode>>>;
  getEligibilityForMember?: Maybe<Scalars['Boolean']>;
  getEmployerCptRates?: Maybe<Array<Maybe<EmployerCptRate>>>;
  getEmployerInsurances?: Maybe<Array<Maybe<EmployerInsuranceNode>>>;
  getEmployerInsurancesHistorical?: Maybe<Array<Maybe<EmployerInsuranceNode>>>;
  getInsuranceCompanies?: Maybe<Array<Maybe<InsuranceCompanyNode>>>;
  getLanguages: Array<LanguageNode>;
  getMemberCostEstimate?: Maybe<CostEstimateNode>;
  getMemberInsurance?: Maybe<MemberInsuranceNode>;
  getMyEligibilityStatus?: Maybe<Scalars['Boolean']>;
  getMyEligibilityStatusInfo?: Maybe<EligibilityStatusNode>;
  getPatientChart?: Maybe<PatientChartNode>;
  getPatientIntakeForm?: Maybe<PatientIntakeFormNode>;
  getPatientIntakeFormTemplate?: Maybe<PatientIntakeFormTemplateNode>;
  getPatientNotes?: Maybe<Array<Maybe<PatientNoteNode>>>;
  getPayerInformation?: Maybe<PayerInformationNode>;
  getPaymentInfoForVisit?: Maybe<PaymentInfoForVisitNode>;
  getPeople?: Maybe<Array<Maybe<PersonNode>>>;
  getRelationshipCodes?: Maybe<Array<Maybe<RelationshipCodeNode>>>;
  getTranslationKey?: Maybe<TranslationKeyNode>;
  getTranslationKeys: Array<TranslationKeyNode>;
  getTranslations: Array<TranslationNode>;
  getTreatmentCycle?: Maybe<TreatmentCycleNode>;
  getVisitCost?: Maybe<PaymentInfoForVisitNode>;
  getVisitRates?: Maybe<Array<Maybe<VisitRateNode>>>;
  getVisitTransactionsForAccounts?: Maybe<Array<Maybe<PaymentRequestNode>>>;
  groupPractice?: Maybe<GroupPracticeNode>;
  hasCalendarSetup?: Maybe<Scalars['Boolean']>;
  healthPlanCompanies?: Maybe<HealthPlanCompaniesOutput>;
  homeScreen?: Maybe<HomeScreenNode>;
  hrAdmin?: Maybe<HrAdminOutput>;
  hrAdminRole?: Maybe<HrAdminRoleOutput>;
  hrAdminSearch?: Maybe<HrResourceNodeConnection>;
  hrCompanyAdditionalBenefits?: Maybe<Array<Maybe<CompanyAdditionalBenefitNode>>>;
  hrEvent?: Maybe<HrEventOutput>;
  hrMessages?: Maybe<HrMessagesResult>;
  hrResource?: Maybe<HrResourceOutput>;
  hrResourceBySlug?: Maybe<HrResourceNode>;
  hrResourceScreen?: Maybe<HrResourceScreenResult>;
  intakeForm?: Maybe<IntakeFormNode>;
  isHrAdmin?: Maybe<Scalars['Boolean']>;
  lastCareNavigationRequest?: Maybe<CareNavigationRequestNode>;
  lastInvoicedCoachingVisit?: Maybe<CoachingVisitNode>;
  listHrAdminRoles: Array<HrAdminRoleNode>;
  listHrAdmins?: Maybe<ListHrAdminQueryOutput>;
  listHrisConnections?: Maybe<HrisConnectionsOutput>;
  lookerSsoEmbed?: Maybe<LookerSsoEmbedResult>;
  manageCareTeamScreen?: Maybe<ManageCareTeamScreenNode>;
  me?: Maybe<MemberNode>;
  meditation?: Maybe<MeditationNode>;
  meditationBySlug?: Maybe<MeditationNode>;
  meditationCategories?: Maybe<Array<Maybe<MeditationCategoryNode>>>;
  meditationProgress?: Maybe<Array<Maybe<MeditationProgressNode>>>;
  meditations?: Maybe<Array<Maybe<MeditationNode>>>;
  meditationsScreen?: Maybe<MeditationsScreenNode>;
  member?: Maybe<MemberNode>;
  memberCarePreferences?: Maybe<Array<Maybe<MemberCarePreferenceNode>>>;
  memberFeaturedMeditations?: Maybe<Array<Maybe<MeditationNode>>>;
  memberFeaturedPrograms?: Maybe<Array<Maybe<ProgramNode>>>;
  memberFilterPreferences?: Maybe<Array<Maybe<MemberFilterPreferenceNode>>>;
  memberNonPhi?: Maybe<MemberNonPhiOutput>;
  memberReportableSessionsCount?: Maybe<Scalars['Int']>;
  messages?: Maybe<MessageNodeConnection>;
  myClients?: Maybe<MemberPageNode>;
  myHrAdmin?: Maybe<HrAdminNode>;
  pageProgress?: Maybe<Array<Maybe<PageProgressNode>>>;
  pages?: Maybe<Array<Maybe<PageNode>>>;
  pathway?: Maybe<PathwayNode>;
  pathwayByAssignment?: Maybe<PathwayNode>;
  pathwayByProviderAssignment?: Maybe<ProviderPathwayNode>;
  pathways?: Maybe<Array<Maybe<PathwayNode>>>;
  phoneSupportDependentInfo?: Maybe<PhoneSupportDependentInfoOutput>;
  phoneSupportMemberInfo?: Maybe<PhoneSupportMemberInfoOutput>;
  phoneSupportMemberSearch?: Maybe<PhoneSupportMemberSearchOutput>;
  program?: Maybe<ProgramNode>;
  programBySlug?: Maybe<ProgramNode>;
  programProgress?: Maybe<Array<Maybe<ProgramProgressNode>>>;
  programs?: Maybe<Array<Maybe<ProgramNode>>>;
  programsScreen?: Maybe<ProgramsScreenNode>;
  providerAvailability?: Maybe<Array<Maybe<AvailablePeriodNode>>>;
  providerAvailabilityForProvider?: Maybe<Array<Maybe<AvailablePeriodNode>>>;
  providerCoachingVisits?: Maybe<ProviderCoachingVisitNodeConnection>;
  providerIntakeForm?: Maybe<IntakeFormNode>;
  providerIntakeForms?: Maybe<Array<Maybe<IntakeFormNode>>>;
  providerMessagingActions?: Maybe<Array<Maybe<MessageActionsNode>>>;
  recommendedScreen?: Maybe<RecommendedScreenNode>;
  resourcesScreen?: Maybe<ResourcesScreenNode>;
  retrieveConnectToken?: Maybe<HrisConnectTokenOutput>;
  scheduledContent?: Maybe<ScheduledContentNode>;
  scheduledContentActivity?: Maybe<ScheduledContentActivitySummaryNode>;
  screenBySlug?: Maybe<ScreenNode>;
  screens?: Maybe<Array<Maybe<ScreenNode>>>;
  searchGlobalResults?: Maybe<SearchGlobalResultsResponse>;
  shouldShowInAppReviewFlow?: Maybe<Scalars['Boolean']>;
  shouldShowNpsQuestion?: Maybe<Scalars['Boolean']>;
  textTrackTranslations?: Maybe<Array<Maybe<TextTrackTranslationNode>>>;
  topicSelectionGroups?: Maybe<Array<Maybe<TopicSelectionGroupNode>>>;
  topicsOfFocus?: Maybe<Array<Maybe<TopicOfFocusNode>>>;
  translations?: Maybe<Array<Maybe<ContentTranslationNode>>>;
  validateEmployerConfig?: Maybe<EmployerValidationConfigNode>;
  wellBeingReport?: Maybe<WellBeingReportNode>;
  wellbeingReportMonitoringMessage?: Maybe<WellbeingReportMonitoringMessageResult>;
  wellbeingReportScreen?: Maybe<WellbeingReportScreenNode>;
};


export type QueryAllHrAdminsArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryAssessmentArgs = {
  name?: Maybe<Scalars['String']>;
};


export type QueryAssessmentDetailArgs = {
  assessmentFlowUuid: Scalars['UUID'];
  assessmentType: Scalars['String'];
};


export type QueryAssessmentOverviewArgs = {
  memberUuid: Scalars['UUID'];
};


export type QueryCalendarAuthLinkArgs = {
  redirectUri?: Maybe<Scalars['String']>;
};


export type QueryCalendarProfilesArgs = {
  sync?: Maybe<Scalars['Boolean']>;
};


export type QueryCareRecommendationsForMembersArgs = {
  memberUuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
};


export type QueryCircleAdminOnDemandByIdArgs = {
  id: Scalars['ID'];
};


export type QueryCircleAdminScheduledTasksConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  taskState: Scalars['String'];
};


export type QueryCircleAdminSessionRegistrantCollectionArgs = {
  sessionId: Scalars['ID'];
};


export type QueryCircleCalendarLinksByRsvpArgs = {
  rsvpId: Scalars['ID'];
};


export type QueryCircleFacilitatorArgs = {
  id: Scalars['ID'];
};


export type QueryCircleOnDemandBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCircleOnDemandConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  filterByLanguageCodes?: Maybe<Array<Scalars['String']>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryCircleRsvpArgs = {
  id: Scalars['ID'];
};


export type QueryCircleRsvpsArgs = {
  after?: Maybe<Scalars['String']>;
  afterDateTime?: Maybe<Scalars['DateTime']>;
  before?: Maybe<Scalars['String']>;
  beforeDateTime?: Maybe<Scalars['DateTime']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryCircleSeriesArgs = {
  id: Scalars['ID'];
};


export type QueryCircleSeriesBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCircleSessionArgs = {
  id: Scalars['ID'];
};


export type QueryCircleSessionConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  afterDateTime?: Maybe<Scalars['DateTime']>;
  before?: Maybe<Scalars['String']>;
  beforeDateTime?: Maybe<Scalars['DateTime']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  topicId: Scalars['ID'];
};


export type QueryCircleSessionsByDateTimeArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  endDateTime: Scalars['DateTime'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  startDateTime: Scalars['DateTime'];
};


export type QueryCircleTopicArgs = {
  id: Scalars['ID'];
};


export type QueryCircleTopicBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryCircleTopicConnectionArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  filterByLanguageCodes?: Maybe<Array<Scalars['String']>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  seriesId?: Maybe<Scalars['ID']>;
};


export type QueryClientsArgs = {
  after?: Maybe<Scalars['String']>;
  appInstalled?: Maybe<Scalars['Boolean']>;
  assignmentCreationSource?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  clientType?: Maybe<Scalars['String']>;
  coachHasSentMessage?: Maybe<Scalars['Boolean']>;
  companies?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  hasRemainingSessions?: Maybe<Scalars['Boolean']>;
  hasUpcomingBooking?: Maybe<Scalars['Boolean']>;
  isMatched?: Maybe<Scalars['Boolean']>;
  last?: Maybe<Scalars['Int']>;
  lastInteraction?: Maybe<Scalars['DateTime']>;
  lastVisit?: Maybe<Scalars['DateTime']>;
  lastWho5Date?: Maybe<Scalars['String']>;
  matchDate?: Maybe<Scalars['DateTime']>;
  matchStatus?: Maybe<Scalars['String']>;
  memberEmail?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  nextVisit?: Maybe<Scalars['DateTime']>;
  orderBy?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
  visitsCovered?: Maybe<Scalars['Int']>;
};


export type QueryCoachAssignmentsArgs = {
  active?: Maybe<Scalars['Boolean']>;
  coachAssignmentUuid?: Maybe<Scalars['String']>;
  coachUuid?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['String']>;
};


export type QueryCoachAvailabilityArgs = {
  coach: Scalars['UUID'];
  ignoreWorkingHours?: Maybe<Scalars['Boolean']>;
};


export type QueryCoachingVisitArgs = {
  uuid: Scalars['UUID'];
};


export type QueryCoachingVisitClaimableArgs = {
  memberUuid: Scalars['UUID'];
  scheduledTime: Scalars['DateTime'];
  state: Scalars['String'];
};


export type QueryCoachingVisitToReportArgs = {
  memberUuid: Scalars['UUID'];
};


export type QueryCompanyArgs = {
  uuid: Scalars['UUID'];
};


export type QueryCompanyFeaturesArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryCompletedScheduledContentArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryContentCollectionArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryContentCollectionsArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryContentTagListScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryContentTagScreenBySlugArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
  slug?: Maybe<Scalars['String']>;
};


export type QueryConversationArgs = {
  uuid: Scalars['UUID'];
};


export type QueryConversationsArgs = {
  active?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  memberCompany?: Maybe<Scalars['String']>;
  memberEmail?: Maybe<Scalars['String']>;
  memberName?: Maybe<Scalars['String']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  orderBy?: Maybe<Scalars['String']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryCourseArgs = {
  id: Scalars['ID'];
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCourseActivityGroupArgs = {
  id: Scalars['ID'];
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCourseBySlugArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
  slug: Scalars['String'];
};


export type QueryCourseSectionArgs = {
  id: Scalars['ID'];
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCourseSectionBySlugArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
  slug: Scalars['String'];
};


export type QueryCoursesArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCoursesScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryCrisisProvidersArgs = {
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryExploreCareOptionsScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryExploreScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryFeaturedPathwayProvidersArgs = {
  pathwayUuid: Scalars['UUID'];
};


export type QueryForYouScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryGetAllReportsAndSectionsArgs = {
  embedDomain?: Maybe<Scalars['String']>;
};


export type QueryGetBenefitUnitArgs = {
  benefitFeatures: BenefitFeatureInput;
  modelName: Scalars['String'];
  userFocusFeatures: UserFocusFeatureInput;
  userId: Scalars['ID'];
};


export type QueryGetClientFileDetailsArgs = {
  clientFileId: Scalars['Int'];
};


export type QueryGetClientFilesByCompanyUuidArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryGetCoachMemberMatchingUnitArgs = {
  coachFeatures?: Maybe<Array<Maybe<CoachInput>>>;
  memberFeatures?: Maybe<MemberInput>;
  modelName: Scalars['String'];
};


export type QueryGetContentUnitArgs = {
  filterContentType?: Maybe<Array<Maybe<ContentType>>>;
  modelName: Scalars['String'];
  userFeatures: UserFeatureInput;
  userId: Scalars['ID'];
};


export type QueryGetCptCodesArgs = {
  companyUuid?: Maybe<Scalars['UUID']>;
  serviceType?: Maybe<ServiceType>;
};


export type QueryGetCptCodesByServiceTypeArgs = {
  serviceType?: Maybe<ServiceType>;
};


export type QueryGetEligibilityForMemberArgs = {
  memberUuid: Scalars['UUID'];
};


export type QueryGetEmployerCptRatesArgs = {
  employerInsuranceId: Scalars['Int'];
};


export type QueryGetEmployerInsurancesArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryGetEmployerInsurancesHistoricalArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryGetMemberCostEstimateArgs = {
  getMemberCostEstimate: GetMemberCostEstimate;
};


export type QueryGetPatientChartArgs = {
  providerMatchUuid: Scalars['UUID'];
};


export type QueryGetPatientIntakeFormArgs = {
  providerMatchUuid?: Maybe<Scalars['UUID']>;
};


export type QueryGetPatientIntakeFormTemplateArgs = {
  providerMatchUuid?: Maybe<Scalars['UUID']>;
};


export type QueryGetPatientNotesArgs = {
  providerMatchUuid?: Maybe<Scalars['UUID']>;
};


export type QueryGetPaymentInfoForVisitArgs = {
  visitUuid: Scalars['UUID'];
};


export type QueryGetTranslationKeyArgs = {
  translationKey: Scalars['String'];
};


export type QueryGetTranslationsArgs = {
  collectionName?: Maybe<Scalars['String']>;
  languageCode: Scalars['String'];
};


export type QueryGetTreatmentCycleArgs = {
  activityDates?: Maybe<Array<Scalars['String']>>;
  activityTimestamp: Scalars['String'];
  treatmentStartedAt?: Maybe<Scalars['String']>;
  treatmentType: Scalars['String'];
};


export type QueryGetVisitCostArgs = {
  accountUuid: Scalars['UUID'];
  visitUuid: Scalars['UUID'];
};


export type QueryGetVisitTransactionsForAccountsArgs = {
  accountUuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  endTime: Scalars['DateTime'];
  startTime: Scalars['DateTime'];
};


export type QueryHasCalendarSetupArgs = {
  coach: Scalars['UUID'];
};


export type QueryHomeScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryHrAdminArgs = {
  id: Scalars['ID'];
};


export type QueryHrAdminRoleArgs = {
  id: Scalars['ID'];
};


export type QueryHrAdminSearchArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  searchPhrase: Scalars['String'];
};


export type QueryHrEventArgs = {
  id: Scalars['ID'];
};


export type QueryHrMessagesArgs = {
  includeSeen?: Maybe<Scalars['Boolean']>;
};


export type QueryHrResourceArgs = {
  id: Scalars['ID'];
};


export type QueryHrResourceBySlugArgs = {
  slug: Scalars['String'];
};


export type QueryHrResourceScreenArgs = {
  path: Scalars['String'];
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryIntakeFormArgs = {
  coachAssignmentUuid?: Maybe<Scalars['UUID']>;
  intakeFormUuid?: Maybe<Scalars['UUID']>;
};


export type QueryLastCareNavigationRequestArgs = {
  topic?: Maybe<Scalars['String']>;
};


export type QueryListHrAdminsArgs = {
  companyUuid: Scalars['UUID'];
  showDisabled?: Maybe<Scalars['Boolean']>;
};


export type QueryLookerSsoEmbedArgs = {
  embedDomain?: Maybe<Scalars['String']>;
  reportType?: Maybe<ReportTypeEnum>;
};


export type QueryManageCareTeamScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryMeditationArgs = {
  languageCode?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryMeditationBySlugArgs = {
  languageCode?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};


export type QueryMeditationsArgs = {
  languageCode?: Maybe<Scalars['String']>;
};


export type QueryMeditationsScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryMemberArgs = {
  uuid: Scalars['UUID'];
};


export type QueryMemberFeaturedMeditationsArgs = {
  uuid: Scalars['UUID'];
};


export type QueryMemberFeaturedProgramsArgs = {
  uuid: Scalars['UUID'];
};


export type QueryMemberNonPhiArgs = {
  uuid: Scalars['UUID'];
};


export type QueryMemberReportableSessionsCountArgs = {
  coachUuid: Scalars['UUID'];
  memberUuid: Scalars['UUID'];
};


export type QueryMessagesArgs = {
  acknowledged?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  bulkMessageUuid?: Maybe<Scalars['UUID']>;
  coachUuid?: Maybe<Scalars['UUID']>;
  conversationUuid?: Maybe<Scalars['UUID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  orderBy?: Maybe<Scalars['String']>;
  providerUuid?: Maybe<Scalars['UUID']>;
  receiverUuid?: Maybe<Scalars['UUID']>;
  senderUuid?: Maybe<Scalars['UUID']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryMyClientsArgs = {
  activeAfter?: Maybe<Scalars['DateTime']>;
  first?: Maybe<Scalars['Int']>;
  loggedInAfter?: Maybe<Scalars['DateTime']>;
  matched?: Maybe<Scalars['Boolean']>;
  newMatches?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  skip?: Maybe<Scalars['Int']>;
};


export type QueryPathwayArgs = {
  pathwayUuid: Scalars['UUID'];
  platform: ContentCollectionPlatform;
};


export type QueryPathwayByAssignmentArgs = {
  platform: ContentCollectionPlatform;
  providerAssignmentUuid: Scalars['UUID'];
};


export type QueryPathwayByProviderAssignmentArgs = {
  assignmentUuid: Scalars['UUID'];
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryPathwaysArgs = {
  platform: ContentCollectionPlatform;
};


export type QueryPhoneSupportDependentInfoArgs = {
  accountUuid: Scalars['UUID'];
};


export type QueryPhoneSupportMemberInfoArgs = {
  eligiblePersonUuid: Scalars['UUID'];
};


export type QueryPhoneSupportMemberSearchArgs = {
  companyUuid: Scalars['UUID'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};


export type QueryProgramArgs = {
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryProgramBySlugArgs = {
  slug?: Maybe<Scalars['String']>;
};


export type QueryProgramsArgs = {
  includeHidden?: Maybe<Scalars['Boolean']>;
};


export type QueryProgramsScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryProviderAvailabilityArgs = {
  ignoreWorkingHours?: Maybe<Scalars['Boolean']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  providerUuid: Scalars['UUID'];
};


export type QueryProviderAvailabilityForProviderArgs = {
  ignoreWorkingHours?: Maybe<Scalars['Boolean']>;
  memberUuid?: Maybe<Scalars['UUID']>;
  providerUuid: Scalars['UUID'];
};


export type QueryProviderCoachingVisitsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orderBy?: Maybe<Scalars['String']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  scheduledTimeAfter?: Maybe<Scalars['DateTime']>;
  scheduledTimeBefore?: Maybe<Scalars['DateTime']>;
};


export type QueryProviderIntakeFormArgs = {
  intakeFormUuid: Scalars['UUID'];
};


export type QueryProviderMessagingActionsArgs = {
  assignmentUuid: Scalars['UUID'];
  platform: ContentCollectionPlatform;
};


export type QueryRecommendedScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryResourcesScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QueryScheduledContentArgs = {
  contentType?: Maybe<ScheduledContentType>;
  forTime?: Maybe<Scalars['DateTime']>;
  uuid?: Maybe<Scalars['UUID']>;
};


export type QueryScreenBySlugArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
  slug: Scalars['String'];
};


export type QueryScreensArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};


export type QuerySearchGlobalResultsArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
  searchText?: Maybe<Scalars['String']>;
};


export type QueryShouldShowInAppReviewFlowArgs = {
  npsScore?: Maybe<Scalars['Int']>;
  store: InAppReviewStore;
};


export type QueryShouldShowNpsQuestionArgs = {
  coachingVisitUuid: Scalars['UUID'];
};


export type QueryValidateEmployerConfigArgs = {
  companyUuid: Scalars['UUID'];
};


export type QueryWellbeingReportScreenArgs = {
  platform?: Maybe<ContentCollectionPlatform>;
};

export type RateScheduledContentMutation = {
  __typename?: 'RateScheduledContentMutation';
  scheduledContentFeedback?: Maybe<ScheduledContentFeedbackNode>;
};

export enum RatingContentTypeEnum {
  Meditation = 'MEDITATION',
  Program = 'PROGRAM',
  Visit = 'VISIT'
}

export type RatingNode = {
  __typename?: 'RatingNode';
  coachingVisit: CoachingVisitNode;
  createdAt: Scalars['DateTime'];
  feedbackText?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  reasons: Array<Maybe<Scalars['String']>>;
};

export type RecommendCareMutation = {
  __typename?: 'RecommendCareMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type RecommendedScreenNode = ScreenNodeInterface & {
  __typename?: 'RecommendedScreenNode';
  description?: Maybe<Scalars['String']>;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type RecordPresenceChangeMutation = {
  __typename?: 'RecordPresenceChangeMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type RecordScheduledContentActivityMutation = {
  __typename?: 'RecordScheduledContentActivityMutation';
  activitySummary?: Maybe<ScheduledContentActivitySummaryNode>;
};

export type RelationshipCodeNode = {
  __typename?: 'RelationshipCodeNode';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type RemoveCoachMutation = {
  __typename?: 'RemoveCoachMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type RemoveModelKeyFromCacheResponse = {
  __typename?: 'RemoveModelKeyFromCacheResponse';
  errors?: Maybe<Scalars['String']>;
  modelName: Scalars['String'];
  ok: Scalars['Boolean'];
};

export enum RenderingProviderType {
  None = 'NONE',
  Provider = 'PROVIDER',
  SameAsBilling = 'SAME_AS_BILLING'
}

export type ReportDataPoint = {
  __typename?: 'ReportDataPoint';
  x: Scalars['String'];
  y: Scalars['Float'];
};

export type ReportMetadata = {
  __typename?: 'ReportMetadata';
  extra?: Maybe<Scalars['JSONString']>;
  labelX: Scalars['String'];
  labelY: Scalars['String'];
  maxY: Scalars['Float'];
  minY: Scalars['Float'];
  title: Scalars['String'];
  xAxisLabels: Array<Scalars['String']>;
  yAxisLabels: Array<Scalars['Float']>;
};

export enum ReportTypeEnum {
  BenefitSnapshot = 'BENEFIT_SNAPSHOT',
  EngagementAndRegistration = 'ENGAGEMENT_AND_REGISTRATION',
  HealthAndWellbeingAreasOfInterest = 'HEALTH_AND_WELLBEING_AREAS_OF_INTEREST',
  HealthAndWellbeingOverview = 'HEALTH_AND_WELLBEING_OVERVIEW',
  HealthAndWellbeingPillarsOfWellbeing = 'HEALTH_AND_WELLBEING_PILLARS_OF_WELLBEING',
  InternalBenchmarkingDash = 'INTERNAL_BENCHMARKING_DASH',
  InternalEfFilterFieldCheck = 'INTERNAL_EF_FILTER_FIELD_CHECK',
  InternalExtendedCare = 'INTERNAL_EXTENDED_CARE',
  InternalOutcome = 'INTERNAL_OUTCOME',
  InternalPsychiatry = 'INTERNAL_PSYCHIATRY',
  InternalQbrDash = 'INTERNAL_QBR_DASH',
  UtilizationCircles = 'UTILIZATION_CIRCLES',
  UtilizationDigitalContent = 'UTILIZATION_DIGITAL_CONTENT',
  UtilizationOneOnOneCare = 'UTILIZATION_ONE_ON_ONE_CARE'
}

export type RequestManualProviderMatchMutation = {
  __typename?: 'RequestManualProviderMatchMutation';
  providerMatchAttempt?: Maybe<ProviderMatchAttemptNode>;
};

export type RescheduleEventMutation = {
  __typename?: 'RescheduleEventMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ResetEligibilityForMember = {
  memberUuid: Scalars['UUID'];
};

export type ResetEligibilityForMemberResponse = {
  __typename?: 'ResetEligibilityForMemberResponse';
  ok: Scalars['Boolean'];
};

export type ResetTestAccountPasswordResult = {
  __typename?: 'ResetTestAccountPasswordResult';
  role: Scalars['String'];
  token: Scalars['String'];
  uidb64: Scalars['String'];
  url: Scalars['String'];
};

export type ResourcesScreenNode = ScreenNodeInterface & {
  __typename?: 'ResourcesScreenNode';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  designatedApplication: ScreenDesignatedApplication;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<GenericScreenNode>;
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type ReviewInputNode = {
  feedbackText?: Maybe<Scalars['String']>;
  rating: Scalars['Int'];
  reason: Scalars['String'];
  reviewId?: Maybe<Scalars['Int']>;
};

export type ReviewNode = {
  __typename?: 'ReviewNode';
  coachingVisitProviderReviews?: Maybe<CoachingVisitProviderReviewNode>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  feedbackText?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  rating: Scalars['Int'];
  reason: Scalars['String'];
  reviewId: Scalars['Int'];
  reviewer: MemberNode;
  targetId: Scalars['Int'];
  targetType: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ReviewProgramMutation = {
  __typename?: 'ReviewProgramMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SaveContentResponsesMutation = {
  __typename?: 'SaveContentResponsesMutation';
  updatedContentResponses?: Maybe<ContentResponsesNode>;
};

export type SaveNewClientCapacityMutation = {
  __typename?: 'SaveNewClientCapacityMutation';
  newClientCapacity?: Maybe<Scalars['Int']>;
  providerSchedulingType?: Maybe<Scalars['String']>;
};

export type SaveRatingMutation = {
  __typename?: 'SaveRatingMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export enum ScheduledContentActivityActivityType {
  Completed = 'COMPLETED',
  CtaClicked = 'CTA_CLICKED',
  Disliked = 'DISLIKED',
  Liked = 'LIKED',
  Viewed = 'VIEWED'
}

export type ScheduledContentActivityNode = {
  __typename?: 'ScheduledContentActivityNode';
  activityType: ScheduledContentActivityActivityType;
  scheduledContent: ScheduledContentNode;
  timestamp: Scalars['DateTime'];
};

export type ScheduledContentActivitySummaryNode = {
  __typename?: 'ScheduledContentActivitySummaryNode';
  completedCount?: Maybe<Scalars['Int']>;
  ctaClickedCount?: Maybe<Scalars['Int']>;
  dayStreakCount: Scalars['Int'];
  dislikedCount?: Maybe<Scalars['Int']>;
  likedCount?: Maybe<Scalars['Int']>;
  myActivity?: Maybe<Array<Maybe<ScheduledContentActivityNode>>>;
  myStreakTracking: Array<ScheduledContentStreakTrackingNode>;
  viewedCount?: Maybe<Scalars['Int']>;
  weekStreakCount: Scalars['Int'];
};


export type ScheduledContentActivitySummaryNodeMyStreakTrackingArgs = {
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};

export enum ScheduledContentActivityType {
  Completed = 'COMPLETED',
  CtaClicked = 'CTA_CLICKED',
  Disliked = 'DISLIKED',
  Liked = 'LIKED',
  Viewed = 'VIEWED'
}

export type ScheduledContentConnection = {
  __typename?: 'ScheduledContentConnection';
  edges: Array<Maybe<ScheduledContentEdge>>;
  pageInfo: PageInfo;
};

export enum ScheduledContentContentType {
  DailyPause = 'DAILY_PAUSE',
  Pathways = 'PATHWAYS'
}

export type ScheduledContentEdge = {
  __typename?: 'ScheduledContentEdge';
  cursor: Scalars['String'];
  node?: Maybe<ScheduledContentNode>;
};

export type ScheduledContentFeedbackNode = {
  __typename?: 'ScheduledContentFeedbackNode';
  rating: ScheduledContentFeedbackRatingType;
  review?: Maybe<Scalars['String']>;
  scheduledContent: ScheduledContentNode;
};

export enum ScheduledContentFeedbackRatingType {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type ScheduledContentLinkNode = {
  __typename?: 'ScheduledContentLinkNode';
  image?: Maybe<Scalars['String']>;
  index: Scalars['Int'];
  isCta: Scalars['Boolean'];
  linkType: ContentCollectionLinkLinkType;
  mobileValue: Scalars['String'];
  scheduledContent: ScheduledContentNode;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
  webValue?: Maybe<Scalars['String']>;
};

export type ScheduledContentNode = Node & {
  __typename?: 'ScheduledContentNode';
  accentColor?: Maybe<Scalars['String']>;
  badgeTitle?: Maybe<Scalars['String']>;
  badgeVariant?: Maybe<Scalars['String']>;
  bannerContent: Scalars['String'];
  bannerCtaText: Scalars['String'];
  bannerImage?: Maybe<Scalars['String']>;
  bannerTitle: Scalars['String'];
  buttonCtaContentLink?: Maybe<ContentCollectionLinkNode>;
  buttonVariant?: Maybe<Scalars['String']>;
  contentType: ScheduledContentContentType;
  duration?: Maybe<Scalars['Int']>;
  feedback?: Maybe<ScheduledContentFeedbackNode>;
  fullContent: Scalars['String'];
  headerImage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isCompleted: Scalars['Boolean'];
  linkHeader?: Maybe<Scalars['String']>;
  mediaType?: Maybe<MediaTypeNode>;
  myActivity?: Maybe<Array<Maybe<ScheduledContentActivityNode>>>;
  scheduledContentLinks: Array<ScheduledContentLinkNode>;
  startTime: Scalars['DateTime'];
  titleColor?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
};

export type ScheduledContentNodeConnection = {
  __typename?: 'ScheduledContentNodeConnection';
  edges: Array<Maybe<ScheduledContentNodeEdge>>;
  pageInfo: PageInfo;
};

export type ScheduledContentNodeEdge = {
  __typename?: 'ScheduledContentNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<ScheduledContentNode>;
};

export type ScheduledContentStreakTrackingNode = {
  __typename?: 'ScheduledContentStreakTrackingNode';
  date: Scalars['Date'];
};

export enum ScheduledContentType {
  DailyPause = 'DAILY_PAUSE',
  Pathways = 'PATHWAYS'
}

export type ScreenCreateErrorResponse = {
  __typename?: 'ScreenCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ScreenCreateInput = {
  description?: Maybe<Scalars['String']>;
  designatedApplication: ScreenDesignatedApplication;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLinkId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  parentId?: Maybe<Scalars['ID']>;
  platform: ScreenPlatform;
};

export type ScreenCreateOutput = InternalToolPermissionDeniedError | ScreenCreateErrorResponse | ScreenCreateSuccessResponse;

export type ScreenCreateSuccessResponse = {
  __typename?: 'ScreenCreateSuccessResponse';
  screen?: Maybe<GenericScreenNode>;
};

export type ScreenDeleteErrorResponse = {
  __typename?: 'ScreenDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ScreenDeleteInput = {
  id: Scalars['ID'];
};

export type ScreenDeleteOutput = InternalToolPermissionDeniedError | ScreenDeleteErrorResponse | ScreenDeleteSuccessResponse;

export type ScreenDeleteSuccessResponse = {
  __typename?: 'ScreenDeleteSuccessResponse';
  screen?: Maybe<GenericScreenNode>;
};

export enum ScreenDesignatedApplication {
  HrAdmin = 'HR_ADMIN',
  Member = 'MEMBER'
}

export type ScreenLinkNode = Node & {
  __typename?: 'ScreenLinkNode';
  banner?: Maybe<ContentBannerNode>;
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['Int']>;
  mediaType?: Maybe<MediaTypeNode>;
  mobileValue?: Maybe<Scalars['String']>;
  screen: ScreenNode;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  uuid: Scalars['UUID'];
  value?: Maybe<Scalars['String']>;
  webValue?: Maybe<Scalars['String']>;
};

export type ScreenNode = ContentTagListScreenNode | ContentTagScreenNode | CoursesScreenNode | DataDefinedScreenNode | ExploreCareOptionsScreenNode | ExploreScreenNode | ForYouScreenNode | HomeScreenNode | ManageCareTeamScreenNode | MeditationsScreenNode | ProgramsScreenNode | RecommendedScreenNode | ResourcesScreenNode | WellbeingReportScreenNode;

export type ScreenNodeInterface = {
  description?: Maybe<Scalars['String']>;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  uuid: Scalars['UUID'];
};

export enum ScreenPlatform {
  Dhcs = 'DHCS',
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type ScreenSectionCreateErrorResponse = {
  __typename?: 'ScreenSectionCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ScreenSectionCreateInput = {
  collectionId: Scalars['ID'];
  ctaLinkId?: Maybe<Scalars['ID']>;
  ctaLinkText?: Maybe<Scalars['String']>;
  englishLanguageVisibility?: Maybe<EnglishLanguageVisibility>;
  maxContent?: Maybe<Scalars['Int']>;
  minContent?: Maybe<Scalars['Int']>;
  minimumMobileVersion?: Maybe<Scalars['String']>;
  renderComponent?: Maybe<ContentCollectionRenderComponent>;
  screenId: Scalars['ID'];
  showTitle?: Maybe<Scalars['Boolean']>;
};

export type ScreenSectionCreateOutput = InternalToolPermissionDeniedError | ScreenSectionCreateErrorResponse | ScreenSectionCreateSuccessResponse;

export type ScreenSectionCreateSuccessResponse = {
  __typename?: 'ScreenSectionCreateSuccessResponse';
  screenSection?: Maybe<DataDefinedScreenSectionNode>;
};

export type ScreenSectionDeleteErrorResponse = {
  __typename?: 'ScreenSectionDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ScreenSectionDeleteInput = {
  id: Scalars['ID'];
};

export type ScreenSectionDeleteOutput = InternalToolPermissionDeniedError | ScreenSectionDeleteErrorResponse | ScreenSectionDeleteSuccessResponse;

export type ScreenSectionDeleteSuccessResponse = {
  __typename?: 'ScreenSectionDeleteSuccessResponse';
  screenSection?: Maybe<DataDefinedScreenSectionNode>;
};

export type ScreenSectionNode = Node & {
  __typename?: 'ScreenSectionNode';
  collection?: Maybe<ContentCollectionNode>;
  contentCollectionLinks: Array<ContentLinkNode>;
  ctaContentLink?: Maybe<ContentCollectionLinkNode>;
  ctaLink?: Maybe<ContentLinkNode>;
  ctaLinkText?: Maybe<Scalars['String']>;
  ctaLinkTextTranslationKey?: Maybe<Scalars['String']>;
  englishLanguageVisibility?: Maybe<EnglishLanguageVisibility>;
  id: Scalars['ID'];
  index: Scalars['Int'];
  maxContent?: Maybe<Scalars['Int']>;
  minContent: Scalars['Int'];
  minimumMobileVersion: Scalars['String'];
  renderComponent?: Maybe<ContentCollectionRenderComponent>;
  slug?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  subtitleTranslationKey?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  titleTranslationKey: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type ScreenSectionUpdateErrorResponse = {
  __typename?: 'ScreenSectionUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ScreenSectionUpdateInput = {
  collectionId: Scalars['ID'];
  ctaLinkId?: Maybe<Scalars['ID']>;
  ctaLinkText?: Maybe<Scalars['String']>;
  englishLanguageVisibility?: Maybe<EnglishLanguageVisibility>;
  id: Scalars['ID'];
  maxContent: Scalars['Int'];
  minContent?: Maybe<Scalars['Int']>;
  minimumMobileVersion: Scalars['String'];
  moveDownInIndex?: Maybe<Scalars['Boolean']>;
  moveUpInIndex?: Maybe<Scalars['Boolean']>;
  renderComponent?: Maybe<ContentCollectionRenderComponent>;
  showTitle?: Maybe<Scalars['Boolean']>;
};

export type ScreenSectionUpdateOutput = InternalToolPermissionDeniedError | ScreenSectionUpdateErrorResponse | ScreenSectionUpdateSuccessResponse;

export type ScreenSectionUpdateSuccessResponse = {
  __typename?: 'ScreenSectionUpdateSuccessResponse';
  screenSection?: Maybe<DataDefinedScreenSectionNode>;
};

export type ScreenUpdateErrorResponse = {
  __typename?: 'ScreenUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type ScreenUpdateInput = {
  description?: Maybe<Scalars['String']>;
  designatedApplication: ScreenDesignatedApplication;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLinkId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parentId?: Maybe<Scalars['ID']>;
  platform: ScreenPlatform;
};

export type ScreenUpdateOutput = InternalToolPermissionDeniedError | ScreenUpdateErrorResponse | ScreenUpdateSuccessResponse;

export type ScreenUpdateSuccessResponse = {
  __typename?: 'ScreenUpdateSuccessResponse';
  screen?: Maybe<GenericScreenNode>;
};

export type SearchGlobalResultsResponse = SearchResponseEmptyResults | SearchResponseResults;

export type SearchResponseEmptyResults = {
  __typename?: 'SearchResponseEmptyResults';
  otherResults: Array<ScreenSectionNode>;
  searchText: Scalars['String'];
};

export type SearchResponseResults = {
  __typename?: 'SearchResponseResults';
  results: Array<ScreenSectionNode>;
  searchText: Scalars['String'];
};

export type SectionDoesNotExist = {
  __typename?: 'SectionDoesNotExist';
  id?: Maybe<Scalars['String']>;
};

export type SelectDifficultyMutation = {
  __typename?: 'SelectDifficultyMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type SelectModalityMutation = {
  __typename?: 'SelectModalityMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type SelectPrimaryFocusMutation = {
  __typename?: 'SelectPrimaryFocusMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SelectTopicsOfFocusMutation = {
  __typename?: 'SelectTopicsOfFocusMutation';
  topicSelections?: Maybe<Array<Maybe<TopicSelectionNode>>>;
};

export type SendMemberEmailReminderMutation = {
  __typename?: 'SendMemberEmailReminderMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SendMemberExtendTherapyEmailReminderMutation = {
  __typename?: 'SendMemberExtendTherapyEmailReminderMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type ServerSideAssessmentError = BaseSurveyError & {
  __typename?: 'ServerSideAssessmentError';
  debug: Scalars['String'];
  message: Scalars['String'];
};

export enum ServiceType {
  Psychiatry = 'PSYCHIATRY',
  Therapy = 'THERAPY'
}

export type SignUpTokenDetailsNode = {
  __typename?: 'SignUpTokenDetailsNode';
  expiresAt: Scalars['DateTime'];
  token: Scalars['String'];
};

export type StartAssessmentFlowMutation = {
  __typename?: 'StartAssessmentFlowMutation';
  assessmentFlow: AssessmentFlowNode;
  nextAssessments: Array<Maybe<AssessmentKey>>;
};

export type StartAssessmentJourneyInput = {
  journeyConfigKeyUuid: Scalars['UUID'];
  metadata?: Maybe<StartAssessmentJourneyMetadata>;
};

export type StartAssessmentJourneyMetadata = {
  creationSource?: Maybe<AssessmentJourneyCreationSource>;
};

export type StartAssessmentJourneyResult = InvalidArgumentError | SuccessfulAssessmentJourneyCreationPayload;

export type StartCareRecommendationMutation = {
  __typename?: 'StartCareRecommendationMutation';
  careRecommendation?: Maybe<CareRecommendationNode>;
};

export type StartMemberPathwayMutationInput = {
  pathwayUuid: Scalars['UUID'];
};

export type StartMemberPathwayMutationResponse = {
  __typename?: 'StartMemberPathwayMutationResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SubmitAssessmentResponseOutput = ContentSubmissionError | InvalidArgumentError | ServerSideAssessmentError | SuccessfulJourneySubmissionPayload;

export type SubmitAssessmentResultInput = {
  assessmentJourneyUuid: Scalars['UUID'];
  content: Scalars['JSONString'];
};

export type SubmitAssessmentsMutation = {
  __typename?: 'SubmitAssessmentsMutation';
  assessment?: Maybe<AssessmentNode>;
  createdContentResponses?: Maybe<Array<Maybe<ContentResponsesNode>>>;
  score?: Maybe<Scalars['Int']>;
};

export type SubmitCourseSectionReviewOutput = CourseSectionDoesNotExist | CourseSectionReviewResponse;

export type SubmitFeatureRecordReviewOutput = FeatureInvalidFeedbackChoice | FeatureRecordDoesNotExist | FeatureRecordReviewResponse;

export type SubmitModularizedAssessmentInput = {
  assessmentFlowUuid: Scalars['UUID'];
  careRecommendationUuid?: Maybe<Scalars['UUID']>;
  content: Scalars['JSONString'];
};

export type SubmitModularizedAssessmentsResult = ContentSubmissionError | InvalidArgumentError | SuccessfulSubmissionPayload;

export type SubmitNpsMutation = {
  __typename?: 'SubmitNpsMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SubmitPathwayAssessmentMutationInput = {
  answers: Scalars['JSONString'];
  pathwayUuid: Scalars['UUID'];
};

export type SubmitPathwayAssessmentMutationOutput = PathwayAssessmentInvalid | PathwayAssessmentSubmitted | PathwayDoesNotExist;

export type SubmitPathwayReviewOutput = PathwayDoesNotExist | SubmitPathwayReviewResponse;

export type SubmitPathwayReviewResponse = {
  __typename?: 'SubmitPathwayReviewResponse';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SubtopicOfFocusDoesNotExist = {
  __typename?: 'SubtopicOfFocusDoesNotExist';
  uuid?: Maybe<Scalars['UUID']>;
};

export type SubtopicOfFocusInput = {
  isPrimarySubtopic: Scalars['Boolean'];
  subtopicId: Scalars['ID'];
};

export type SubtopicOfFocusNode = {
  __typename?: 'SubtopicOfFocusNode';
  isActive: Scalars['Boolean'];
  isClinical: Scalars['Boolean'];
  name: Scalars['String'];
  nameDe?: Maybe<Scalars['String']>;
  nameEnUs?: Maybe<Scalars['String']>;
  nameEs?: Maybe<Scalars['String']>;
  nameFr?: Maybe<Scalars['String']>;
  nameFrCa?: Maybe<Scalars['String']>;
  nameHi?: Maybe<Scalars['String']>;
  nameJa?: Maybe<Scalars['String']>;
  nameKo?: Maybe<Scalars['String']>;
  namePt?: Maybe<Scalars['String']>;
  nameZhHans?: Maybe<Scalars['String']>;
  subtopicSymptoms: Array<SubtopicOfFocusSymptomNode>;
  symptoms: Array<Scalars['String']>;
  topicOfFocus: TopicOfFocusNode;
  uuid: Scalars['UUID'];
};

export type SubtopicOfFocusSymptomNode = {
  __typename?: 'SubtopicOfFocusSymptomNode';
  displayOrder: Scalars['Int'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  nameDe?: Maybe<Scalars['String']>;
  nameEnUs?: Maybe<Scalars['String']>;
  nameEs?: Maybe<Scalars['String']>;
  nameFr?: Maybe<Scalars['String']>;
  nameFrCa?: Maybe<Scalars['String']>;
  nameHi?: Maybe<Scalars['String']>;
  nameJa?: Maybe<Scalars['String']>;
  nameKo?: Maybe<Scalars['String']>;
  namePt?: Maybe<Scalars['String']>;
  nameZhHans?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
};

export type SubtopicSelectionNode = {
  __typename?: 'SubtopicSelectionNode';
  createdAt: Scalars['DateTime'];
  subtopicOfFocus: SubtopicOfFocusNode;
  symptomsExperienced: Array<Scalars['String']>;
  topicSelection: TopicSelectionNode;
  uuid: Scalars['UUID'];
};

export type SubtopicSymptomsInput = {
  symptomsUuids: Array<Maybe<Scalars['UUID']>>;
};

export type SuccessfulAssessmentJourneyCreationPayload = {
  __typename?: 'SuccessfulAssessmentJourneyCreationPayload';
  assessmentJourney: AssessmentJourneyNode;
  nextAssessments: Array<Maybe<AssessmentKey>>;
};

export type SuccessfulJourneySubmissionPayload = {
  __typename?: 'SuccessfulJourneySubmissionPayload';
  nextAssessments: Array<Maybe<AssessmentKey>>;
  submittedAssessment: AssessmentNode;
};

export type SuccessfulSubmissionPayload = {
  __typename?: 'SuccessfulSubmissionPayload';
  createdContentResponses: Array<ContentResponsesNode>;
  nextAssessments: Array<Maybe<AssessmentKey>>;
  submittedAssessment: AssessmentNode;
};

export type SyncUuidsSuccessResponse = {
  __typename?: 'SyncUuidsSuccessResponse';
  ok: Scalars['Boolean'];
};

export type TestMemberNode = {
  __typename?: 'TestMemberNode';
  company?: Maybe<CompanyDropdownNode>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
};

export type TestProviderNode = {
  __typename?: 'TestProviderNode';
  company?: Maybe<CompanyDropdownNode>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  uuid: Scalars['UUID'];
};

export type TextTrackTranslationCreateErrorResponse = {
  __typename?: 'TextTrackTranslationCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type TextTrackTranslationCreateInput = {
  contentLanguage?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  textTrack: Scalars['String'];
  videoContentUuid?: Maybe<Scalars['ID']>;
};

export type TextTrackTranslationCreateOutput = InternalToolPermissionDeniedError | TextTrackTranslationCreateErrorResponse | TextTrackTranslationCreateSuccessResponse;

export type TextTrackTranslationCreateSuccessResponse = {
  __typename?: 'TextTrackTranslationCreateSuccessResponse';
  textTrackTranslation?: Maybe<TextTrackTranslationNode>;
};

export type TextTrackTranslationDeleteErrorResponse = {
  __typename?: 'TextTrackTranslationDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type TextTrackTranslationDeleteInput = {
  id: Scalars['ID'];
};

export type TextTrackTranslationDeleteOutput = InternalToolPermissionDeniedError | TextTrackTranslationDeleteErrorResponse | TextTrackTranslationDeleteSuccessResponse;

export type TextTrackTranslationDeleteSuccessResponse = {
  __typename?: 'TextTrackTranslationDeleteSuccessResponse';
  textTrackTranslation?: Maybe<TextTrackTranslationNode>;
};

export type TextTrackTranslationNode = Node & {
  __typename?: 'TextTrackTranslationNode';
  contentLanguage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  textTrack: Scalars['String'];
  uuid: Scalars['UUID'];
  videoContent: VideoContentNode;
};

export type TextTrackTranslationNodeConnection = {
  __typename?: 'TextTrackTranslationNodeConnection';
  edges: Array<Maybe<TextTrackTranslationNodeEdge>>;
  pageInfo: PageInfo;
};

export type TextTrackTranslationNodeEdge = {
  __typename?: 'TextTrackTranslationNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<TextTrackTranslationNode>;
};

export type TextTrackTranslationUpdateErrorResponse = {
  __typename?: 'TextTrackTranslationUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type TextTrackTranslationUpdateInput = {
  contentLanguage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label: Scalars['String'];
  textTrack: Scalars['String'];
};

export type TextTrackTranslationUpdateOutput = InternalToolPermissionDeniedError | TextTrackTranslationUpdateErrorResponse | TextTrackTranslationUpdateSuccessResponse;

export type TextTrackTranslationUpdateSuccessResponse = {
  __typename?: 'TextTrackTranslationUpdateSuccessResponse';
  textTrackTranslation?: Maybe<TextTrackTranslationNode>;
};

export type TimeToCareLabelMutation = {
  __typename?: 'TimeToCareLabelMutation';
  providersWithTtcLabels?: Maybe<Array<Maybe<ProviderLabelNode>>>;
};

export type TimezoneNode = {
  __typename?: 'TimezoneNode';
  commonName?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  locality?: Maybe<Scalars['String']>;
  properName: Scalars['String'];
  utcOffset: Scalars['Float'];
  utcOffsetFormatted: Scalars['String'];
};

export type TopicInput = {
  subtopicUuids?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  topicUuid: Scalars['UUID'];
};

export type TopicOfFocusNode = {
  __typename?: 'TopicOfFocusNode';
  alias?: Maybe<Scalars['String']>;
  benefitColor?: Maybe<Scalars['String']>;
  benefitImage?: Maybe<Scalars['String']>;
  benefits: Array<CompanyAdditionalBenefitNode>;
  displayOrder: Scalars['Int'];
  image: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  nameDe?: Maybe<Scalars['String']>;
  nameEnUs?: Maybe<Scalars['String']>;
  nameEs?: Maybe<Scalars['String']>;
  nameFr?: Maybe<Scalars['String']>;
  nameFrCa?: Maybe<Scalars['String']>;
  nameHi?: Maybe<Scalars['String']>;
  nameJa?: Maybe<Scalars['String']>;
  nameKo?: Maybe<Scalars['String']>;
  namePt?: Maybe<Scalars['String']>;
  nameZhHans?: Maybe<Scalars['String']>;
  subtopicsOfFocus: Array<SubtopicOfFocusNode>;
  uuid: Scalars['UUID'];
};

export type TopicSelectionGroupNode = {
  __typename?: 'TopicSelectionGroupNode';
  createdAt: Scalars['DateTime'];
  hasAtLeastOneClinicalSubtopicOfFocus?: Maybe<Scalars['Boolean']>;
  selectionType?: Maybe<TopicSelectionGroupSelectionType>;
  subtopicSelections: Array<SubtopicSelectionNode>;
  uuid: Scalars['UUID'];
};

export enum TopicSelectionGroupSelectionType {
  AddProvider = 'ADD_PROVIDER',
  ChangeProvider = 'CHANGE_PROVIDER',
  DjangoAdminPage = 'DJANGO_ADMIN_PAGE',
  OnboardingFlow = 'ONBOARDING_FLOW',
  ProfileSettings = 'PROFILE_SETTINGS',
  WellbeingReport = 'WELLBEING_REPORT'
}

export type TopicSelectionNode = {
  __typename?: 'TopicSelectionNode';
  careRecommendation?: Maybe<CareRecommendationNode>;
  subtopicSelections: Array<SubtopicSelectionNode>;
  topicOfFocus: TopicOfFocusNode;
  uuid: Scalars['UUID'];
};

export type TopicSelectionTypeInvalid = {
  __typename?: 'TopicSelectionTypeInvalid';
  message?: Maybe<Scalars['String']>;
};

export type TransactionNode = {
  __typename?: 'TransactionNode';
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
  responsibleParty: TransactionResponsibleParty;
  source: TransactionSource;
  type: TransactionType;
};

export enum TransactionResponsibleParty {
  Insurance = 'INSURANCE',
  Ops = 'OPS',
  Payer = 'PAYER',
  User = 'USER'
}

export enum TransactionSource {
  Instamed = 'INSTAMED',
  Insurance = 'INSURANCE',
  PaymentChargedEvent = 'PAYMENT_CHARGED_EVENT'
}

export enum TransactionType {
  Authorization = 'AUTHORIZATION',
  Charge = 'CHARGE',
  Chargeback = 'CHARGEBACK',
  Payment = 'PAYMENT',
  PaymentDeclined = 'PAYMENT_DECLINED',
  PaymentVoided = 'PAYMENT_VOIDED',
  PendingRefund = 'PENDING_REFUND',
  Refund = 'REFUND',
  RefundDeclined = 'REFUND_DECLINED',
  RefundVoided = 'REFUND_VOIDED'
}

export type TranslationCollectionNode = {
  __typename?: 'TranslationCollectionNode';
  name: Scalars['String'];
  translations?: Maybe<Array<TranslationNode>>;
  uuid: Scalars['UUID'];
};

export type TranslationKeyNode = {
  __typename?: 'TranslationKeyNode';
  defaultTranslation: Scalars['String'];
  key: Scalars['String'];
  translations?: Maybe<Array<TranslationNode>>;
  uuid: Scalars['UUID'];
};

export type TranslationNode = {
  __typename?: 'TranslationNode';
  collections: Array<TranslationCollectionNode>;
  language: LanguageNode;
  translatedText: Scalars['String'];
  translationKey: TranslationKeyNode;
  uuid: Scalars['UUID'];
};

export type TreatmentCycleNode = {
  __typename?: 'TreatmentCycleNode';
  treatmentState: TreatmentState;
};

export enum TreatmentState {
  Completed = 'COMPLETED',
  Expired = 'EXPIRED',
  Mid = 'MID',
  Started = 'STARTED'
}


export type UnavailableReportType = {
  __typename?: 'UnavailableReportType';
  iconUrl?: Maybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  mainMessage: Scalars['String'];
  reportOrSectionEnum: Scalars['String'];
  subMessage?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UnavailableSectionType = {
  __typename?: 'UnavailableSectionType';
  imageUrl: Scalars['String'];
  mainMessage: Scalars['String'];
  reportOrSectionEnum: Scalars['String'];
  subMessage?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type UnknownCompanyError = BaseError & {
  __typename?: 'UnknownCompanyError';
  debug?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type UnknownHrAdminError = BaseError & {
  __typename?: 'UnknownHRAdminError';
  debug?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type UnknownReportTypeError = BaseError & {
  __typename?: 'UnknownReportTypeError';
  debug?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type UnknownUserError = BaseError & {
  __typename?: 'UnknownUserError';
  debug?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type UpdateAccountSharedPreferencesMutation = {
  __typename?: 'UpdateAccountSharedPreferencesMutation';
  sharedPreferencesRecord?: Maybe<AccountSharedPreferencesRecordNode>;
};

export type UpdateAvailableHoursMutation = {
  __typename?: 'UpdateAvailableHoursMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateCalendarMutation = {
  __typename?: 'UpdateCalendarMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateClientBucketInput = {
  automated?: Maybe<Scalars['Boolean']>;
  bucketName?: Maybe<Scalars['String']>;
  companyFolder?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  notifyAccountUuid?: Maybe<Scalars['UUID']>;
};

export type UpdateClientBucketResponse = {
  __typename?: 'UpdateClientBucketResponse';
  clientBucket?: Maybe<ClientBucketNode>;
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UpdateCoachingVisitMutation = {
  __typename?: 'UpdateCoachingVisitMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateConversationMutation = {
  __typename?: 'UpdateConversationMutation';
  conversation?: Maybe<ConversationNode>;
};

export type UpdateCourseHeroMutationErrorResponse = {
  __typename?: 'UpdateCourseHeroMutationErrorResponse';
  message: Scalars['String'];
};

export type UpdateCourseHeroMutationInput = {
  backgroundColor?: Maybe<Scalars['String']>;
  courseId: Scalars['ID'];
  imageAltText?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  videoPoster?: Maybe<Scalars['String']>;
  videoSourceHorizontal?: Maybe<Scalars['String']>;
  videoSourceVertical?: Maybe<Scalars['String']>;
  videoTextTrack?: Maybe<Scalars['String']>;
  videoTitle?: Maybe<Scalars['String']>;
};

export type UpdateCourseHeroMutationOutput = UpdateCourseHeroMutationErrorResponse | UpdateCourseHeroMutationSuccessResponse;

export type UpdateCourseHeroMutationSuccessResponse = {
  __typename?: 'UpdateCourseHeroMutationSuccessResponse';
  hero?: Maybe<CourseHeroNode>;
};

export type UpdateIntakeFormMutation = {
  __typename?: 'UpdateIntakeFormMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type UpdateMemberProfileMutation = {
  __typename?: 'UpdateMemberProfileMutation';
  member?: Maybe<MemberNode>;
};

export type UpdateMessageMutation = {
  __typename?: 'UpdateMessageMutation';
  error?: Maybe<Scalars['String']>;
  message?: Maybe<MessageNode>;
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateNameInput = {
  newName: Scalars['String'];
  personUuid: Scalars['UUID'];
};

export type UpdateNameResponse = {
  __typename?: 'UpdateNameResponse';
  newPerson?: Maybe<PersonNode>;
  ok: Scalars['Boolean'];
};

export type UpdateNotificationPreferencesMutation = {
  __typename?: 'UpdateNotificationPreferencesMutation';
  notificationPreferences?: Maybe<NotificationPreferencesNode>;
};

export type UpdatePatientIntakeFormInput = {
  intakeFormAnswers?: Maybe<Array<Maybe<IntakeFormAnswerInput>>>;
  providerMatchUuid: Scalars['UUID'];
};

export type UpdateProviderProfileResponse = {
  __typename?: 'UpdateProviderProfileResponse';
  ok?: Maybe<Scalars['Boolean']>;
  updatedProvider?: Maybe<CoachNode>;
};

export type UpdateProviderReview = {
  __typename?: 'UpdateProviderReview';
  ok?: Maybe<Scalars['Boolean']>;
};

export type UpdateVisitMutation = {
  __typename?: 'UpdateVisitMutation';
  ok?: Maybe<Scalars['Boolean']>;
};


export type UploadCsvResponse = {
  __typename?: 'UploadCsvResponse';
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};

export type UserFeatureInput = {
  subtopicsOfFocus: Array<SubtopicOfFocusInput>;
};

export type UserFocusFeatureInput = {
  subtopicsOfFocus: Array<UserSubtopicOfFocusInput>;
};

export type UserInput = {
  __typename?: 'UserInput';
  optionValue?: Maybe<Scalars['String']>;
  textValue?: Maybe<Scalars['String']>;
};

export type UserSubtopicOfFocusInput = {
  isPrimarySubtopic: Scalars['Boolean'];
  subtopicId: Scalars['ID'];
  topicId: Scalars['ID'];
};

export type UuidSpecificationInput = {
  naturalKey: Scalars['String'];
  objectType: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type ValidatePendingCoachingVisitMutation = {
  __typename?: 'ValidatePendingCoachingVisitMutation';
  costEstimation?: Maybe<CostEstimation>;
  ok?: Maybe<Scalars['Boolean']>;
  patientResponsibility?: Maybe<Scalars['Float']>;
  sessionState?: Maybe<Scalars['String']>;
};

export type VideoContentCreateErrorResponse = {
  __typename?: 'VideoContentCreateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type VideoContentCreateInput = {
  poster?: Maybe<Scalars['String']>;
  sourceHorizontal: Scalars['String'];
  sourceVertical: Scalars['String'];
  textTrack?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type VideoContentCreateOutput = InternalToolPermissionDeniedError | VideoContentCreateErrorResponse | VideoContentCreateSuccessResponse;

export type VideoContentCreateSuccessResponse = {
  __typename?: 'VideoContentCreateSuccessResponse';
  videoContent?: Maybe<VideoContentNode>;
};

export type VideoContentDeleteErrorResponse = {
  __typename?: 'VideoContentDeleteErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type VideoContentDeleteInput = {
  id: Scalars['ID'];
};

export type VideoContentDeleteOutput = InternalToolPermissionDeniedError | VideoContentDeleteErrorResponse | VideoContentDeleteSuccessResponse;

export type VideoContentDeleteSuccessResponse = {
  __typename?: 'VideoContentDeleteSuccessResponse';
  videoContent?: Maybe<VideoContentNode>;
};

export type VideoContentNode = Node & {
  __typename?: 'VideoContentNode';
  id: Scalars['ID'];
  mediaType?: Maybe<MediaTypeNode>;
  poster?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  sourceHorizontal: Scalars['String'];
  sourceVertical: Scalars['String'];
  textTrack?: Maybe<Scalars['String']>;
  textTrackTranslation?: Maybe<TextTrackTranslationNode>;
  title: Scalars['String'];
  uuid: Scalars['UUID'];
};

export type VideoContentNodeConnection = {
  __typename?: 'VideoContentNodeConnection';
  edges: Array<Maybe<VideoContentNodeEdge>>;
  pageInfo: PageInfo;
};

export type VideoContentNodeEdge = {
  __typename?: 'VideoContentNodeEdge';
  cursor: Scalars['String'];
  node?: Maybe<VideoContentNode>;
};

export type VideoContentUpdateErrorResponse = {
  __typename?: 'VideoContentUpdateErrorResponse';
  error?: Maybe<Scalars['String']>;
};

export type VideoContentUpdateInput = {
  id: Scalars['ID'];
  poster?: Maybe<Scalars['String']>;
  sourceHorizontal: Scalars['String'];
  sourceVertical: Scalars['String'];
  textTrack?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type VideoContentUpdateOutput = InternalToolPermissionDeniedError | VideoContentUpdateErrorResponse | VideoContentUpdateSuccessResponse;

export type VideoContentUpdateSuccessResponse = {
  __typename?: 'VideoContentUpdateSuccessResponse';
  videoContent?: Maybe<VideoContentNode>;
};

export type VideoSessionNode = {
  __typename?: 'VideoSessionNode';
  apiKey?: Maybe<Scalars['String']>;
  coachingVisit?: Maybe<CoachingVisitNode>;
  sessionId?: Maybe<Scalars['String']>;
  sessionToken?: Maybe<Scalars['String']>;
};

export type VisitRateNode = {
  __typename?: 'VisitRateNode';
  productType: ProductType;
  rate: Scalars['Float'];
};

export type VisitsRemainingNode = {
  __typename?: 'VisitsRemainingNode';
  coachingVisitsRemaining?: Maybe<Scalars['Int']>;
  therapyVisitsRemaining?: Maybe<Scalars['Int']>;
};

export type WellBeingReportNode = {
  __typename?: 'WellBeingReportNode';
  data: Array<ReportDataPoint>;
  metadata: ReportMetadata;
};

export enum WellbeingReportMessages {
  EncourageAssessmentRetakeMessage = 'ENCOURAGE_ASSESSMENT_RETAKE_MESSAGE'
}

export type WellbeingReportMonitoringMessageResult = {
  __typename?: 'WellbeingReportMonitoringMessageResult';
  messageType?: Maybe<WellbeingReportMessages>;
};

export type WellbeingReportScreenNode = ScreenNodeInterface & {
  __typename?: 'WellbeingReportScreenNode';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  designatedApplication: ScreenDesignatedApplication;
  heroSectionImage?: Maybe<Scalars['String']>;
  heroSectionLink?: Maybe<ContentLinkNode>;
  /** @deprecated Functionality change */
  icon?: Maybe<Scalars['String']>;
  /** @deprecated Functionality change */
  iconLabel?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  parent?: Maybe<GenericScreenNode>;
  platform: ScreenPlatform;
  screenSections: Array<ScreenSectionNode>;
  slug: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};

export type Who5SurveyNode = {
  __typename?: 'Who5SurveyNode';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  owner: MemberNode;
  score?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  who5Activevigorous: Scalars['Int'];
  who5Althoughsick?: Maybe<Scalars['Int']>;
  who5Burnedout?: Maybe<Scalars['Int']>;
  who5Calmrelaxed: Scalars['Int'];
  who5Freshrested: Scalars['Int'];
  who5Goodspirits: Scalars['Int'];
  who5Interestme: Scalars['Int'];
  who5Recommendcompany?: Maybe<Scalars['Int']>;
  who5Stickness?: Maybe<Scalars['Int']>;
};

export type CreateOrUpdatePayerInformationResponse = {
  __typename?: 'createOrUpdatePayerInformationResponse';
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
  payerInformation?: Maybe<PayerInformationNode>;
};

export type CreateSamlPostPageResponse = {
  __typename?: 'createSAMLPostPageResponse';
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
  samlPage?: Maybe<Scalars['String']>;
};

export type UpdateAutoPaymentEnrollmentResponse = {
  __typename?: 'updateAutoPaymentEnrollmentResponse';
  enrolledInAutoPayments?: Maybe<Scalars['Boolean']>;
  error?: Maybe<Scalars['String']>;
  ok: Scalars['Boolean'];
};
